import { c as Ze, g as Mo } from "./main-zRUwk2ge.mjs";
import { _ as Ha } from "./pdf-DOHeHzrp.mjs";
var ft = function(a) {
  return a && a.Math === Math && a;
}, V = (
  // eslint-disable-next-line es/no-global-this -- safe
  ft(typeof globalThis == "object" && globalThis) || ft(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  ft(typeof self == "object" && self) || ft(typeof Ze == "object" && Ze) || ft(typeof Ze == "object" && Ze) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")()
);
var St = {}, k = function(a) {
  try {
    return !!a();
  } catch {
    return !0;
  }
};
var El = k, le = !El(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
});
var Sl = k, xr = !Sl(function() {
  var a = (function() {
  }).bind();
  return typeof a != "function" || a.hasOwnProperty("prototype");
});
var wl = xr, zt = Function.prototype.call, Y = wl ? zt.bind(zt) : function() {
  return zt.apply(zt, arguments);
};
var _o = {}, Do = {}.propertyIsEnumerable, Vo = Object.getOwnPropertyDescriptor, Cl = Vo && !Do.call({ 1: 2 }, 1), y2 = _o.f = Cl ? function(e) {
  var t = Vo(this, e);
  return !!t && t.enumerable;
} : Do, Ti = function(a, e) {
  return {
    enumerable: !(a & 1),
    configurable: !(a & 2),
    writable: !(a & 4),
    value: e
  };
};
var ko = xr, Lo = Function.prototype, Ya = Lo.call, Pl = ko && Lo.bind.bind(Ya, Ya), L = ko ? Pl : function(a) {
  return function() {
    return Ya.apply(a, arguments);
  };
};
var Bo = L, Al = Bo({}.toString), Rl = Bo("".slice), je = function(a) {
  return Rl(Al(a), 8, -1);
};
var Il = L, Nl = k, Ml = je, Qr = Object, _l = Il("".split), jo = Nl(function() {
  return !Qr("z").propertyIsEnumerable(0);
}) ? function(a) {
  return Ml(a) === "String" ? _l(a, "") : Qr(a);
} : Qr;
var Ue = function(a) {
  return a == null;
};
var Dl = Ue, Vl = TypeError, ge = function(a) {
  if (Dl(a))
    throw new Vl("Can't call method on " + a);
  return a;
};
var kl = jo, Ll = ge, wt = function(a) {
  return kl(Ll(a));
};
var Zr = typeof document == "object" && document.all, B = typeof Zr > "u" && Zr !== void 0 ? function(a) {
  return typeof a == "function" || a === Zr;
} : function(a) {
  return typeof a == "function";
};
var Bl = B, de = function(a) {
  return typeof a == "object" ? a !== null : Bl(a);
};
var Jr = V, jl = B, Ul = function(a) {
  return jl(a) ? a : void 0;
}, Fe = function(a, e) {
  return arguments.length < 2 ? Ul(Jr[a]) : Jr[a] && Jr[a][e];
};
var Fl = L, $r = Fl({}.isPrototypeOf);
var Tr = typeof navigator < "u" && String(navigator.userAgent) || "";
var Uo = V, ea = Tr, yn = Uo.process, mn = Uo.Deno, bn = yn && yn.versions || mn && mn.version, xn = bn && bn.v8, ue, gr;
xn && (ue = xn.split("."), gr = ue[0] > 0 && ue[0] < 4 ? 1 : +(ue[0] + ue[1]));
!gr && ea && (ue = ea.match(/Edge\/(\d+)/), (!ue || ue[1] >= 74) && (ue = ea.match(/Chrome\/(\d+)/), ue && (gr = +ue[1])));
var Oi = gr;
var $n = Oi, Gl = k, zl = V, Hl = zl.String, Fo = !!Object.getOwnPropertySymbols && !Gl(function() {
  var a = Symbol("symbol detection");
  return !Hl(a) || !(Object(a) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && $n && $n < 41;
});
var Yl = Fo, Go = Yl && !Symbol.sham && typeof Symbol.iterator == "symbol";
var Wl = Fe, Xl = B, ql = $r, Kl = Go, Ql = Object, zo = Kl ? function(a) {
  return typeof a == "symbol";
} : function(a) {
  var e = Wl("Symbol");
  return Xl(e) && ql(e.prototype, Ql(a));
};
var Zl = String, Or = function(a) {
  try {
    return Zl(a);
  } catch {
    return "Object";
  }
};
var Jl = B, ec = Or, tc = TypeError, Oe = function(a) {
  if (Jl(a))
    return a;
  throw new tc(ec(a) + " is not a function");
};
var rc = Oe, ac = Ue, lt = function(a, e) {
  var t = a[e];
  return ac(t) ? void 0 : rc(t);
};
var ta = Y, ra = B, aa = de, ic = TypeError, nc = function(a, e) {
  var t, r;
  if (e === "string" && ra(t = a.toString) && !aa(r = ta(t, a)) || ra(t = a.valueOf) && !aa(r = ta(t, a)) || e !== "string" && ra(t = a.toString) && !aa(r = ta(t, a)))
    return r;
  throw new ic("Can't convert object to primitive value");
};
var Ei = { exports: {} }, pe = !1;
var Tn = V, sc = Object.defineProperty, Si = function(a, e) {
  try {
    sc(Tn, a, { value: e, configurable: !0, writable: !0 });
  } catch {
    Tn[a] = e;
  }
  return e;
};
var oc = V, uc = Si, On = "__core-js_shared__", lc = oc[On] || uc(On, {}), wi = lc;
var m2 = Ei.exports, cc = pe, En = wi;
(Ei.exports = function(a, e) {
  return En[a] || (En[a] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.35.1",
  mode: cc ? "pure" : "global",
  copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.35.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var Ci = Ei.exports;
var hc = ge, vc = Object, Er = function(a) {
  return vc(hc(a));
};
var fc = L, gc = Er, dc = fc({}.hasOwnProperty), ce = Object.hasOwn || function(e, t) {
  return dc(gc(e), t);
};
var pc = L, yc = 0, mc = Math.random(), bc = pc(1 .toString), Ho = function(a) {
  return "Symbol(" + (a === void 0 ? "" : a) + ")_" + bc(++yc + mc, 36);
};
var xc = V, $c = Ci, Sn = ce, Tc = Ho, Oc = Fo, Ec = Go, Je = xc.Symbol, ia = $c("wks"), Sc = Ec ? Je.for || Je : Je && Je.withoutSetter || Tc, z = function(a) {
  return Sn(ia, a) || (ia[a] = Oc && Sn(Je, a) ? Je[a] : Sc("Symbol." + a)), ia[a];
};
var wc = Y, wn = de, Cn = zo, Cc = lt, Pc = nc, Ac = z, Rc = TypeError, Ic = Ac("toPrimitive"), Nc = function(a, e) {
  if (!wn(a) || Cn(a))
    return a;
  var t = Cc(a, Ic), r;
  if (t) {
    if (e === void 0 && (e = "default"), r = wc(t, a, e), !wn(r) || Cn(r))
      return r;
    throw new Rc("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), Pc(a, e);
};
var Mc = Nc, _c = zo, Yo = function(a) {
  var e = Mc(a, "string");
  return _c(e) ? e : e + "";
};
var Dc = V, Pn = de, Wa = Dc.document, Vc = Pn(Wa) && Pn(Wa.createElement), Sr = function(a) {
  return Vc ? Wa.createElement(a) : {};
};
var kc = le, Lc = k, Bc = Sr, Wo = !kc && !Lc(function() {
  return Object.defineProperty(Bc("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
});
var jc = le, Uc = Y, Fc = _o, Gc = Ti, zc = wt, Hc = Yo, Yc = ce, Wc = Wo, An = Object.getOwnPropertyDescriptor, b2 = St.f = jc ? An : function(e, t) {
  if (e = zc(e), t = Hc(t), Wc)
    try {
      return An(e, t);
    } catch {
    }
  if (Yc(e, t))
    return Gc(!Uc(Fc.f, e, t), e[t]);
}, Ee = {}, Xc = le, qc = k, Xo = Xc && qc(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
});
var Kc = de, Qc = String, Zc = TypeError, Q = function(a) {
  if (Kc(a))
    return a;
  throw new Zc(Qc(a) + " is not an object");
};
var Jc = le, eh = Wo, th = Xo, Ht = Q, Rn = Yo, rh = TypeError, na = Object.defineProperty, ah = Object.getOwnPropertyDescriptor, sa = "enumerable", oa = "configurable", ua = "writable", x2 = Ee.f = Jc ? th ? function(e, t, r) {
  if (Ht(e), t = Rn(t), Ht(r), typeof e == "function" && t === "prototype" && "value" in r && ua in r && !r[ua]) {
    var i = ah(e, t);
    i && i[ua] && (e[t] = r.value, r = {
      configurable: oa in r ? r[oa] : i[oa],
      enumerable: sa in r ? r[sa] : i[sa],
      writable: !1
    });
  }
  return na(e, t, r);
} : na : function(e, t, r) {
  if (Ht(e), t = Rn(t), Ht(r), eh)
    try {
      return na(e, t, r);
    } catch {
    }
  if ("get" in r || "set" in r)
    throw new rh("Accessors not supported");
  return "value" in r && (e[t] = r.value), e;
}, ih = le, nh = Ee, sh = Ti, Ct = ih ? function(a, e, t) {
  return nh.f(a, e, sh(1, t));
} : function(a, e, t) {
  return a[e] = t, a;
};
var Pi = { exports: {} }, Xa = le, oh = ce, qo = Function.prototype, uh = Xa && Object.getOwnPropertyDescriptor, Ai = oh(qo, "name"), lh = Ai && (function() {
}).name === "something", ch = Ai && (!Xa || Xa && uh(qo, "name").configurable), wr = {
  EXISTS: Ai,
  PROPER: lh,
  CONFIGURABLE: ch
};
var hh = L, vh = B, qa = wi, fh = hh(Function.toString);
vh(qa.inspectSource) || (qa.inspectSource = function(a) {
  return fh(a);
});
var Ri = qa.inspectSource;
var gh = V, dh = B, In = gh.WeakMap, ph = dh(In) && /native code/.test(String(In));
var yh = Ci, mh = Ho, Nn = yh("keys"), Ii = function(a) {
  return Nn[a] || (Nn[a] = mh(a));
};
var Ni = {};
var bh = ph, Ko = V, xh = de, $h = Ct, la = ce, ca = wi, Th = Ii, Oh = Ni, Mn = "Object already initialized", Ka = Ko.TypeError, Eh = Ko.WeakMap, dr, Tt, pr, Sh = function(a) {
  return pr(a) ? Tt(a) : dr(a, {});
}, wh = function(a) {
  return function(e) {
    var t;
    if (!xh(e) || (t = Tt(e)).type !== a)
      throw new Ka("Incompatible receiver, " + a + " required");
    return t;
  };
};
if (bh || ca.state) {
  var fe = ca.state || (ca.state = new Eh());
  fe.get = fe.get, fe.has = fe.has, fe.set = fe.set, dr = function(a, e) {
    if (fe.has(a))
      throw new Ka(Mn);
    return e.facade = a, fe.set(a, e), e;
  }, Tt = function(a) {
    return fe.get(a) || {};
  }, pr = function(a) {
    return fe.has(a);
  };
} else {
  var We = Th("state");
  Oh[We] = !0, dr = function(a, e) {
    if (la(a, We))
      throw new Ka(Mn);
    return e.facade = a, $h(a, We, e), e;
  }, Tt = function(a) {
    return la(a, We) ? a[We] : {};
  }, pr = function(a) {
    return la(a, We);
  };
}
var Cr = {
  set: dr,
  get: Tt,
  has: pr,
  enforce: Sh,
  getterFor: wh
};
var $2 = Pi.exports, Mi = L, Ch = k, Ph = B, Yt = ce, Qa = le, Ah = wr.CONFIGURABLE, Rh = Ri, Qo = Cr, Ih = Qo.enforce, Nh = Qo.get, _n = String, ur = Object.defineProperty, Mh = Mi("".slice), _h = Mi("".replace), Dh = Mi([].join), Vh = Qa && !Ch(function() {
  return ur(function() {
  }, "length", { value: 8 }).length !== 8;
}), kh = String(String).split("String"), Lh = Pi.exports = function(a, e, t) {
  Mh(_n(e), 0, 7) === "Symbol(" && (e = "[" + _h(_n(e), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), t && t.getter && (e = "get " + e), t && t.setter && (e = "set " + e), (!Yt(a, "name") || Ah && a.name !== e) && (Qa ? ur(a, "name", { value: e, configurable: !0 }) : a.name = e), Vh && t && Yt(t, "arity") && a.length !== t.arity && ur(a, "length", { value: t.arity });
  try {
    t && Yt(t, "constructor") && t.constructor ? Qa && ur(a, "prototype", { writable: !1 }) : a.prototype && (a.prototype = void 0);
  } catch {
  }
  var r = Ih(a);
  return Yt(r, "source") || (r.source = Dh(kh, typeof e == "string" ? e : "")), a;
};
Function.prototype.toString = Lh(function() {
  return Ph(this) && Nh(this).source || Rh(this);
}, "toString");
var Zo = Pi.exports;
var Bh = B, jh = Ee, Uh = Zo, Fh = Si, Ge = function(a, e, t, r) {
  r || (r = {});
  var i = r.enumerable, n = r.name !== void 0 ? r.name : e;
  if (Bh(t) && Uh(t, n, r), r.global)
    i ? a[e] = t : Fh(e, t);
  else {
    try {
      r.unsafe ? a[e] && (i = !0) : delete a[e];
    } catch {
    }
    i ? a[e] = t : jh.f(a, e, {
      value: t,
      enumerable: !1,
      configurable: !r.nonConfigurable,
      writable: !r.nonWritable
    });
  }
  return a;
};
var Jo = {}, Gh = Math.ceil, zh = Math.floor, Hh = Math.trunc || function(e) {
  var t = +e;
  return (t > 0 ? zh : Gh)(t);
};
var Yh = Hh, Pr = function(a) {
  var e = +a;
  return e !== e || e === 0 ? 0 : Yh(e);
};
var Wh = Pr, Xh = Math.max, qh = Math.min, Kh = function(a, e) {
  var t = Wh(a);
  return t < 0 ? Xh(t + e, 0) : qh(t, e);
};
var Qh = Pr, Zh = Math.min, ct = function(a) {
  var e = Qh(a);
  return e > 0 ? Zh(e, 9007199254740991) : 0;
};
var Jh = ct, _i = function(a) {
  return Jh(a.length);
};
var ev = wt, tv = Kh, rv = _i, Dn = function(a) {
  return function(e, t, r) {
    var i = ev(e), n = rv(i), o = tv(r, n), s;
    if (a && t !== t) {
      for (; n > o; )
        if (s = i[o++], s !== s)
          return !0;
    } else
      for (; n > o; o++)
        if ((a || o in i) && i[o] === t)
          return a || o || 0;
    return !a && -1;
  };
}, eu = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: Dn(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: Dn(!1)
};
var av = L, ha = ce, iv = wt, nv = eu.indexOf, sv = Ni, Vn = av([].push), tu = function(a, e) {
  var t = iv(a), r = 0, i = [], n;
  for (n in t)
    !ha(sv, n) && ha(t, n) && Vn(i, n);
  for (; e.length > r; )
    ha(t, n = e[r++]) && (~nv(i, n) || Vn(i, n));
  return i;
};
var Di = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
];
var ov = tu, uv = Di, lv = uv.concat("length", "prototype"), T2 = Jo.f = Object.getOwnPropertyNames || function(e) {
  return ov(e, lv);
}, ru = {}, O2 = ru.f = Object.getOwnPropertySymbols, cv = Fe, hv = L, vv = Jo, fv = ru, gv = Q, dv = hv([].concat), pv = cv("Reflect", "ownKeys") || function(e) {
  var t = vv.f(gv(e)), r = fv.f;
  return r ? dv(t, r(e)) : t;
};
var kn = ce, yv = pv, mv = St, bv = Ee, xv = function(a, e, t) {
  for (var r = yv(e), i = bv.f, n = mv.f, o = 0; o < r.length; o++) {
    var s = r[o];
    !kn(a, s) && !(t && kn(t, s)) && i(a, s, n(e, s));
  }
};
var $v = k, Tv = B, Ov = /#|\.prototype\./, Pt = function(a, e) {
  var t = Sv[Ev(a)];
  return t === Cv ? !0 : t === wv ? !1 : Tv(e) ? $v(e) : !!e;
}, Ev = Pt.normalize = function(a) {
  return String(a).replace(Ov, ".").toLowerCase();
}, Sv = Pt.data = {}, wv = Pt.NATIVE = "N", Cv = Pt.POLYFILL = "P", au = Pt;
var Wt = V, Pv = St.f, Av = Ct, Rv = Ge, Iv = Si, Nv = xv, Mv = au, ee = function(a, e) {
  var t = a.target, r = a.global, i = a.stat, n, o, s, u, l, c;
  if (r ? o = Wt : i ? o = Wt[t] || Iv(t, {}) : o = Wt[t] && Wt[t].prototype, o)
    for (s in e) {
      if (l = e[s], a.dontCallGetSet ? (c = Pv(o, s), u = c && c.value) : u = o[s], n = Mv(r ? s : t + (i ? "." : "#") + s, a.forced), !n && u !== void 0) {
        if (typeof l == typeof u)
          continue;
        Nv(l, u);
      }
      (a.sham || u && u.sham) && Av(l, "sham", !0), Rv(o, s, l, a);
    }
};
var _v = V, Dv = je, At = Dv(_v.process) === "process";
var Vv = L, kv = Oe, Lv = function(a, e, t) {
  try {
    return Vv(kv(Object.getOwnPropertyDescriptor(a, e)[t]));
  } catch {
  }
};
var Bv = de, jv = function(a) {
  return Bv(a) || a === null;
};
var Uv = jv, Fv = String, Gv = TypeError, zv = function(a) {
  if (Uv(a))
    return a;
  throw new Gv("Can't set " + Fv(a) + " as a prototype");
};
var Hv = Lv, Yv = Q, Wv = zv, iu = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var a = !1, e = {}, t;
  try {
    t = Hv(Object.prototype, "__proto__", "set"), t(e, []), a = e instanceof Array;
  } catch {
  }
  return function(i, n) {
    return Yv(i), Wv(n), a ? t(i, n) : i.__proto__ = n, i;
  };
}() : void 0);
var Xv = Ee.f, qv = ce, Kv = z, Ln = Kv("toStringTag"), Ar = function(a, e, t) {
  a && !t && (a = a.prototype), a && !qv(a, Ln) && Xv(a, Ln, { configurable: !0, value: e });
};
var Bn = Zo, Qv = Ee, Zv = function(a, e, t) {
  return t.get && Bn(t.get, e, { getter: !0 }), t.set && Bn(t.set, e, { setter: !0 }), Qv.f(a, e, t);
};
var Jv = Fe, ef = Zv, tf = z, rf = le, jn = tf("species"), af = function(a) {
  var e = Jv(a);
  rf && e && !e[jn] && ef(e, jn, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
};
var nf = $r, sf = TypeError, of = function(a, e) {
  if (nf(e, a))
    return a;
  throw new sf("Incorrect invocation");
};
var uf = z, lf = uf("toStringTag"), nu = {};
nu[lf] = "z";
var cf = String(nu) === "[object z]";
var hf = cf, vf = B, lr = je, ff = z, gf = ff("toStringTag"), df = Object, pf = lr(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", yf = function(a, e) {
  try {
    return a[e];
  } catch {
  }
}, Vi = hf ? lr : function(a) {
  var e, t, r;
  return a === void 0 ? "Undefined" : a === null ? "Null" : typeof (t = yf(e = df(a), gf)) == "string" ? t : pf ? lr(e) : (r = lr(e)) === "Object" && vf(e.callee) ? "Arguments" : r;
};
var mf = L, bf = k, su = B, xf = Vi, $f = Fe, Tf = Ri, ou = function() {
}, uu = $f("Reflect", "construct"), ki = /^\s*(?:class|function)\b/, Of = mf(ki.exec), Ef = !ki.test(ou), gt = function(e) {
  if (!su(e))
    return !1;
  try {
    return uu(ou, [], e), !0;
  } catch {
    return !1;
  }
}, lu = function(e) {
  if (!su(e))
    return !1;
  switch (xf(e)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return Ef || !!Of(ki, Tf(e));
  } catch {
    return !0;
  }
};
lu.sham = !0;
var Sf = !uu || bf(function() {
  var a;
  return gt(gt.call) || !gt(Object) || !gt(function() {
    a = !0;
  }) || a;
}) ? lu : gt;
var wf = Sf, Cf = Or, Pf = TypeError, Af = function(a) {
  if (wf(a))
    return a;
  throw new Pf(Cf(a) + " is not a constructor");
};
var Un = Q, Rf = Af, If = Ue, Nf = z, Mf = Nf("species"), cu = function(a, e) {
  var t = Un(a).constructor, r;
  return t === void 0 || If(r = Un(t)[Mf]) ? e : Rf(r);
};
var _f = xr, hu = Function.prototype, Fn = hu.apply, Gn = hu.call, vu = typeof Reflect == "object" && Reflect.apply || (_f ? Gn.bind(Fn) : function() {
  return Gn.apply(Fn, arguments);
});
var Df = je, Vf = L, Rr = function(a) {
  if (Df(a) === "Function")
    return Vf(a);
};
var zn = Rr, kf = Oe, Lf = xr, Bf = zn(zn.bind), Li = function(a, e) {
  return kf(a), e === void 0 ? a : Lf ? Bf(a, e) : function() {
    return a.apply(e, arguments);
  };
};
var jf = Fe, fu = jf("document", "documentElement");
var Uf = L, Ff = Uf([].slice);
var Gf = TypeError, zf = function(a, e) {
  if (a < e)
    throw new Gf("Not enough arguments");
  return a;
};
var Hf = Tr, gu = /(?:ipad|iphone|ipod).*applewebkit/i.test(Hf);
var ae = V, Yf = vu, Wf = Li, Hn = B, Xf = ce, du = k, Yn = fu, qf = Ff, Wn = Sr, Kf = zf, Qf = gu, Zf = At, Za = ae.setImmediate, Ja = ae.clearImmediate, Jf = ae.process, va = ae.Dispatch, eg = ae.Function, Xn = ae.MessageChannel, tg = ae.String, fa = 0, xt = {}, qn = "onreadystatechange", Ot, _e, ga, da;
du(function() {
  Ot = ae.location;
});
var Bi = function(a) {
  if (Xf(xt, a)) {
    var e = xt[a];
    delete xt[a], e();
  }
}, pa = function(a) {
  return function() {
    Bi(a);
  };
}, Kn = function(a) {
  Bi(a.data);
}, Qn = function(a) {
  ae.postMessage(tg(a), Ot.protocol + "//" + Ot.host);
};
(!Za || !Ja) && (Za = function(e) {
  Kf(arguments.length, 1);
  var t = Hn(e) ? e : eg(e), r = qf(arguments, 1);
  return xt[++fa] = function() {
    Yf(t, void 0, r);
  }, _e(fa), fa;
}, Ja = function(e) {
  delete xt[e];
}, Zf ? _e = function(a) {
  Jf.nextTick(pa(a));
} : va && va.now ? _e = function(a) {
  va.now(pa(a));
} : Xn && !Qf ? (ga = new Xn(), da = ga.port2, ga.port1.onmessage = Kn, _e = Wf(da.postMessage, da)) : ae.addEventListener && Hn(ae.postMessage) && !ae.importScripts && Ot && Ot.protocol !== "file:" && !du(Qn) ? (_e = Qn, ae.addEventListener("message", Kn, !1)) : qn in Wn("script") ? _e = function(a) {
  Yn.appendChild(Wn("script"))[qn] = function() {
    Yn.removeChild(this), Bi(a);
  };
} : _e = function(a) {
  setTimeout(pa(a), 0);
});
var pu = {
  set: Za,
  clear: Ja
};
var Zn = V, rg = le, ag = Object.getOwnPropertyDescriptor, ig = function(a) {
  if (!rg)
    return Zn[a];
  var e = ag(Zn, a);
  return e && e.value;
};
var yu = function() {
  this.head = null, this.tail = null;
};
yu.prototype = {
  add: function(a) {
    var e = { item: a, next: null }, t = this.tail;
    t ? t.next = e : this.head = e, this.tail = e;
  },
  get: function() {
    var a = this.head;
    if (a) {
      var e = this.head = a.next;
      return e === null && (this.tail = null), a.item;
    }
  }
};
var mu = yu;
var ng = Tr, sg = /ipad|iphone|ipod/i.test(ng) && typeof Pebble < "u";
var og = Tr, ug = /web0s(?!.*chrome)/i.test(og);
var st = V, lg = ig, Jn = Li, ya = pu.set, cg = mu, hg = gu, vg = sg, fg = ug, ma = At, es = st.MutationObserver || st.WebKitMutationObserver, ts = st.document, rs = st.process, Xt = st.Promise, ei = lg("queueMicrotask"), Xe, ba, xa, qt, as;
if (!ei) {
  var Kt = new cg(), Qt = function() {
    var a, e;
    for (ma && (a = rs.domain) && a.exit(); e = Kt.get(); )
      try {
        e();
      } catch (t) {
        throw Kt.head && Xe(), t;
      }
    a && a.enter();
  };
  !hg && !ma && !fg && es && ts ? (ba = !0, xa = ts.createTextNode(""), new es(Qt).observe(xa, { characterData: !0 }), Xe = function() {
    xa.data = ba = !ba;
  }) : !vg && Xt && Xt.resolve ? (qt = Xt.resolve(void 0), qt.constructor = Xt, as = Jn(qt.then, qt), Xe = function() {
    as(Qt);
  }) : ma ? Xe = function() {
    rs.nextTick(Qt);
  } : (ya = Jn(ya, st), Xe = function() {
    ya(Qt);
  }), ei = function(a) {
    Kt.head || Xe(), Kt.add(a);
  };
}
var gg = ei;
var dg = function(a, e) {
  try {
    arguments.length === 1 ? console.error(a) : console.error(a, e);
  } catch {
  }
};
var ji = function(a) {
  try {
    return { error: !1, value: a() };
  } catch (e) {
    return { error: !0, value: e };
  }
};
var pg = V, Rt = pg.Promise;
var bu = typeof Deno == "object" && Deno && typeof Deno.version == "object";
var yg = bu, mg = At, bg = !yg && !mg && typeof window == "object" && typeof document == "object";
var xg = V, $t = Rt, $g = B, Tg = au, Og = Ri, Eg = z, Sg = bg, wg = bu, Cg = pe, $a = Oi, is = $t && $t.prototype, Pg = Eg("species"), ti = !1, xu = $g(xg.PromiseRejectionEvent), Ag = Tg("Promise", function() {
  var a = Og($t), e = a !== String($t);
  if (!e && $a === 66 || Cg && !(is.catch && is.finally))
    return !0;
  if (!$a || $a < 51 || !/native code/.test(a)) {
    var t = new $t(function(n) {
      n(1);
    }), r = function(n) {
      n(function() {
      }, function() {
      });
    }, i = t.constructor = {};
    if (i[Pg] = r, ti = t.then(function() {
    }) instanceof r, !ti)
      return !0;
  }
  return !e && (Sg || wg) && !xu;
}), It = {
  CONSTRUCTOR: Ag,
  REJECTION_EVENT: xu,
  SUBCLASSING: ti
};
var ht = {}, ns = Oe, Rg = TypeError, Ig = function(a) {
  var e, t;
  this.promise = new a(function(r, i) {
    if (e !== void 0 || t !== void 0)
      throw new Rg("Bad Promise constructor");
    e = r, t = i;
  }), this.resolve = ns(e), this.reject = ns(t);
}, E2 = ht.f = function(a) {
  return new Ig(a);
}, Ng = ee, Mg = pe, yr = At, Pe = V, ot = Y, ss = Ge, os = iu, _g = Ar, Dg = af, Vg = Oe, cr = B, kg = de, Lg = of, Bg = cu, $u = pu.set, Ui = gg, jg = dg, Ug = ji, Fg = mu, Tu = Cr, mr = Rt, Fi = It, Ou = ht, Ir = "Promise", Eu = Fi.CONSTRUCTOR, Gg = Fi.REJECTION_EVENT, zg = Fi.SUBCLASSING, Ta = Tu.getterFor(Ir), Hg = Tu.set, Qe = mr && mr.prototype, Le = mr, Zt = Qe, Su = Pe.TypeError, ri = Pe.document, Gi = Pe.process, ai = Ou.f, Yg = ai, Wg = !!(ri && ri.createEvent && Pe.dispatchEvent), wu = "unhandledrejection", Xg = "rejectionhandled", us = 0, Cu = 1, qg = 2, zi = 1, Pu = 2, Jt, ls, Kg, cs, Au = function(a) {
  var e;
  return kg(a) && cr(e = a.then) ? e : !1;
}, Ru = function(a, e) {
  var t = e.value, r = e.state === Cu, i = r ? a.ok : a.fail, n = a.resolve, o = a.reject, s = a.domain, u, l, c;
  try {
    i ? (r || (e.rejection === Pu && Zg(e), e.rejection = zi), i === !0 ? u = t : (s && s.enter(), u = i(t), s && (s.exit(), c = !0)), u === a.promise ? o(new Su("Promise-chain cycle")) : (l = Au(u)) ? ot(l, u, n, o) : n(u)) : o(t);
  } catch (v) {
    s && !c && s.exit(), o(v);
  }
}, Iu = function(a, e) {
  a.notified || (a.notified = !0, Ui(function() {
    for (var t = a.reactions, r; r = t.get(); )
      Ru(r, a);
    a.notified = !1, e && !a.rejection && Qg(a);
  }));
}, Nu = function(a, e, t) {
  var r, i;
  Wg ? (r = ri.createEvent("Event"), r.promise = e, r.reason = t, r.initEvent(a, !1, !0), Pe.dispatchEvent(r)) : r = { promise: e, reason: t }, !Gg && (i = Pe["on" + a]) ? i(r) : a === wu && jg("Unhandled promise rejection", t);
}, Qg = function(a) {
  ot($u, Pe, function() {
    var e = a.facade, t = a.value, r = hs(a), i;
    if (r && (i = Ug(function() {
      yr ? Gi.emit("unhandledRejection", t, e) : Nu(wu, e, t);
    }), a.rejection = yr || hs(a) ? Pu : zi, i.error))
      throw i.value;
  });
}, hs = function(a) {
  return a.rejection !== zi && !a.parent;
}, Zg = function(a) {
  ot($u, Pe, function() {
    var e = a.facade;
    yr ? Gi.emit("rejectionHandled", e) : Nu(Xg, e, a.value);
  });
}, et = function(a, e, t) {
  return function(r) {
    a(e, r, t);
  };
}, at = function(a, e, t) {
  a.done || (a.done = !0, t && (a = t), a.value = e, a.state = qg, Iu(a, !0));
}, ii = function(a, e, t) {
  if (!a.done) {
    a.done = !0, t && (a = t);
    try {
      if (a.facade === e)
        throw new Su("Promise can't be resolved itself");
      var r = Au(e);
      r ? Ui(function() {
        var i = { done: !1 };
        try {
          ot(
            r,
            e,
            et(ii, i, a),
            et(at, i, a)
          );
        } catch (n) {
          at(i, n, a);
        }
      }) : (a.value = e, a.state = Cu, Iu(a, !1));
    } catch (i) {
      at({ done: !1 }, i, a);
    }
  }
};
if (Eu && (Le = function(e) {
  Lg(this, Zt), Vg(e), ot(Jt, this);
  var t = Ta(this);
  try {
    e(et(ii, t), et(at, t));
  } catch (r) {
    at(t, r);
  }
}, Zt = Le.prototype, Jt = function(e) {
  Hg(this, {
    type: Ir,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new Fg(),
    rejection: !1,
    state: us,
    value: void 0
  });
}, Jt.prototype = ss(Zt, "then", function(e, t) {
  var r = Ta(this), i = ai(Bg(this, Le));
  return r.parent = !0, i.ok = cr(e) ? e : !0, i.fail = cr(t) && t, i.domain = yr ? Gi.domain : void 0, r.state === us ? r.reactions.add(i) : Ui(function() {
    Ru(i, r);
  }), i.promise;
}), ls = function() {
  var a = new Jt(), e = Ta(a);
  this.promise = a, this.resolve = et(ii, e), this.reject = et(at, e);
}, Ou.f = ai = function(a) {
  return a === Le || a === Kg ? new ls(a) : Yg(a);
}, !Mg && cr(mr) && Qe !== Object.prototype)) {
  cs = Qe.then, zg || ss(Qe, "then", function(e, t) {
    var r = this;
    return new Le(function(i, n) {
      ot(cs, r, i, n);
    }).then(e, t);
  }, { unsafe: !0 });
  try {
    delete Qe.constructor;
  } catch {
  }
  os && os(Qe, Zt);
}
Ng({ global: !0, constructor: !0, wrap: !0, forced: Eu }, {
  Promise: Le
});
_g(Le, Ir, !1, !0);
Dg(Ir);
var Nt = {};
var Jg = z, ed = Nt, td = Jg("iterator"), rd = Array.prototype, ad = function(a) {
  return a !== void 0 && (ed.Array === a || rd[td] === a);
};
var id = Vi, vs = lt, nd = Ue, sd = Nt, od = z, ud = od("iterator"), Mu = function(a) {
  if (!nd(a))
    return vs(a, ud) || vs(a, "@@iterator") || sd[id(a)];
};
var ld = Y, cd = Oe, hd = Q, vd = Or, fd = Mu, gd = TypeError, dd = function(a, e) {
  var t = arguments.length < 2 ? fd(a) : e;
  if (cd(t))
    return hd(ld(t, a));
  throw new gd(vd(a) + " is not iterable");
};
var pd = Y, fs = Q, yd = lt, md = function(a, e, t) {
  var r, i;
  fs(a);
  try {
    if (r = yd(a, "return"), !r) {
      if (e === "throw")
        throw t;
      return t;
    }
    r = pd(r, a);
  } catch (n) {
    i = !0, r = n;
  }
  if (e === "throw")
    throw t;
  if (i)
    throw r;
  return fs(r), t;
};
var bd = Li, xd = Y, $d = Q, Td = Or, Od = ad, Ed = _i, gs = $r, Sd = dd, wd = Mu, ds = md, Cd = TypeError, hr = function(a, e) {
  this.stopped = a, this.result = e;
}, ps = hr.prototype, _u = function(a, e, t) {
  var r = t && t.that, i = !!(t && t.AS_ENTRIES), n = !!(t && t.IS_RECORD), o = !!(t && t.IS_ITERATOR), s = !!(t && t.INTERRUPTED), u = bd(e, r), l, c, v, f, h, d, g, p = function(x) {
    return l && ds(l, "normal", x), new hr(!0, x);
  }, y = function(x) {
    return i ? ($d(x), s ? u(x[0], x[1], p) : u(x[0], x[1])) : s ? u(x, p) : u(x);
  };
  if (n)
    l = a.iterator;
  else if (o)
    l = a;
  else {
    if (c = wd(a), !c)
      throw new Cd(Td(a) + " is not iterable");
    if (Od(c)) {
      for (v = 0, f = Ed(a); f > v; v++)
        if (h = y(a[v]), h && gs(ps, h))
          return h;
      return new hr(!1);
    }
    l = Sd(a, c);
  }
  for (d = n ? a.next : l.next; !(g = xd(d, l)).done; ) {
    try {
      h = y(g.value);
    } catch (x) {
      ds(l, "throw", x);
    }
    if (typeof h == "object" && h && gs(ps, h))
      return h;
  }
  return new hr(!1);
};
var Pd = z, Du = Pd("iterator"), Vu = !1;
try {
  var Ad = 0, ys = {
    next: function() {
      return { done: !!Ad++ };
    },
    return: function() {
      Vu = !0;
    }
  };
  ys[Du] = function() {
    return this;
  }, Array.from(ys, function() {
    throw 2;
  });
} catch {
}
var Rd = function(a, e) {
  try {
    if (!e && !Vu)
      return !1;
  } catch {
    return !1;
  }
  var t = !1;
  try {
    var r = {};
    r[Du] = function() {
      return {
        next: function() {
          return { done: t = !0 };
        }
      };
    }, a(r);
  } catch {
  }
  return t;
};
var Id = Rt, Nd = Rd, Md = It.CONSTRUCTOR, ku = Md || !Nd(function(a) {
  Id.all(a).then(void 0, function() {
  });
});
var _d = ee, Dd = Y, Vd = Oe, kd = ht, Ld = ji, Bd = _u, jd = ku;
_d({ target: "Promise", stat: !0, forced: jd }, {
  all: function(e) {
    var t = this, r = kd.f(t), i = r.resolve, n = r.reject, o = Ld(function() {
      var s = Vd(t.resolve), u = [], l = 0, c = 1;
      Bd(e, function(v) {
        var f = l++, h = !1;
        c++, Dd(s, t, v).then(function(d) {
          h || (h = !0, u[f] = d, --c || i(u));
        }, n);
      }), --c || i(u);
    });
    return o.error && n(o.value), r.promise;
  }
});
var Ud = ee, Fd = pe, Gd = It.CONSTRUCTOR, ni = Rt, zd = Fe, Hd = B, Yd = Ge, ms = ni && ni.prototype;
Ud({ target: "Promise", proto: !0, forced: Gd, real: !0 }, {
  catch: function(a) {
    return this.then(void 0, a);
  }
});
if (!Fd && Hd(ni)) {
  var bs = zd("Promise").prototype.catch;
  ms.catch !== bs && Yd(ms, "catch", bs, { unsafe: !0 });
}
var Wd = ee, Xd = Y, qd = Oe, Kd = ht, Qd = ji, Zd = _u, Jd = ku;
Wd({ target: "Promise", stat: !0, forced: Jd }, {
  race: function(e) {
    var t = this, r = Kd.f(t), i = r.reject, n = Qd(function() {
      var o = qd(t.resolve);
      Zd(e, function(s) {
        Xd(o, t, s).then(r.resolve, i);
      });
    });
    return n.error && i(n.value), r.promise;
  }
});
var ep = ee, tp = ht, rp = It.CONSTRUCTOR;
ep({ target: "Promise", stat: !0, forced: rp }, {
  reject: function(e) {
    var t = tp.f(this), r = t.reject;
    return r(e), t.promise;
  }
});
var ap = Q, ip = de, np = ht, sp = function(a, e) {
  if (ap(a), ip(e) && e.constructor === a)
    return e;
  var t = np.f(a), r = t.resolve;
  return r(e), t.promise;
};
var op = ee, up = Fe, Lu = pe, lp = Rt, Bu = It.CONSTRUCTOR, cp = sp, hp = up("Promise"), vp = Lu && !Bu;
op({ target: "Promise", stat: !0, forced: Lu || Bu }, {
  resolve: function(e) {
    return cp(vp && this === hp ? lp : this, e);
  }
});
function xs(a, e, t, r, i, n, o) {
  try {
    var s = a[n](o), u = s.value;
  } catch (l) {
    t(l);
    return;
  }
  s.done ? e(u) : Promise.resolve(u).then(r, i);
}
function Te(a) {
  return function() {
    var e = this, t = arguments;
    return new Promise(function(r, i) {
      var n = a.apply(e, t);
      function o(u) {
        xs(n, r, i, o, s, "next", u);
      }
      function s(u) {
        xs(n, r, i, o, s, "throw", u);
      }
      o(void 0);
    });
  };
}
var fp = Vi, gp = String, ye = function(a) {
  if (fp(a) === "Symbol")
    throw new TypeError("Cannot convert a Symbol value to a string");
  return gp(a);
};
var dp = Q, ju = function() {
  var a = dp(this), e = "";
  return a.hasIndices && (e += "d"), a.global && (e += "g"), a.ignoreCase && (e += "i"), a.multiline && (e += "m"), a.dotAll && (e += "s"), a.unicode && (e += "u"), a.unicodeSets && (e += "v"), a.sticky && (e += "y"), e;
};
var Hi = k, pp = V, Yi = pp.RegExp, Wi = Hi(function() {
  var a = Yi("a", "y");
  return a.lastIndex = 2, a.exec("abcd") !== null;
}), yp = Wi || Hi(function() {
  return !Yi("a", "y").sticky;
}), mp = Wi || Hi(function() {
  var a = Yi("^r", "gy");
  return a.lastIndex = 2, a.exec("str") !== null;
}), Uu = {
  BROKEN_CARET: mp,
  MISSED_STICKY: yp,
  UNSUPPORTED_Y: Wi
};
var Fu = {}, bp = tu, xp = Di, $p = Object.keys || function(e) {
  return bp(e, xp);
};
var Tp = le, Op = Xo, Ep = Ee, Sp = Q, wp = wt, Cp = $p, S2 = Fu.f = Tp && !Op ? Object.defineProperties : function(e, t) {
  Sp(e);
  for (var r = wp(t), i = Cp(t), n = i.length, o = 0, s; n > o; )
    Ep.f(e, s = i[o++], r[s]);
  return e;
}, Pp = Q, Ap = Fu, $s = Di, Rp = Ni, Ip = fu, Np = Sr, Mp = Ii, Ts = ">", Os = "<", si = "prototype", oi = "script", Gu = Mp("IE_PROTO"), Oa = function() {
}, zu = function(a) {
  return Os + oi + Ts + a + Os + "/" + oi + Ts;
}, Es = function(a) {
  a.write(zu("")), a.close();
  var e = a.parentWindow.Object;
  return a = null, e;
}, _p = function() {
  var a = Np("iframe"), e = "java" + oi + ":", t;
  return a.style.display = "none", Ip.appendChild(a), a.src = String(e), t = a.contentWindow.document, t.open(), t.write(zu("document.F=Object")), t.close(), t.F;
}, er, vr = function() {
  try {
    er = new ActiveXObject("htmlfile");
  } catch {
  }
  vr = typeof document < "u" ? document.domain && er ? Es(er) : _p() : Es(er);
  for (var a = $s.length; a--; )
    delete vr[si][$s[a]];
  return vr();
};
Rp[Gu] = !0;
var Nr = Object.create || function(e, t) {
  var r;
  return e !== null ? (Oa[si] = Pp(e), r = new Oa(), Oa[si] = null, r[Gu] = e) : r = vr(), t === void 0 ? r : Ap.f(r, t);
};
var Dp = k, Vp = V, kp = Vp.RegExp, Lp = Dp(function() {
  var a = kp(".", "s");
  return !(a.dotAll && a.test(`
`) && a.flags === "s");
});
var Bp = k, jp = V, Up = jp.RegExp, Fp = Bp(function() {
  var a = Up("(?<a>b)", "g");
  return a.exec("b").groups.a !== "b" || "b".replace(a, "$<a>c") !== "bc";
});
var tt = Y, Mr = L, Gp = ye, zp = ju, Hp = Uu, Yp = Ci, Wp = Nr, Xp = Cr.get, qp = Lp, Kp = Fp, Qp = Yp("native-string-replace", String.prototype.replace), br = RegExp.prototype.exec, ui = br, Zp = Mr("".charAt), Jp = Mr("".indexOf), ey = Mr("".replace), Ea = Mr("".slice), li = function() {
  var a = /a/, e = /b*/g;
  return tt(br, a, "a"), tt(br, e, "a"), a.lastIndex !== 0 || e.lastIndex !== 0;
}(), Hu = Hp.BROKEN_CARET, ci = /()??/.exec("")[1] !== void 0, ty = li || ci || Hu || qp || Kp;
ty && (ui = function(e) {
  var t = this, r = Xp(t), i = Gp(e), n = r.raw, o, s, u, l, c, v, f;
  if (n)
    return n.lastIndex = t.lastIndex, o = tt(ui, n, i), t.lastIndex = n.lastIndex, o;
  var h = r.groups, d = Hu && t.sticky, g = tt(zp, t), p = t.source, y = 0, x = i;
  if (d && (g = ey(g, "y", ""), Jp(g, "g") === -1 && (g += "g"), x = Ea(i, t.lastIndex), t.lastIndex > 0 && (!t.multiline || t.multiline && Zp(i, t.lastIndex - 1) !== `
`) && (p = "(?: " + p + ")", x = " " + x, y++), s = new RegExp("^(?:" + p + ")", g)), ci && (s = new RegExp("^" + p + "$(?!\\s)", g)), li && (u = t.lastIndex), l = tt(br, d ? s : t, x), d ? l ? (l.input = Ea(l.input, y), l[0] = Ea(l[0], y), l.index = t.lastIndex, t.lastIndex += l[0].length) : t.lastIndex = 0 : li && l && (t.lastIndex = t.global ? l.index + l[0].length : u), ci && l && l.length > 1 && tt(Qp, l[0], s, function() {
    for (c = 1; c < arguments.length - 2; c++)
      arguments[c] === void 0 && (l[c] = void 0);
  }), l && h)
    for (l.groups = v = Wp(null), c = 0; c < h.length; c++)
      f = h[c], v[f[0]] = l[f[1]];
  return l;
});
var Xi = ui;
var ry = ee, Ss = Xi;
ry({ target: "RegExp", proto: !0, forced: /./.exec !== Ss }, {
  exec: Ss
});
var ws = Y, Cs = Ge, ay = Xi, Ps = k, Yu = z, iy = Ct, ny = Yu("species"), Sa = RegExp.prototype, qi = function(a, e, t, r) {
  var i = Yu(a), n = !Ps(function() {
    var l = {};
    return l[i] = function() {
      return 7;
    }, ""[a](l) !== 7;
  }), o = n && !Ps(function() {
    var l = !1, c = /a/;
    return a === "split" && (c = {}, c.constructor = {}, c.constructor[ny] = function() {
      return c;
    }, c.flags = "", c[i] = /./[i]), c.exec = function() {
      return l = !0, null;
    }, c[i](""), !l;
  });
  if (!n || !o || t) {
    var s = /./[i], u = e(i, ""[a], function(l, c, v, f, h) {
      var d = c.exec;
      return d === ay || d === Sa.exec ? n && !h ? { done: !0, value: ws(s, c, v, f) } : { done: !0, value: ws(l, v, c, f) } : { done: !1 };
    });
    Cs(String.prototype, a, u[0]), Cs(Sa, i, u[1]);
  }
  r && iy(Sa[i], "sham", !0);
};
var Ki = L, sy = Pr, oy = ye, uy = ge, ly = Ki("".charAt), As = Ki("".charCodeAt), cy = Ki("".slice), Rs = function(a) {
  return function(e, t) {
    var r = oy(uy(e)), i = sy(t), n = r.length, o, s;
    return i < 0 || i >= n ? a ? "" : void 0 : (o = As(r, i), o < 55296 || o > 56319 || i + 1 === n || (s = As(r, i + 1)) < 56320 || s > 57343 ? a ? ly(r, i) : o : a ? cy(r, i, i + 2) : (o - 55296 << 10) + (s - 56320) + 65536);
  };
}, hy = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: Rs(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: Rs(!0)
};
var vy = hy.charAt, Qi = function(a, e, t) {
  return e + (t ? vy(a, e).length : 1);
};
var Is = Y, fy = Q, gy = B, dy = je, py = Xi, yy = TypeError, Zi = function(a, e) {
  var t = a.exec;
  if (gy(t)) {
    var r = Is(t, a, e);
    return r !== null && fy(r), r;
  }
  if (dy(a) === "RegExp")
    return Is(py, a, e);
  throw new yy("RegExp#exec called on incompatible receiver");
};
var my = Y, by = qi, xy = Q, $y = Ue, Ty = ct, wa = ye, Oy = ge, Ey = lt, Sy = Qi, Ns = Zi;
by("match", function(a, e, t) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function(i) {
      var n = Oy(this), o = $y(i) ? void 0 : Ey(i, a);
      return o ? my(o, i, n) : new RegExp(i)[a](wa(n));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function(r) {
      var i = xy(this), n = wa(r), o = t(e, i, n);
      if (o.done)
        return o.value;
      if (!i.global)
        return Ns(i, n);
      var s = i.unicode;
      i.lastIndex = 0;
      for (var u = [], l = 0, c; (c = Ns(i, n)) !== null; ) {
        var v = wa(c[0]);
        u[l] = v, v === "" && (i.lastIndex = Sy(n, Ty(i.lastIndex), s)), l++;
      }
      return l === 0 ? null : u;
    }
  ];
});
var Ji = L, wy = Er, Cy = Math.floor, Ca = Ji("".charAt), Py = Ji("".replace), Pa = Ji("".slice), Ay = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, Ry = /\$([$&'`]|\d{1,2})/g, Iy = function(a, e, t, r, i, n) {
  var o = t + a.length, s = r.length, u = Ry;
  return i !== void 0 && (i = wy(i), u = Ay), Py(n, u, function(l, c) {
    var v;
    switch (Ca(c, 0)) {
      case "$":
        return "$";
      case "&":
        return a;
      case "`":
        return Pa(e, 0, t);
      case "'":
        return Pa(e, o);
      case "<":
        v = i[Pa(c, 1, -1)];
        break;
      default:
        var f = +c;
        if (f === 0)
          return l;
        if (f > s) {
          var h = Cy(f / 10);
          return h === 0 ? l : h <= s ? r[h - 1] === void 0 ? Ca(c, 1) : r[h - 1] + Ca(c, 1) : l;
        }
        v = r[f - 1];
    }
    return v === void 0 ? "" : v;
  });
};
var Ny = vu, Ms = Y, _r = L, My = qi, _y = k, Dy = Q, Vy = B, ky = Ue, Ly = Pr, By = ct, qe = ye, jy = ge, Uy = Qi, Fy = lt, Gy = Iy, zy = Zi, Hy = z, hi = Hy("replace"), Yy = Math.max, Wy = Math.min, Xy = _r([].concat), Aa = _r([].push), _s = _r("".indexOf), Ds = _r("".slice), qy = function(a) {
  return a === void 0 ? a : String(a);
}, Ky = function() {
  return "a".replace(/./, "$0") === "$0";
}(), Vs = function() {
  return /./[hi] ? /./[hi]("a", "$0") === "" : !1;
}(), Qy = !_y(function() {
  var a = /./;
  return a.exec = function() {
    var e = [];
    return e.groups = { a: "7" }, e;
  }, "".replace(a, "$<a>") !== "7";
});
My("replace", function(a, e, t) {
  var r = Vs ? "$" : "$0";
  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function(n, o) {
      var s = jy(this), u = ky(n) ? void 0 : Fy(n, hi);
      return u ? Ms(u, n, s, o) : Ms(e, qe(s), n, o);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function(i, n) {
      var o = Dy(this), s = qe(i);
      if (typeof n == "string" && _s(n, r) === -1 && _s(n, "$<") === -1) {
        var u = t(e, o, s, n);
        if (u.done)
          return u.value;
      }
      var l = Vy(n);
      l || (n = qe(n));
      var c = o.global, v;
      c && (v = o.unicode, o.lastIndex = 0);
      for (var f = [], h; h = zy(o, s), !(h === null || (Aa(f, h), !c)); ) {
        var d = qe(h[0]);
        d === "" && (o.lastIndex = Uy(s, By(o.lastIndex), v));
      }
      for (var g = "", p = 0, y = 0; y < f.length; y++) {
        h = f[y];
        for (var x = qe(h[0]), b = Yy(Wy(Ly(h.index), s.length), 0), $ = [], S, E = 1; E < h.length; E++)
          Aa($, qy(h[E]));
        var T = h.groups;
        if (l) {
          var C = Xy([x], $, b, s);
          T !== void 0 && Aa(C, T), S = qe(Ny(n, void 0, C));
        } else
          S = Gy(x, s, b, $, T, n);
        b >= p && (g += Ds(s, p, b) + S, p = b + x.length);
      }
      return g + Ds(s, p);
    }
  ];
}, !Qy || !Ky || Vs);
var Zy = de, Jy = je, em = z, tm = em("match"), rm = function(a) {
  var e;
  return Zy(a) && ((e = a[tm]) !== void 0 ? !!e : Jy(a) === "RegExp");
};
var am = rm, im = TypeError, en = function(a) {
  if (am(a))
    throw new im("The method doesn't accept regular expressions");
  return a;
};
var nm = z, sm = nm("match"), tn = function(a) {
  var e = /./;
  try {
    "/./"[a](e);
  } catch {
    try {
      return e[sm] = !1, "/./"[a](e);
    } catch {
    }
  }
  return !1;
};
var om = ee, um = Rr, lm = St.f, cm = ct, ks = ye, hm = en, vm = ge, fm = tn, gm = pe, dm = um("".slice), pm = Math.min, Wu = fm("startsWith"), ym = !gm && !Wu && !!function() {
  var a = lm(String.prototype, "startsWith");
  return a && !a.writable;
}();
om({ target: "String", proto: !0, forced: !ym && !Wu }, {
  startsWith: function(e) {
    var t = ks(vm(this));
    hm(e);
    var r = cm(pm(arguments.length > 1 ? arguments[1] : void 0, t.length)), i = ks(e);
    return dm(t, r, r + i.length) === i;
  }
});
var mm = z, bm = Nr, xm = Ee.f, vi = mm("unscopables"), fi = Array.prototype;
fi[vi] === void 0 && xm(fi, vi, {
  configurable: !0,
  value: bm(null)
});
var $m = function(a) {
  fi[vi][a] = !0;
};
var Tm = k, Om = !Tm(function() {
  function a() {
  }
  return a.prototype.constructor = null, Object.getPrototypeOf(new a()) !== a.prototype;
});
var Em = ce, Sm = B, wm = Er, Cm = Ii, Pm = Om, Ls = Cm("IE_PROTO"), gi = Object, Am = gi.prototype, Xu = Pm ? gi.getPrototypeOf : function(a) {
  var e = wm(a);
  if (Em(e, Ls))
    return e[Ls];
  var t = e.constructor;
  return Sm(t) && e instanceof t ? t.prototype : e instanceof gi ? Am : null;
};
var Rm = k, Im = B, Nm = de, Mm = Nr, Bs = Xu, _m = Ge, Dm = z, Vm = pe, di = Dm("iterator"), qu = !1, xe, Ra, Ia;
[].keys && (Ia = [].keys(), "next" in Ia ? (Ra = Bs(Bs(Ia)), Ra !== Object.prototype && (xe = Ra)) : qu = !0);
var km = !Nm(xe) || Rm(function() {
  var a = {};
  return xe[di].call(a) !== a;
});
km ? xe = {} : Vm && (xe = Mm(xe));
Im(xe[di]) || _m(xe, di, function() {
  return this;
});
var Ku = {
  IteratorPrototype: xe,
  BUGGY_SAFARI_ITERATORS: qu
};
var Lm = Ku.IteratorPrototype, Bm = Nr, jm = Ti, Um = Ar, Fm = Nt, Gm = function() {
  return this;
}, zm = function(a, e, t, r) {
  var i = e + " Iterator";
  return a.prototype = Bm(Lm, { next: jm(+!r, t) }), Um(a, i, !1, !0), Fm[i] = Gm, a;
};
var Hm = ee, Ym = Y, tr = pe, Qu = wr, Wm = B, Xm = zm, js = Xu, Us = iu, qm = Ar, Km = Ct, Na = Ge, Qm = z, Fs = Nt, Zu = Ku, Zm = Qu.PROPER, Jm = Qu.CONFIGURABLE, Gs = Zu.IteratorPrototype, rr = Zu.BUGGY_SAFARI_ITERATORS, dt = Qm("iterator"), zs = "keys", pt = "values", Hs = "entries", Ys = function() {
  return this;
}, e0 = function(a, e, t, r, i, n, o) {
  Xm(t, e, r);
  var s = function(y) {
    if (y === i && f)
      return f;
    if (!rr && y && y in c)
      return c[y];
    switch (y) {
      case zs:
        return function() {
          return new t(this, y);
        };
      case pt:
        return function() {
          return new t(this, y);
        };
      case Hs:
        return function() {
          return new t(this, y);
        };
    }
    return function() {
      return new t(this);
    };
  }, u = e + " Iterator", l = !1, c = a.prototype, v = c[dt] || c["@@iterator"] || i && c[i], f = !rr && v || s(i), h = e === "Array" && c.entries || v, d, g, p;
  if (h && (d = js(h.call(new a())), d !== Object.prototype && d.next && (!tr && js(d) !== Gs && (Us ? Us(d, Gs) : Wm(d[dt]) || Na(d, dt, Ys)), qm(d, u, !0, !0), tr && (Fs[u] = Ys))), Zm && i === pt && v && v.name !== pt && (!tr && Jm ? Km(c, "name", pt) : (l = !0, f = function() {
    return Ym(v, this);
  })), i)
    if (g = {
      values: s(pt),
      keys: n ? f : s(zs),
      entries: s(Hs)
    }, o)
      for (p in g)
        (rr || l || !(p in c)) && Na(c, p, g[p]);
    else
      Hm({ target: e, proto: !0, forced: rr || l }, g);
  return (!tr || o) && c[dt] !== f && Na(c, dt, f, { name: i }), Fs[e] = f, g;
};
var t0 = function(a, e) {
  return { value: a, done: e };
};
var r0 = wt, rn = $m, Ws = Nt, Ju = Cr, a0 = Ee.f, i0 = e0, ar = t0, n0 = pe, s0 = le, el = "Array Iterator", o0 = Ju.set, u0 = Ju.getterFor(el), l0 = i0(Array, "Array", function(a, e) {
  o0(this, {
    type: el,
    target: r0(a),
    // target
    index: 0,
    // next index
    kind: e
    // kind
  });
}, function() {
  var a = u0(this), e = a.target, t = a.index++;
  if (!e || t >= e.length)
    return a.target = void 0, ar(void 0, !0);
  switch (a.kind) {
    case "keys":
      return ar(t, !1);
    case "values":
      return ar(e[t], !1);
  }
  return ar([t, e[t]], !1);
}, "values"), Xs = Ws.Arguments = Ws.Array;
rn("keys");
rn("values");
rn("entries");
if (!n0 && s0 && Xs.name !== "values")
  try {
    a0(Xs, "name", { value: "values" });
  } catch {
  }
var c0 = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};
var h0 = Sr, Ma = h0("span").classList, qs = Ma && Ma.constructor && Ma.constructor.prototype, v0 = qs === Object.prototype ? void 0 : qs;
var Ks = V, tl = c0, f0 = v0, mt = l0, Qs = Ct, g0 = Ar, d0 = z, _a = d0("iterator"), Da = mt.values, rl = function(a, e) {
  if (a) {
    if (a[_a] !== Da)
      try {
        Qs(a, _a, Da);
      } catch {
        a[_a] = Da;
      }
    if (g0(a, e, !0), tl[e]) {
      for (var t in mt)
        if (a[t] !== mt[t])
          try {
            Qs(a, t, mt[t]);
          } catch {
            a[t] = mt[t];
          }
    }
  }
};
for (var Va in tl)
  rl(Ks[Va] && Ks[Va].prototype, Va);
rl(f0, "DOMTokenList");
function p0(a, e) {
  if (Ha(a) != "object" || !a)
    return a;
  var t = a[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(a, e || "default");
    if (Ha(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(a);
}
function y0(a) {
  var e = p0(a, "string");
  return Ha(e) == "symbol" ? e : String(e);
}
function an(a, e, t) {
  return e = y0(e), e in a ? Object.defineProperty(a, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[e] = t, a;
}
var m0 = Oe, b0 = Er, x0 = jo, $0 = _i, T0 = TypeError, Zs = function(a) {
  return function(e, t, r, i) {
    var n = b0(e), o = x0(n), s = $0(n);
    m0(t);
    var u = a ? s - 1 : 0, l = a ? -1 : 1;
    if (r < 2)
      for (; ; ) {
        if (u in o) {
          i = o[u], u += l;
          break;
        }
        if (u += l, a ? u < 0 : s <= u)
          throw new T0("Reduce of empty array with no initial value");
      }
    for (; a ? u >= 0 : s > u; u += l)
      u in o && (i = t(i, o[u], u, n));
    return i;
  };
}, O0 = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: Zs(!1),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: Zs(!0)
};
var E0 = k, al = function(a, e) {
  var t = [][a];
  return !!t && E0(function() {
    t.call(null, e || function() {
      return 1;
    }, 1);
  });
};
var S0 = ee, w0 = O0.left, C0 = al, Js = Oi, P0 = At, A0 = !P0 && Js > 79 && Js < 83, R0 = A0 || !C0("reduce");
S0({ target: "Array", proto: !0, forced: R0 }, {
  reduce: function(e) {
    var t = arguments.length;
    return w0(this, e, t, t > 1 ? arguments[1] : void 0);
  }
});
var I0 = ee, N0 = Rr, M0 = St.f, _0 = ct, eo = ye, D0 = en, V0 = ge, k0 = tn, L0 = pe, B0 = N0("".slice), j0 = Math.min, il = k0("endsWith"), U0 = !L0 && !il && !!function() {
  var a = M0(String.prototype, "endsWith");
  return a && !a.writable;
}();
I0({ target: "String", proto: !0, forced: !U0 && !il }, {
  endsWith: function(e) {
    var t = eo(V0(this));
    D0(e);
    var r = arguments.length > 1 ? arguments[1] : void 0, i = t.length, n = r === void 0 ? i : j0(_0(r), i), o = eo(e);
    return B0(t, n - o.length, n) === o;
  }
});
var ka = Y, nl = L, F0 = qi, G0 = Q, z0 = Ue, H0 = ge, Y0 = cu, W0 = Qi, X0 = ct, to = ye, q0 = lt, ro = Zi, K0 = Uu, Q0 = k, Ke = K0.UNSUPPORTED_Y, Z0 = 4294967295, J0 = Math.min, La = nl([].push), Ba = nl("".slice), e1 = !Q0(function() {
  var a = /(?:)/, e = a.exec;
  a.exec = function() {
    return e.apply(this, arguments);
  };
  var t = "ab".split(a);
  return t.length !== 2 || t[0] !== "a" || t[1] !== "b";
}), ao = "abbc".split(/(b)*/)[1] === "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
"test".split(/(?:)/, -1).length !== 4 || "ab".split(/(?:ab)*/).length !== 2 || ".".split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
".".split(/()()/).length > 1 || "".split(/.?/).length;
F0("split", function(a, e, t) {
  var r = "0".split(void 0, 0).length ? function(i, n) {
    return i === void 0 && n === 0 ? [] : ka(e, this, i, n);
  } : e;
  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function(n, o) {
      var s = H0(this), u = z0(n) ? void 0 : q0(n, a);
      return u ? ka(u, n, s, o) : ka(r, to(s), n, o);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function(i, n) {
      var o = G0(this), s = to(i);
      if (!ao) {
        var u = t(r, o, s, n, r !== e);
        if (u.done)
          return u.value;
      }
      var l = Y0(o, RegExp), c = o.unicode, v = (o.ignoreCase ? "i" : "") + (o.multiline ? "m" : "") + (o.unicode ? "u" : "") + (Ke ? "g" : "y"), f = new l(Ke ? "^(?:" + o.source + ")" : o, v), h = n === void 0 ? Z0 : n >>> 0;
      if (h === 0)
        return [];
      if (s.length === 0)
        return ro(f, s) === null ? [s] : [];
      for (var d = 0, g = 0, p = []; g < s.length; ) {
        f.lastIndex = Ke ? 0 : g;
        var y = ro(f, Ke ? Ba(s, g) : s), x;
        if (y === null || (x = J0(X0(f.lastIndex + (Ke ? g : 0)), s.length)) === d)
          g = W0(s, g, c);
        else {
          if (La(p, Ba(s, d, g)), p.length === h)
            return p;
          for (var b = 1; b <= y.length - 1; b++)
            if (La(p, y[b]), p.length === h)
              return p;
          g = d = x;
        }
      }
      return La(p, Ba(s, d)), p;
    }
  ];
}, ao || !e1, Ke);
var Mt = { exports: {} }, rt = { exports: {} }, w2 = rt.exports;
(function() {
  var a, e, t, r, i, n;
  typeof performance < "u" && performance !== null && performance.now ? rt.exports = function() {
    return performance.now();
  } : typeof process < "u" && process !== null && process.hrtime ? (rt.exports = function() {
    return (a() - i) / 1e6;
  }, e = process.hrtime, a = function() {
    var o;
    return o = e(), o[0] * 1e9 + o[1];
  }, r = a(), n = process.uptime() * 1e9, i = r - n) : Date.now ? (rt.exports = function() {
    return Date.now() - t;
  }, t = Date.now()) : (rt.exports = function() {
    return (/* @__PURE__ */ new Date()).getTime() - t;
  }, t = (/* @__PURE__ */ new Date()).getTime());
}).call(Ze);
var t1 = rt.exports;
var C2 = Mt.exports, r1 = t1, $e = typeof window > "u" ? Ze : window, ir = ["moz", "webkit"], it = "AnimationFrame", ut = $e["request" + it], Et = $e["cancel" + it] || $e["cancelRequest" + it];
for (var yt = 0; !ut && yt < ir.length; yt++)
  ut = $e[ir[yt] + "Request" + it], Et = $e[ir[yt] + "Cancel" + it] || $e[ir[yt] + "CancelRequest" + it];
if (!ut || !Et) {
  var ja = 0, io = 0, De = [], a1 = 1e3 / 60;
  ut = function(a) {
    if (De.length === 0) {
      var e = r1(), t = Math.max(0, a1 - (e - ja));
      ja = t + e, setTimeout(function() {
        var r = De.slice(0);
        De.length = 0;
        for (var i = 0; i < r.length; i++)
          if (!r[i].cancelled)
            try {
              r[i].callback(ja);
            } catch (n) {
              setTimeout(function() {
                throw n;
              }, 0);
            }
      }, Math.round(t));
    }
    return De.push({
      handle: ++io,
      callback: a,
      cancelled: !1
    }), io;
  }, Et = function(a) {
    for (var e = 0; e < De.length; e++)
      De[e].handle === a && (De[e].cancelled = !0);
  };
}
Mt.exports = function(a) {
  return ut.call($e, a);
};
var P2 = Mt.exports.cancel = function() {
  Et.apply($e, arguments);
}, A2 = Mt.exports.polyfill = function(a) {
  a || (a = $e), a.requestAnimationFrame = ut, a.cancelAnimationFrame = Et;
}, i1 = Mt.exports;
const Ua = /* @__PURE__ */ Mo(i1);
var sl = `	
\v\f\r                　\u2028\u2029\uFEFF`;
var n1 = L, s1 = ge, o1 = ye, pi = sl, no = n1("".replace), u1 = RegExp("^[" + pi + "]+"), l1 = RegExp("(^|[^" + pi + "])[" + pi + "]+$"), Fa = function(a) {
  return function(e) {
    var t = o1(s1(e));
    return a & 1 && (t = no(t, u1, "")), a & 2 && (t = no(t, l1, "$1")), t;
  };
}, c1 = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: Fa(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: Fa(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: Fa(3)
};
var h1 = wr.PROPER, v1 = k, so = sl, oo = "​᠎", f1 = function(a) {
  return v1(function() {
    return !!so[a]() || oo[a]() !== oo || h1 && so[a].name !== a;
  });
};
var g1 = ee, d1 = c1.trim, p1 = f1;
g1({ target: "String", proto: !0, forced: p1("trim") }, {
  trim: function() {
    return d1(this);
  }
});
var y1 = function(a) {
  this.ok = !1, this.alpha = 1, a.charAt(0) == "#" && (a = a.substr(1, 6)), a = a.replace(/ /g, ""), a = a.toLowerCase();
  var e = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "00ffff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000000",
    blanchedalmond: "ffebcd",
    blue: "0000ff",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "00ffff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dodgerblue: "1e90ff",
    feldspar: "d19275",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "ff00ff",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgrey: "d3d3d3",
    lightgreen: "90ee90",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslateblue: "8470ff",
    lightslategray: "778899",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "00ff00",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "ff00ff",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370d8",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "d87093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "ff0000",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    violetred: "d02090",
    wheat: "f5deb3",
    white: "ffffff",
    whitesmoke: "f5f5f5",
    yellow: "ffff00",
    yellowgreen: "9acd32"
  };
  a = e[a] || a;
  for (var t = [
    {
      re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
      example: ["rgba(123, 234, 45, 0.8)", "rgba(255,234,245,1.0)"],
      process: function(u) {
        return [
          parseInt(u[1]),
          parseInt(u[2]),
          parseInt(u[3]),
          parseFloat(u[4])
        ];
      }
    },
    {
      re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
      example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
      process: function(u) {
        return [
          parseInt(u[1]),
          parseInt(u[2]),
          parseInt(u[3])
        ];
      }
    },
    {
      re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      example: ["#00ff00", "336699"],
      process: function(u) {
        return [
          parseInt(u[1], 16),
          parseInt(u[2], 16),
          parseInt(u[3], 16)
        ];
      }
    },
    {
      re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      example: ["#fb0", "f0f"],
      process: function(u) {
        return [
          parseInt(u[1] + u[1], 16),
          parseInt(u[2] + u[2], 16),
          parseInt(u[3] + u[3], 16)
        ];
      }
    }
  ], r = 0; r < t.length; r++) {
    var i = t[r].re, n = t[r].process, o = i.exec(a);
    if (o) {
      var s = n(o);
      this.r = s[0], this.g = s[1], this.b = s[2], s.length > 3 && (this.alpha = s[3]), this.ok = !0;
    }
  }
  this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.alpha = this.alpha < 0 ? 0 : this.alpha > 1 || isNaN(this.alpha) ? 1 : this.alpha, this.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  }, this.toRGBA = function() {
    return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + this.alpha + ")";
  }, this.toHex = function() {
    var u = this.r.toString(16), l = this.g.toString(16), c = this.b.toString(16);
    return u.length == 1 && (u = "0" + u), l.length == 1 && (l = "0" + l), c.length == 1 && (c = "0" + c), "#" + u + l + c;
  }, this.getHelpXML = function() {
    for (var u = new Array(), l = 0; l < t.length; l++)
      for (var c = t[l].example, v = 0; v < c.length; v++)
        u[u.length] = c[v];
    for (var f in e)
      u[u.length] = f;
    var h = document.createElement("ul");
    h.setAttribute("id", "rgbcolor-examples");
    for (var l = 0; l < u.length; l++)
      try {
        var d = document.createElement("li"), g = new RGBColor(u[l]), p = document.createElement("div");
        p.style.cssText = "margin: 3px; border: 1px solid black; background:" + g.toHex() + "; color:" + g.toHex(), p.appendChild(document.createTextNode("test"));
        var y = document.createTextNode(
          " " + u[l] + " -> " + g.toRGB() + " -> " + g.toHex()
        );
        d.appendChild(p), d.appendChild(y), h.appendChild(d);
      } catch {
      }
    return h;
  };
};
const yi = /* @__PURE__ */ Mo(y1);
var m1 = ee, b1 = Rr, x1 = eu.indexOf, $1 = al, mi = b1([].indexOf), ol = !!mi && 1 / mi([1], 1, -0) < 0, T1 = ol || !$1("indexOf");
m1({ target: "Array", proto: !0, forced: T1 }, {
  indexOf: function(e) {
    var t = arguments.length > 1 ? arguments[1] : void 0;
    return ol ? mi(this, e, t) || 0 : x1(this, e, t);
  }
});
var O1 = ee, E1 = L, S1 = en, w1 = ge, uo = ye, C1 = tn, P1 = E1("".indexOf);
O1({ target: "String", proto: !0, forced: !C1("includes") }, {
  includes: function(e) {
    return !!~P1(
      uo(w1(this)),
      uo(S1(e)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
var A1 = je, R1 = Array.isArray || function(e) {
  return A1(e) === "Array";
};
var I1 = ee, N1 = L, M1 = R1, _1 = N1([].reverse), lo = [1, 2];
I1({ target: "Array", proto: !0, forced: String(lo) === String(lo.reverse()) }, {
  reverse: function() {
    return M1(this) && (this.length = this.length), _1(this);
  }
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var ul = function(a, e) {
  return (ul = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
  })(a, e);
};
function ll(a, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  function t() {
    this.constructor = a;
  }
  ul(a, e), a.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
function D1(a) {
  var e = "";
  Array.isArray(a) || (a = [a]);
  for (var t = 0; t < a.length; t++) {
    var r = a[t];
    if (r.type === m.CLOSE_PATH)
      e += "z";
    else if (r.type === m.HORIZ_LINE_TO)
      e += (r.relative ? "h" : "H") + r.x;
    else if (r.type === m.VERT_LINE_TO)
      e += (r.relative ? "v" : "V") + r.y;
    else if (r.type === m.MOVE_TO)
      e += (r.relative ? "m" : "M") + r.x + " " + r.y;
    else if (r.type === m.LINE_TO)
      e += (r.relative ? "l" : "L") + r.x + " " + r.y;
    else if (r.type === m.CURVE_TO)
      e += (r.relative ? "c" : "C") + r.x1 + " " + r.y1 + " " + r.x2 + " " + r.y2 + " " + r.x + " " + r.y;
    else if (r.type === m.SMOOTH_CURVE_TO)
      e += (r.relative ? "s" : "S") + r.x2 + " " + r.y2 + " " + r.x + " " + r.y;
    else if (r.type === m.QUAD_TO)
      e += (r.relative ? "q" : "Q") + r.x1 + " " + r.y1 + " " + r.x + " " + r.y;
    else if (r.type === m.SMOOTH_QUAD_TO)
      e += (r.relative ? "t" : "T") + r.x + " " + r.y;
    else {
      if (r.type !== m.ARC)
        throw new Error('Unexpected command type "' + r.type + '" at index ' + t + ".");
      e += (r.relative ? "a" : "A") + r.rX + " " + r.rY + " " + r.xRot + " " + +r.lArcFlag + " " + +r.sweepFlag + " " + r.x + " " + r.y;
    }
  }
  return e;
}
function bi(a, e) {
  var t = a[0], r = a[1];
  return [t * Math.cos(e) - r * Math.sin(e), t * Math.sin(e) + r * Math.cos(e)];
}
function oe() {
  for (var a = [], e = 0; e < arguments.length; e++)
    a[e] = arguments[e];
  for (var t = 0; t < a.length; t++)
    if (typeof a[t] != "number")
      throw new Error("assertNumbers arguments[" + t + "] is not a number. " + typeof a[t] + " == typeof " + a[t]);
  return !0;
}
var we = Math.PI;
function Ga(a, e, t) {
  a.lArcFlag = a.lArcFlag === 0 ? 0 : 1, a.sweepFlag = a.sweepFlag === 0 ? 0 : 1;
  var r = a.rX, i = a.rY, n = a.x, o = a.y;
  r = Math.abs(a.rX), i = Math.abs(a.rY);
  var s = bi([(e - n) / 2, (t - o) / 2], -a.xRot / 180 * we), u = s[0], l = s[1], c = Math.pow(u, 2) / Math.pow(r, 2) + Math.pow(l, 2) / Math.pow(i, 2);
  1 < c && (r *= Math.sqrt(c), i *= Math.sqrt(c)), a.rX = r, a.rY = i;
  var v = Math.pow(r, 2) * Math.pow(l, 2) + Math.pow(i, 2) * Math.pow(u, 2), f = (a.lArcFlag !== a.sweepFlag ? 1 : -1) * Math.sqrt(Math.max(0, (Math.pow(r, 2) * Math.pow(i, 2) - v) / v)), h = r * l / i * f, d = -i * u / r * f, g = bi([h, d], a.xRot / 180 * we);
  a.cX = g[0] + (e + n) / 2, a.cY = g[1] + (t + o) / 2, a.phi1 = Math.atan2((l - d) / i, (u - h) / r), a.phi2 = Math.atan2((-l - d) / i, (-u - h) / r), a.sweepFlag === 0 && a.phi2 > a.phi1 && (a.phi2 -= 2 * we), a.sweepFlag === 1 && a.phi2 < a.phi1 && (a.phi2 += 2 * we), a.phi1 *= 180 / we, a.phi2 *= 180 / we;
}
function co(a, e, t) {
  oe(a, e, t);
  var r = a * a + e * e - t * t;
  if (0 > r)
    return [];
  if (r === 0)
    return [[a * t / (a * a + e * e), e * t / (a * a + e * e)]];
  var i = Math.sqrt(r);
  return [[(a * t + e * i) / (a * a + e * e), (e * t - a * i) / (a * a + e * e)], [(a * t - e * i) / (a * a + e * e), (e * t + a * i) / (a * a + e * e)]];
}
var F, me = Math.PI / 180;
function ho(a, e, t) {
  return (1 - t) * a + t * e;
}
function vo(a, e, t, r) {
  return a + Math.cos(r / 180 * we) * e + Math.sin(r / 180 * we) * t;
}
function fo(a, e, t, r) {
  var i = 1e-6, n = e - a, o = t - e, s = 3 * n + 3 * (r - t) - 6 * o, u = 6 * (o - n), l = 3 * n;
  return Math.abs(s) < i ? [-l / u] : function(c, v, f) {
    f === void 0 && (f = 1e-6);
    var h = c * c / 4 - v;
    if (h < -f)
      return [];
    if (h <= f)
      return [-c / 2];
    var d = Math.sqrt(h);
    return [-c / 2 - d, -c / 2 + d];
  }(u / s, l / s, i);
}
function go(a, e, t, r, i) {
  var n = 1 - i;
  return a * (n * n * n) + e * (3 * n * n * i) + t * (3 * n * i * i) + r * (i * i * i);
}
(function(a) {
  function e() {
    return i(function(s, u, l) {
      return s.relative && (s.x1 !== void 0 && (s.x1 += u), s.y1 !== void 0 && (s.y1 += l), s.x2 !== void 0 && (s.x2 += u), s.y2 !== void 0 && (s.y2 += l), s.x !== void 0 && (s.x += u), s.y !== void 0 && (s.y += l), s.relative = !1), s;
    });
  }
  function t() {
    var s = NaN, u = NaN, l = NaN, c = NaN;
    return i(function(v, f, h) {
      return v.type & m.SMOOTH_CURVE_TO && (v.type = m.CURVE_TO, s = isNaN(s) ? f : s, u = isNaN(u) ? h : u, v.x1 = v.relative ? f - s : 2 * f - s, v.y1 = v.relative ? h - u : 2 * h - u), v.type & m.CURVE_TO ? (s = v.relative ? f + v.x2 : v.x2, u = v.relative ? h + v.y2 : v.y2) : (s = NaN, u = NaN), v.type & m.SMOOTH_QUAD_TO && (v.type = m.QUAD_TO, l = isNaN(l) ? f : l, c = isNaN(c) ? h : c, v.x1 = v.relative ? f - l : 2 * f - l, v.y1 = v.relative ? h - c : 2 * h - c), v.type & m.QUAD_TO ? (l = v.relative ? f + v.x1 : v.x1, c = v.relative ? h + v.y1 : v.y1) : (l = NaN, c = NaN), v;
    });
  }
  function r() {
    var s = NaN, u = NaN;
    return i(function(l, c, v) {
      if (l.type & m.SMOOTH_QUAD_TO && (l.type = m.QUAD_TO, s = isNaN(s) ? c : s, u = isNaN(u) ? v : u, l.x1 = l.relative ? c - s : 2 * c - s, l.y1 = l.relative ? v - u : 2 * v - u), l.type & m.QUAD_TO) {
        s = l.relative ? c + l.x1 : l.x1, u = l.relative ? v + l.y1 : l.y1;
        var f = l.x1, h = l.y1;
        l.type = m.CURVE_TO, l.x1 = ((l.relative ? 0 : c) + 2 * f) / 3, l.y1 = ((l.relative ? 0 : v) + 2 * h) / 3, l.x2 = (l.x + 2 * f) / 3, l.y2 = (l.y + 2 * h) / 3;
      } else
        s = NaN, u = NaN;
      return l;
    });
  }
  function i(s) {
    var u = 0, l = 0, c = NaN, v = NaN;
    return function(f) {
      if (isNaN(c) && !(f.type & m.MOVE_TO))
        throw new Error("path must start with moveto");
      var h = s(f, u, l, c, v);
      return f.type & m.CLOSE_PATH && (u = c, l = v), f.x !== void 0 && (u = f.relative ? u + f.x : f.x), f.y !== void 0 && (l = f.relative ? l + f.y : f.y), f.type & m.MOVE_TO && (c = u, v = l), h;
    };
  }
  function n(s, u, l, c, v, f) {
    return oe(s, u, l, c, v, f), i(function(h, d, g, p) {
      var y = h.x1, x = h.x2, b = h.relative && !isNaN(p), $ = h.x !== void 0 ? h.x : b ? 0 : d, S = h.y !== void 0 ? h.y : b ? 0 : g;
      function E(ne) {
        return ne * ne;
      }
      h.type & m.HORIZ_LINE_TO && u !== 0 && (h.type = m.LINE_TO, h.y = h.relative ? 0 : g), h.type & m.VERT_LINE_TO && l !== 0 && (h.type = m.LINE_TO, h.x = h.relative ? 0 : d), h.x !== void 0 && (h.x = h.x * s + S * l + (b ? 0 : v)), h.y !== void 0 && (h.y = $ * u + h.y * c + (b ? 0 : f)), h.x1 !== void 0 && (h.x1 = h.x1 * s + h.y1 * l + (b ? 0 : v)), h.y1 !== void 0 && (h.y1 = y * u + h.y1 * c + (b ? 0 : f)), h.x2 !== void 0 && (h.x2 = h.x2 * s + h.y2 * l + (b ? 0 : v)), h.y2 !== void 0 && (h.y2 = x * u + h.y2 * c + (b ? 0 : f));
      var T = s * c - u * l;
      if (h.xRot !== void 0 && (s !== 1 || u !== 0 || l !== 0 || c !== 1))
        if (T === 0)
          delete h.rX, delete h.rY, delete h.xRot, delete h.lArcFlag, delete h.sweepFlag, h.type = m.LINE_TO;
        else {
          var C = h.xRot * Math.PI / 180, N = Math.sin(C), _ = Math.cos(C), j = 1 / E(h.rX), A = 1 / E(h.rY), W = E(_) * j + E(N) * A, X = 2 * N * _ * (j - A), G = E(N) * j + E(_) * A, q = W * c * c - X * u * c + G * u * u, H = X * (s * c + u * l) - 2 * (W * l * c + G * s * u), K = W * l * l - X * s * l + G * s * s, R = (Math.atan2(H, q - K) + Math.PI) % Math.PI / 2, M = Math.sin(R), Z = Math.cos(R);
          h.rX = Math.abs(T) / Math.sqrt(q * E(Z) + H * M * Z + K * E(M)), h.rY = Math.abs(T) / Math.sqrt(q * E(M) - H * M * Z + K * E(Z)), h.xRot = 180 * R / Math.PI;
        }
      return h.sweepFlag !== void 0 && 0 > T && (h.sweepFlag = +!h.sweepFlag), h;
    });
  }
  function o() {
    return function(s) {
      var u = {};
      for (var l in s)
        u[l] = s[l];
      return u;
    };
  }
  a.ROUND = function(s) {
    function u(l) {
      return Math.round(l * s) / s;
    }
    return s === void 0 && (s = 1e13), oe(s), function(l) {
      return l.x1 !== void 0 && (l.x1 = u(l.x1)), l.y1 !== void 0 && (l.y1 = u(l.y1)), l.x2 !== void 0 && (l.x2 = u(l.x2)), l.y2 !== void 0 && (l.y2 = u(l.y2)), l.x !== void 0 && (l.x = u(l.x)), l.y !== void 0 && (l.y = u(l.y)), l.rX !== void 0 && (l.rX = u(l.rX)), l.rY !== void 0 && (l.rY = u(l.rY)), l;
    };
  }, a.TO_ABS = e, a.TO_REL = function() {
    return i(function(s, u, l) {
      return s.relative || (s.x1 !== void 0 && (s.x1 -= u), s.y1 !== void 0 && (s.y1 -= l), s.x2 !== void 0 && (s.x2 -= u), s.y2 !== void 0 && (s.y2 -= l), s.x !== void 0 && (s.x -= u), s.y !== void 0 && (s.y -= l), s.relative = !0), s;
    });
  }, a.NORMALIZE_HVZ = function(s, u, l) {
    return s === void 0 && (s = !0), u === void 0 && (u = !0), l === void 0 && (l = !0), i(function(c, v, f, h, d) {
      if (isNaN(h) && !(c.type & m.MOVE_TO))
        throw new Error("path must start with moveto");
      return u && c.type & m.HORIZ_LINE_TO && (c.type = m.LINE_TO, c.y = c.relative ? 0 : f), l && c.type & m.VERT_LINE_TO && (c.type = m.LINE_TO, c.x = c.relative ? 0 : v), s && c.type & m.CLOSE_PATH && (c.type = m.LINE_TO, c.x = c.relative ? h - v : h, c.y = c.relative ? d - f : d), c.type & m.ARC && (c.rX === 0 || c.rY === 0) && (c.type = m.LINE_TO, delete c.rX, delete c.rY, delete c.xRot, delete c.lArcFlag, delete c.sweepFlag), c;
    });
  }, a.NORMALIZE_ST = t, a.QT_TO_C = r, a.INFO = i, a.SANITIZE = function(s) {
    s === void 0 && (s = 0), oe(s);
    var u = NaN, l = NaN, c = NaN, v = NaN;
    return i(function(f, h, d, g, p) {
      var y = Math.abs, x = !1, b = 0, $ = 0;
      if (f.type & m.SMOOTH_CURVE_TO && (b = isNaN(u) ? 0 : h - u, $ = isNaN(l) ? 0 : d - l), f.type & (m.CURVE_TO | m.SMOOTH_CURVE_TO) ? (u = f.relative ? h + f.x2 : f.x2, l = f.relative ? d + f.y2 : f.y2) : (u = NaN, l = NaN), f.type & m.SMOOTH_QUAD_TO ? (c = isNaN(c) ? h : 2 * h - c, v = isNaN(v) ? d : 2 * d - v) : f.type & m.QUAD_TO ? (c = f.relative ? h + f.x1 : f.x1, v = f.relative ? d + f.y1 : f.y2) : (c = NaN, v = NaN), f.type & m.LINE_COMMANDS || f.type & m.ARC && (f.rX === 0 || f.rY === 0 || !f.lArcFlag) || f.type & m.CURVE_TO || f.type & m.SMOOTH_CURVE_TO || f.type & m.QUAD_TO || f.type & m.SMOOTH_QUAD_TO) {
        var S = f.x === void 0 ? 0 : f.relative ? f.x : f.x - h, E = f.y === void 0 ? 0 : f.relative ? f.y : f.y - d;
        b = isNaN(c) ? f.x1 === void 0 ? b : f.relative ? f.x : f.x1 - h : c - h, $ = isNaN(v) ? f.y1 === void 0 ? $ : f.relative ? f.y : f.y1 - d : v - d;
        var T = f.x2 === void 0 ? 0 : f.relative ? f.x : f.x2 - h, C = f.y2 === void 0 ? 0 : f.relative ? f.y : f.y2 - d;
        y(S) <= s && y(E) <= s && y(b) <= s && y($) <= s && y(T) <= s && y(C) <= s && (x = !0);
      }
      return f.type & m.CLOSE_PATH && y(h - g) <= s && y(d - p) <= s && (x = !0), x ? [] : f;
    });
  }, a.MATRIX = n, a.ROTATE = function(s, u, l) {
    u === void 0 && (u = 0), l === void 0 && (l = 0), oe(s, u, l);
    var c = Math.sin(s), v = Math.cos(s);
    return n(v, c, -c, v, u - u * v + l * c, l - u * c - l * v);
  }, a.TRANSLATE = function(s, u) {
    return u === void 0 && (u = 0), oe(s, u), n(1, 0, 0, 1, s, u);
  }, a.SCALE = function(s, u) {
    return u === void 0 && (u = s), oe(s, u), n(s, 0, 0, u, 0, 0);
  }, a.SKEW_X = function(s) {
    return oe(s), n(1, 0, Math.atan(s), 1, 0, 0);
  }, a.SKEW_Y = function(s) {
    return oe(s), n(1, Math.atan(s), 0, 1, 0, 0);
  }, a.X_AXIS_SYMMETRY = function(s) {
    return s === void 0 && (s = 0), oe(s), n(-1, 0, 0, 1, s, 0);
  }, a.Y_AXIS_SYMMETRY = function(s) {
    return s === void 0 && (s = 0), oe(s), n(1, 0, 0, -1, 0, s);
  }, a.A_TO_C = function() {
    return i(function(s, u, l) {
      return m.ARC === s.type ? function(c, v, f) {
        var h, d, g, p;
        c.cX || Ga(c, v, f);
        for (var y = Math.min(c.phi1, c.phi2), x = Math.max(c.phi1, c.phi2) - y, b = Math.ceil(x / 90), $ = new Array(b), S = v, E = f, T = 0; T < b; T++) {
          var C = ho(c.phi1, c.phi2, T / b), N = ho(c.phi1, c.phi2, (T + 1) / b), _ = N - C, j = 4 / 3 * Math.tan(_ * me / 4), A = [Math.cos(C * me) - j * Math.sin(C * me), Math.sin(C * me) + j * Math.cos(C * me)], W = A[0], X = A[1], G = [Math.cos(N * me), Math.sin(N * me)], q = G[0], H = G[1], K = [q + j * Math.sin(N * me), H - j * Math.cos(N * me)], R = K[0], M = K[1];
          $[T] = { relative: c.relative, type: m.CURVE_TO };
          var Z = function(ne, ve) {
            var Se = bi([ne * c.rX, ve * c.rY], c.xRot), He = Se[0], Dt = Se[1];
            return [c.cX + He, c.cY + Dt];
          };
          h = Z(W, X), $[T].x1 = h[0], $[T].y1 = h[1], d = Z(R, M), $[T].x2 = d[0], $[T].y2 = d[1], g = Z(q, H), $[T].x = g[0], $[T].y = g[1], c.relative && ($[T].x1 -= S, $[T].y1 -= E, $[T].x2 -= S, $[T].y2 -= E, $[T].x -= S, $[T].y -= E), S = (p = [$[T].x, $[T].y])[0], E = p[1];
        }
        return $;
      }(s, s.relative ? 0 : u, s.relative ? 0 : l) : s;
    });
  }, a.ANNOTATE_ARCS = function() {
    return i(function(s, u, l) {
      return s.relative && (u = 0, l = 0), m.ARC === s.type && Ga(s, u, l), s;
    });
  }, a.CLONE = o, a.CALCULATE_BOUNDS = function() {
    var s = function(f) {
      var h = {};
      for (var d in f)
        h[d] = f[d];
      return h;
    }, u = e(), l = r(), c = t(), v = i(function(f, h, d) {
      var g = c(l(u(s(f))));
      function p(M) {
        M > v.maxX && (v.maxX = M), M < v.minX && (v.minX = M);
      }
      function y(M) {
        M > v.maxY && (v.maxY = M), M < v.minY && (v.minY = M);
      }
      if (g.type & m.DRAWING_COMMANDS && (p(h), y(d)), g.type & m.HORIZ_LINE_TO && p(g.x), g.type & m.VERT_LINE_TO && y(g.y), g.type & m.LINE_TO && (p(g.x), y(g.y)), g.type & m.CURVE_TO) {
        p(g.x), y(g.y);
        for (var x = 0, b = fo(h, g.x1, g.x2, g.x); x < b.length; x++)
          0 < (R = b[x]) && 1 > R && p(go(h, g.x1, g.x2, g.x, R));
        for (var $ = 0, S = fo(d, g.y1, g.y2, g.y); $ < S.length; $++)
          0 < (R = S[$]) && 1 > R && y(go(d, g.y1, g.y2, g.y, R));
      }
      if (g.type & m.ARC) {
        p(g.x), y(g.y), Ga(g, h, d);
        for (var E = g.xRot / 180 * Math.PI, T = Math.cos(E) * g.rX, C = Math.sin(E) * g.rX, N = -Math.sin(E) * g.rY, _ = Math.cos(E) * g.rY, j = g.phi1 < g.phi2 ? [g.phi1, g.phi2] : -180 > g.phi2 ? [g.phi2 + 360, g.phi1 + 360] : [g.phi2, g.phi1], A = j[0], W = j[1], X = function(M) {
          var Z = M[0], ne = M[1], ve = 180 * Math.atan2(ne, Z) / Math.PI;
          return ve < A ? ve + 360 : ve;
        }, G = 0, q = co(N, -T, 0).map(X); G < q.length; G++)
          (R = q[G]) > A && R < W && p(vo(g.cX, T, N, R));
        for (var H = 0, K = co(_, -C, 0).map(X); H < K.length; H++) {
          var R;
          (R = K[H]) > A && R < W && y(vo(g.cY, C, _, R));
        }
      }
      return f;
    });
    return v.minX = 1 / 0, v.maxX = -1 / 0, v.minY = 1 / 0, v.maxY = -1 / 0, v;
  };
})(F || (F = {}));
var se, cl = function() {
  function a() {
  }
  return a.prototype.round = function(e) {
    return this.transform(F.ROUND(e));
  }, a.prototype.toAbs = function() {
    return this.transform(F.TO_ABS());
  }, a.prototype.toRel = function() {
    return this.transform(F.TO_REL());
  }, a.prototype.normalizeHVZ = function(e, t, r) {
    return this.transform(F.NORMALIZE_HVZ(e, t, r));
  }, a.prototype.normalizeST = function() {
    return this.transform(F.NORMALIZE_ST());
  }, a.prototype.qtToC = function() {
    return this.transform(F.QT_TO_C());
  }, a.prototype.aToC = function() {
    return this.transform(F.A_TO_C());
  }, a.prototype.sanitize = function(e) {
    return this.transform(F.SANITIZE(e));
  }, a.prototype.translate = function(e, t) {
    return this.transform(F.TRANSLATE(e, t));
  }, a.prototype.scale = function(e, t) {
    return this.transform(F.SCALE(e, t));
  }, a.prototype.rotate = function(e, t, r) {
    return this.transform(F.ROTATE(e, t, r));
  }, a.prototype.matrix = function(e, t, r, i, n, o) {
    return this.transform(F.MATRIX(e, t, r, i, n, o));
  }, a.prototype.skewX = function(e) {
    return this.transform(F.SKEW_X(e));
  }, a.prototype.skewY = function(e) {
    return this.transform(F.SKEW_Y(e));
  }, a.prototype.xSymmetry = function(e) {
    return this.transform(F.X_AXIS_SYMMETRY(e));
  }, a.prototype.ySymmetry = function(e) {
    return this.transform(F.Y_AXIS_SYMMETRY(e));
  }, a.prototype.annotateArcs = function() {
    return this.transform(F.ANNOTATE_ARCS());
  }, a;
}(), V1 = function(a) {
  return a === " " || a === "	" || a === "\r" || a === `
`;
}, po = function(a) {
  return 48 <= a.charCodeAt(0) && a.charCodeAt(0) <= 57;
}, k1 = function(a) {
  function e() {
    var t = a.call(this) || this;
    return t.curNumber = "", t.curCommandType = -1, t.curCommandRelative = !1, t.canParseCommandOrComma = !0, t.curNumberHasExp = !1, t.curNumberHasExpDigits = !1, t.curNumberHasDecimal = !1, t.curArgs = [], t;
  }
  return ll(e, a), e.prototype.finish = function(t) {
    if (t === void 0 && (t = []), this.parse(" ", t), this.curArgs.length !== 0 || !this.canParseCommandOrComma)
      throw new SyntaxError("Unterminated command at the path end.");
    return t;
  }, e.prototype.parse = function(t, r) {
    var i = this;
    r === void 0 && (r = []);
    for (var n = function(v) {
      r.push(v), i.curArgs.length = 0, i.canParseCommandOrComma = !0;
    }, o = 0; o < t.length; o++) {
      var s = t[o], u = !(this.curCommandType !== m.ARC || this.curArgs.length !== 3 && this.curArgs.length !== 4 || this.curNumber.length !== 1 || this.curNumber !== "0" && this.curNumber !== "1"), l = po(s) && (this.curNumber === "0" && s === "0" || u);
      if (!po(s) || l)
        if (s !== "e" && s !== "E")
          if (s !== "-" && s !== "+" || !this.curNumberHasExp || this.curNumberHasExpDigits)
            if (s !== "." || this.curNumberHasExp || this.curNumberHasDecimal || u) {
              if (this.curNumber && this.curCommandType !== -1) {
                var c = Number(this.curNumber);
                if (isNaN(c))
                  throw new SyntaxError("Invalid number ending at " + o);
                if (this.curCommandType === m.ARC) {
                  if (this.curArgs.length === 0 || this.curArgs.length === 1) {
                    if (0 > c)
                      throw new SyntaxError('Expected positive number, got "' + c + '" at index "' + o + '"');
                  } else if ((this.curArgs.length === 3 || this.curArgs.length === 4) && this.curNumber !== "0" && this.curNumber !== "1")
                    throw new SyntaxError('Expected a flag, got "' + this.curNumber + '" at index "' + o + '"');
                }
                this.curArgs.push(c), this.curArgs.length === L1[this.curCommandType] && (m.HORIZ_LINE_TO === this.curCommandType ? n({ type: m.HORIZ_LINE_TO, relative: this.curCommandRelative, x: c }) : m.VERT_LINE_TO === this.curCommandType ? n({ type: m.VERT_LINE_TO, relative: this.curCommandRelative, y: c }) : this.curCommandType === m.MOVE_TO || this.curCommandType === m.LINE_TO || this.curCommandType === m.SMOOTH_QUAD_TO ? (n({ type: this.curCommandType, relative: this.curCommandRelative, x: this.curArgs[0], y: this.curArgs[1] }), m.MOVE_TO === this.curCommandType && (this.curCommandType = m.LINE_TO)) : this.curCommandType === m.CURVE_TO ? n({ type: m.CURVE_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x2: this.curArgs[2], y2: this.curArgs[3], x: this.curArgs[4], y: this.curArgs[5] }) : this.curCommandType === m.SMOOTH_CURVE_TO ? n({ type: m.SMOOTH_CURVE_TO, relative: this.curCommandRelative, x2: this.curArgs[0], y2: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === m.QUAD_TO ? n({ type: m.QUAD_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === m.ARC && n({ type: m.ARC, relative: this.curCommandRelative, rX: this.curArgs[0], rY: this.curArgs[1], xRot: this.curArgs[2], lArcFlag: this.curArgs[3], sweepFlag: this.curArgs[4], x: this.curArgs[5], y: this.curArgs[6] })), this.curNumber = "", this.curNumberHasExpDigits = !1, this.curNumberHasExp = !1, this.curNumberHasDecimal = !1, this.canParseCommandOrComma = !0;
              }
              if (!V1(s))
                if (s === "," && this.canParseCommandOrComma)
                  this.canParseCommandOrComma = !1;
                else if (s !== "+" && s !== "-" && s !== ".")
                  if (l)
                    this.curNumber = s, this.curNumberHasDecimal = !1;
                  else {
                    if (this.curArgs.length !== 0)
                      throw new SyntaxError("Unterminated command at index " + o + ".");
                    if (!this.canParseCommandOrComma)
                      throw new SyntaxError('Unexpected character "' + s + '" at index ' + o + ". Command cannot follow comma");
                    if (this.canParseCommandOrComma = !1, s !== "z" && s !== "Z")
                      if (s === "h" || s === "H")
                        this.curCommandType = m.HORIZ_LINE_TO, this.curCommandRelative = s === "h";
                      else if (s === "v" || s === "V")
                        this.curCommandType = m.VERT_LINE_TO, this.curCommandRelative = s === "v";
                      else if (s === "m" || s === "M")
                        this.curCommandType = m.MOVE_TO, this.curCommandRelative = s === "m";
                      else if (s === "l" || s === "L")
                        this.curCommandType = m.LINE_TO, this.curCommandRelative = s === "l";
                      else if (s === "c" || s === "C")
                        this.curCommandType = m.CURVE_TO, this.curCommandRelative = s === "c";
                      else if (s === "s" || s === "S")
                        this.curCommandType = m.SMOOTH_CURVE_TO, this.curCommandRelative = s === "s";
                      else if (s === "q" || s === "Q")
                        this.curCommandType = m.QUAD_TO, this.curCommandRelative = s === "q";
                      else if (s === "t" || s === "T")
                        this.curCommandType = m.SMOOTH_QUAD_TO, this.curCommandRelative = s === "t";
                      else {
                        if (s !== "a" && s !== "A")
                          throw new SyntaxError('Unexpected character "' + s + '" at index ' + o + ".");
                        this.curCommandType = m.ARC, this.curCommandRelative = s === "a";
                      }
                    else
                      r.push({ type: m.CLOSE_PATH }), this.canParseCommandOrComma = !0, this.curCommandType = -1;
                  }
                else
                  this.curNumber = s, this.curNumberHasDecimal = s === ".";
            } else
              this.curNumber += s, this.curNumberHasDecimal = !0;
          else
            this.curNumber += s;
        else
          this.curNumber += s, this.curNumberHasExp = !0;
      else
        this.curNumber += s, this.curNumberHasExpDigits = this.curNumberHasExp;
    }
    return r;
  }, e.prototype.transform = function(t) {
    return Object.create(this, { parse: { value: function(r, i) {
      i === void 0 && (i = []);
      for (var n = 0, o = Object.getPrototypeOf(this).parse.call(this, r); n < o.length; n++) {
        var s = o[n], u = t(s);
        Array.isArray(u) ? i.push.apply(i, u) : i.push(u);
      }
      return i;
    } } });
  }, e;
}(cl), m = function(a) {
  function e(t) {
    var r = a.call(this) || this;
    return r.commands = typeof t == "string" ? e.parse(t) : t, r;
  }
  return ll(e, a), e.prototype.encode = function() {
    return e.encode(this.commands);
  }, e.prototype.getBounds = function() {
    var t = F.CALCULATE_BOUNDS();
    return this.transform(t), t;
  }, e.prototype.transform = function(t) {
    for (var r = [], i = 0, n = this.commands; i < n.length; i++) {
      var o = t(n[i]);
      Array.isArray(o) ? r.push.apply(r, o) : r.push(o);
    }
    return this.commands = r, this;
  }, e.encode = function(t) {
    return D1(t);
  }, e.parse = function(t) {
    var r = new k1(), i = [];
    return r.parse(t, i), r.finish(i), i;
  }, e.CLOSE_PATH = 1, e.MOVE_TO = 2, e.HORIZ_LINE_TO = 4, e.VERT_LINE_TO = 8, e.LINE_TO = 16, e.CURVE_TO = 32, e.SMOOTH_CURVE_TO = 64, e.QUAD_TO = 128, e.SMOOTH_QUAD_TO = 256, e.ARC = 512, e.LINE_COMMANDS = e.LINE_TO | e.HORIZ_LINE_TO | e.VERT_LINE_TO, e.DRAWING_COMMANDS = e.HORIZ_LINE_TO | e.VERT_LINE_TO | e.LINE_TO | e.CURVE_TO | e.SMOOTH_CURVE_TO | e.QUAD_TO | e.SMOOTH_QUAD_TO | e.ARC, e;
}(cl), L1 = ((se = {})[m.MOVE_TO] = 2, se[m.LINE_TO] = 2, se[m.HORIZ_LINE_TO] = 1, se[m.VERT_LINE_TO] = 1, se[m.CLOSE_PATH] = 0, se[m.QUAD_TO] = 4, se[m.SMOOTH_QUAD_TO] = 2, se[m.CURVE_TO] = 6, se[m.SMOOTH_CURVE_TO] = 4, se[m.ARC] = 7, se);
var B1 = Y, j1 = ce, U1 = $r, F1 = ju, yo = RegExp.prototype, G1 = function(a) {
  var e = a.flags;
  return e === void 0 && !("flags" in yo) && !j1(a, "flags") && U1(yo, a) ? B1(F1, a) : e;
};
var z1 = wr.PROPER, H1 = Ge, Y1 = Q, mo = ye, W1 = k, X1 = G1, nn = "toString", hl = RegExp.prototype, vl = hl[nn], q1 = W1(function() {
  return vl.call({ source: "a", flags: "b" }) !== "/a/b";
}), K1 = z1 && vl.name !== nn;
(q1 || K1) && H1(hl, nn, function() {
  var e = Y1(this), t = mo(e.source), r = mo(X1(e));
  return "/" + t + "/" + r;
}, { unsafe: !0 });
function fr(a) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? fr = function(e) {
    return typeof e;
  } : fr = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, fr(a);
}
function Q1(a, e) {
  if (!(a instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var Z1 = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259], J1 = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];
function eb(a, e, t, r, i) {
  if (typeof a == "string" && (a = document.getElementById(a)), !a || fr(a) !== "object" || !("getContext" in a))
    throw new TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
  var n = a.getContext("2d");
  try {
    return n.getImageData(e, t, r, i);
  } catch (o) {
    throw new Error("unable to access image data: " + o);
  }
}
function tb(a, e, t, r, i, n) {
  if (!(isNaN(n) || n < 1)) {
    n |= 0;
    var o = eb(a, e, t, r, i);
    o = rb(o, e, t, r, i, n), a.getContext("2d").putImageData(o, e, t);
  }
}
function rb(a, e, t, r, i, n) {
  for (var o = a.data, s = 2 * n + 1, u = r - 1, l = i - 1, c = n + 1, v = c * (c + 1) / 2, f = new bo(), h = f, d, g = 1; g < s; g++)
    h = h.next = new bo(), g === c && (d = h);
  h.next = f;
  for (var p = null, y = null, x = 0, b = 0, $ = Z1[n], S = J1[n], E = 0; E < i; E++) {
    h = f;
    for (var T = o[b], C = o[b + 1], N = o[b + 2], _ = o[b + 3], j = 0; j < c; j++)
      h.r = T, h.g = C, h.b = N, h.a = _, h = h.next;
    for (var A = 0, W = 0, X = 0, G = 0, q = c * T, H = c * C, K = c * N, R = c * _, M = v * T, Z = v * C, ne = v * N, ve = v * _, Se = 1; Se < c; Se++) {
      var He = b + ((u < Se ? u : Se) << 2), Dt = o[He], un = o[He + 1], ln = o[He + 2], cn = o[He + 3], Vt = c - Se;
      M += (h.r = Dt) * Vt, Z += (h.g = un) * Vt, ne += (h.b = ln) * Vt, ve += (h.a = cn) * Vt, A += Dt, W += un, X += ln, G += cn, h = h.next;
    }
    p = f, y = d;
    for (var Br = 0; Br < r; Br++) {
      var jr = ve * $ >>> S;
      if (o[b + 3] = jr, jr !== 0) {
        var Ur = 255 / jr;
        o[b] = (M * $ >>> S) * Ur, o[b + 1] = (Z * $ >>> S) * Ur, o[b + 2] = (ne * $ >>> S) * Ur;
      } else
        o[b] = o[b + 1] = o[b + 2] = 0;
      M -= q, Z -= H, ne -= K, ve -= R, q -= p.r, H -= p.g, K -= p.b, R -= p.a;
      var Re = Br + n + 1;
      Re = x + (Re < u ? Re : u) << 2, A += p.r = o[Re], W += p.g = o[Re + 1], X += p.b = o[Re + 2], G += p.a = o[Re + 3], M += A, Z += W, ne += X, ve += G, p = p.next;
      var kt = y, hn = kt.r, vn = kt.g, fn = kt.b, gn = kt.a;
      q += hn, H += vn, K += fn, R += gn, A -= hn, W -= vn, X -= fn, G -= gn, y = y.next, b += 4;
    }
    x += r;
  }
  for (var Ye = 0; Ye < r; Ye++) {
    b = Ye << 2;
    var Ie = o[b], Ne = o[b + 1], Me = o[b + 2], te = o[b + 3], Fr = c * Ie, Gr = c * Ne, zr = c * Me, Hr = c * te, Lt = v * Ie, Bt = v * Ne, jt = v * Me, Ut = v * te;
    h = f;
    for (var dn = 0; dn < c; dn++)
      h.r = Ie, h.g = Ne, h.b = Me, h.a = te, h = h.next;
    for (var pn = r, Yr = 0, Wr = 0, Xr = 0, qr = 0, Ft = 1; Ft <= n; Ft++) {
      b = pn + Ye << 2;
      var Gt = c - Ft;
      Lt += (h.r = Ie = o[b]) * Gt, Bt += (h.g = Ne = o[b + 1]) * Gt, jt += (h.b = Me = o[b + 2]) * Gt, Ut += (h.a = te = o[b + 3]) * Gt, qr += Ie, Yr += Ne, Wr += Me, Xr += te, h = h.next, Ft < l && (pn += r);
    }
    b = Ye, p = f, y = d;
    for (var Kr = 0; Kr < i; Kr++) {
      var re = b << 2;
      o[re + 3] = te = Ut * $ >>> S, te > 0 ? (te = 255 / te, o[re] = (Lt * $ >>> S) * te, o[re + 1] = (Bt * $ >>> S) * te, o[re + 2] = (jt * $ >>> S) * te) : o[re] = o[re + 1] = o[re + 2] = 0, Lt -= Fr, Bt -= Gr, jt -= zr, Ut -= Hr, Fr -= p.r, Gr -= p.g, zr -= p.b, Hr -= p.a, re = Ye + ((re = Kr + c) < l ? re : l) * r << 2, Lt += qr += p.r = o[re], Bt += Yr += p.g = o[re + 1], jt += Wr += p.b = o[re + 2], Ut += Xr += p.a = o[re + 3], p = p.next, Fr += Ie = y.r, Gr += Ne = y.g, zr += Me = y.b, Hr += te = y.a, qr -= Ie, Yr -= Ne, Wr -= Me, Xr -= te, y = y.next, b += r;
    }
  }
  return a;
}
var bo = (
  /**
   * Set properties.
   */
  function a() {
    Q1(this, a), this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
  }
);
function ab() {
  var {
    DOMParser: a
  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = {
    window: null,
    ignoreAnimation: !0,
    ignoreMouse: !0,
    DOMParser: a,
    createCanvas(t, r) {
      return new OffscreenCanvas(t, r);
    },
    createImage(t) {
      return Te(function* () {
        var r = yield fetch(t), i = yield r.blob(), n = yield createImageBitmap(i);
        return n;
      })();
    }
  };
  return (typeof DOMParser < "u" || typeof a > "u") && Reflect.deleteProperty(e, "DOMParser"), e;
}
function ib(a) {
  var {
    DOMParser: e,
    canvas: t,
    fetch: r
  } = a;
  return {
    window: null,
    ignoreAnimation: !0,
    ignoreMouse: !0,
    DOMParser: e,
    fetch: r,
    createCanvas: t.createCanvas,
    createImage: t.loadImage
  };
}
var R2 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  offscreen: ab,
  node: ib
});
function vt(a) {
  return a.replace(/(?!\u3000)\s+/gm, " ");
}
function nb(a) {
  return a.replace(/^[\n \t]+/, "");
}
function sb(a) {
  return a.replace(/[\n \t]+$/, "");
}
function ie(a) {
  var e = (a || "").match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm) || [];
  return e.map(parseFloat);
}
var ob = /^[A-Z-]+$/;
function ub(a) {
  return ob.test(a) ? a.toLowerCase() : a;
}
function fl(a) {
  var e = /url\(('([^']+)'|"([^"]+)"|([^'")]+))\)/.exec(a) || [];
  return e[2] || e[3] || e[4];
}
function lb(a) {
  if (!a.startsWith("rgb"))
    return a;
  var e = 3, t = a.replace(/\d+(\.\d+)?/g, (r, i) => e-- && i ? String(Math.round(parseFloat(r))) : r);
  return t;
}
var cb = /(\[[^\]]+\])/g, hb = /(#[^\s+>~.[:]+)/g, vb = /(\.[^\s+>~.[:]+)/g, fb = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi, gb = /(:[\w-]+\([^)]*\))/gi, db = /(:[^\s+>~.[:]+)/g, pb = /([^\s+>~.[:]+)/g;
function Ve(a, e) {
  var t = e.exec(a);
  return t ? [a.replace(e, " "), t.length] : [a, 0];
}
function yb(a) {
  var e = [0, 0, 0], t = a.replace(/:not\(([^)]*)\)/g, "     $1 ").replace(/{[\s\S]*/gm, " "), r = 0;
  return [t, r] = Ve(t, cb), e[1] += r, [t, r] = Ve(t, hb), e[0] += r, [t, r] = Ve(t, vb), e[1] += r, [t, r] = Ve(t, fb), e[2] += r, [t, r] = Ve(t, gb), e[1] += r, [t, r] = Ve(t, db), e[1] += r, t = t.replace(/[*\s+>~]/g, " ").replace(/[#.]/g, " "), [t, r] = Ve(t, pb), e[2] += r, e.join("");
}
var nt = 1e-8;
function xo(a) {
  return Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2));
}
function xi(a, e) {
  return (a[0] * e[0] + a[1] * e[1]) / (xo(a) * xo(e));
}
function $o(a, e) {
  return (a[0] * e[1] < a[1] * e[0] ? -1 : 1) * Math.acos(xi(a, e));
}
function To(a) {
  return a * a * a;
}
function Oo(a) {
  return 3 * a * a * (1 - a);
}
function Eo(a) {
  return 3 * a * (1 - a) * (1 - a);
}
function So(a) {
  return (1 - a) * (1 - a) * (1 - a);
}
function wo(a) {
  return a * a;
}
function Co(a) {
  return 2 * a * (1 - a);
}
function Po(a) {
  return (1 - a) * (1 - a);
}
class O {
  constructor(e, t, r) {
    this.document = e, this.name = t, this.value = r, this.isNormalizedColor = !1;
  }
  static empty(e) {
    return new O(e, "EMPTY", "");
  }
  split() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ", {
      document: t,
      name: r
    } = this;
    return vt(this.getString()).trim().split(e).map((i) => new O(t, r, i));
  }
  hasValue(e) {
    var {
      value: t
    } = this;
    return t !== null && t !== "" && (e || t !== 0) && typeof t < "u";
  }
  isString(e) {
    var {
      value: t
    } = this, r = typeof t == "string";
    return !r || !e ? r : e.test(t);
  }
  isUrlDefinition() {
    return this.isString(/^url\(/);
  }
  isPixels() {
    if (!this.hasValue())
      return !1;
    var e = this.getString();
    switch (!0) {
      case e.endsWith("px"):
      case /^[0-9]+$/.test(e):
        return !0;
      default:
        return !1;
    }
  }
  setValue(e) {
    return this.value = e, this;
  }
  getValue(e) {
    return typeof e > "u" || this.hasValue() ? this.value : e;
  }
  getNumber(e) {
    if (!this.hasValue())
      return typeof e > "u" ? 0 : parseFloat(e);
    var {
      value: t
    } = this, r = parseFloat(t);
    return this.isString(/%$/) && (r /= 100), r;
  }
  getString(e) {
    return typeof e > "u" || this.hasValue() ? typeof this.value > "u" ? "" : String(this.value) : String(e);
  }
  getColor(e) {
    var t = this.getString(e);
    return this.isNormalizedColor || (this.isNormalizedColor = !0, t = lb(t), this.value = t), t;
  }
  getDpi() {
    return 96;
  }
  getRem() {
    return this.document.rootEmSize;
  }
  getEm() {
    return this.document.emSize;
  }
  getUnits() {
    return this.getString().replace(/[0-9.-]/g, "");
  }
  getPixels(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (!this.hasValue())
      return 0;
    var [r, i] = typeof e == "boolean" ? [void 0, e] : [e], {
      viewPort: n
    } = this.document.screen;
    switch (!0) {
      case this.isString(/vmin$/):
        return this.getNumber() / 100 * Math.min(n.computeSize("x"), n.computeSize("y"));
      case this.isString(/vmax$/):
        return this.getNumber() / 100 * Math.max(n.computeSize("x"), n.computeSize("y"));
      case this.isString(/vw$/):
        return this.getNumber() / 100 * n.computeSize("x");
      case this.isString(/vh$/):
        return this.getNumber() / 100 * n.computeSize("y");
      case this.isString(/rem$/):
        return this.getNumber() * this.getRem();
      case this.isString(/em$/):
        return this.getNumber() * this.getEm();
      case this.isString(/ex$/):
        return this.getNumber() * this.getEm() / 2;
      case this.isString(/px$/):
        return this.getNumber();
      case this.isString(/pt$/):
        return this.getNumber() * this.getDpi() * (1 / 72);
      case this.isString(/pc$/):
        return this.getNumber() * 15;
      case this.isString(/cm$/):
        return this.getNumber() * this.getDpi() / 2.54;
      case this.isString(/mm$/):
        return this.getNumber() * this.getDpi() / 25.4;
      case this.isString(/in$/):
        return this.getNumber() * this.getDpi();
      case (this.isString(/%$/) && i):
        return this.getNumber() * this.getEm();
      case this.isString(/%$/):
        return this.getNumber() * n.computeSize(r);
      default: {
        var o = this.getNumber();
        return t && o < 1 ? o * n.computeSize(r) : o;
      }
    }
  }
  getMilliseconds() {
    return this.hasValue() ? this.isString(/ms$/) ? this.getNumber() : this.getNumber() * 1e3 : 0;
  }
  getRadians() {
    if (!this.hasValue())
      return 0;
    switch (!0) {
      case this.isString(/deg$/):
        return this.getNumber() * (Math.PI / 180);
      case this.isString(/grad$/):
        return this.getNumber() * (Math.PI / 200);
      case this.isString(/rad$/):
        return this.getNumber();
      default:
        return this.getNumber() * (Math.PI / 180);
    }
  }
  getDefinition() {
    var e = this.getString(), t = /#([^)'"]+)/.exec(e);
    return t && (t = t[1]), t || (t = e), this.document.definitions[t];
  }
  getFillStyleDefinition(e, t) {
    var r = this.getDefinition();
    if (!r)
      return null;
    if (typeof r.createGradient == "function")
      return r.createGradient(this.document.ctx, e, t);
    if (typeof r.createPattern == "function") {
      if (r.getHrefAttribute().hasValue()) {
        var i = r.getAttribute("patternTransform");
        r = r.getHrefAttribute().getDefinition(), i.hasValue() && r.getAttribute("patternTransform", !0).setValue(i.value);
      }
      return r.createPattern(this.document.ctx, e, t);
    }
    return null;
  }
  getTextBaseline() {
    return this.hasValue() ? O.textBaselineMapping[this.getString()] : null;
  }
  addOpacity(e) {
    for (var t = this.getColor(), r = t.length, i = 0, n = 0; n < r && (t[n] === "," && i++, i !== 3); n++)
      ;
    if (e.hasValue() && this.isString() && i !== 3) {
      var o = new yi(t);
      o.ok && (o.alpha = e.getNumber(), t = o.toRGBA());
    }
    return new O(this.document, this.name, t);
  }
}
O.textBaselineMapping = {
  baseline: "alphabetic",
  "before-edge": "top",
  "text-before-edge": "top",
  middle: "middle",
  central: "middle",
  "after-edge": "bottom",
  "text-after-edge": "bottom",
  ideographic: "ideographic",
  alphabetic: "alphabetic",
  hanging: "hanging",
  mathematical: "alphabetic"
};
class mb {
  constructor() {
    this.viewPorts = [];
  }
  clear() {
    this.viewPorts = [];
  }
  setCurrent(e, t) {
    this.viewPorts.push({
      width: e,
      height: t
    });
  }
  removeCurrent() {
    this.viewPorts.pop();
  }
  getCurrent() {
    var {
      viewPorts: e
    } = this;
    return e[e.length - 1];
  }
  get width() {
    return this.getCurrent().width;
  }
  get height() {
    return this.getCurrent().height;
  }
  computeSize(e) {
    return typeof e == "number" ? e : e === "x" ? this.width : e === "y" ? this.height : Math.sqrt(Math.pow(this.width, 2) + Math.pow(this.height, 2)) / Math.sqrt(2);
  }
}
class D {
  constructor(e, t) {
    this.x = e, this.y = t;
  }
  static parse(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, [r = t, i = t] = ie(e);
    return new D(r, i);
  }
  static parseScale(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, [r = t, i = r] = ie(e);
    return new D(r, i);
  }
  static parsePath(e) {
    for (var t = ie(e), r = t.length, i = [], n = 0; n < r; n += 2)
      i.push(new D(t[n], t[n + 1]));
    return i;
  }
  angleTo(e) {
    return Math.atan2(e.y - this.y, e.x - this.x);
  }
  applyTransform(e) {
    var {
      x: t,
      y: r
    } = this, i = t * e[0] + r * e[2] + e[4], n = t * e[1] + r * e[3] + e[5];
    this.x = i, this.y = n;
  }
}
class bb {
  constructor(e) {
    this.screen = e, this.working = !1, this.events = [], this.eventElements = [], this.onClick = this.onClick.bind(this), this.onMouseMove = this.onMouseMove.bind(this);
  }
  isWorking() {
    return this.working;
  }
  start() {
    if (!this.working) {
      var {
        screen: e,
        onClick: t,
        onMouseMove: r
      } = this, i = e.ctx.canvas;
      i.onclick = t, i.onmousemove = r, this.working = !0;
    }
  }
  stop() {
    if (this.working) {
      var e = this.screen.ctx.canvas;
      this.working = !1, e.onclick = null, e.onmousemove = null;
    }
  }
  hasEvents() {
    return this.working && this.events.length > 0;
  }
  runEvents() {
    if (this.working) {
      var {
        screen: e,
        events: t,
        eventElements: r
      } = this, {
        style: i
      } = e.ctx.canvas;
      i && (i.cursor = ""), t.forEach((n, o) => {
        for (var {
          run: s
        } = n, u = r[o]; u; )
          s(u), u = u.parent;
      }), this.events = [], this.eventElements = [];
    }
  }
  checkPath(e, t) {
    if (!(!this.working || !t)) {
      var {
        events: r,
        eventElements: i
      } = this;
      r.forEach((n, o) => {
        var {
          x: s,
          y: u
        } = n;
        !i[o] && t.isPointInPath && t.isPointInPath(s, u) && (i[o] = e);
      });
    }
  }
  checkBoundingBox(e, t) {
    if (!(!this.working || !t)) {
      var {
        events: r,
        eventElements: i
      } = this;
      r.forEach((n, o) => {
        var {
          x: s,
          y: u
        } = n;
        !i[o] && t.isPointInBox(s, u) && (i[o] = e);
      });
    }
  }
  mapXY(e, t) {
    for (var {
      window: r,
      ctx: i
    } = this.screen, n = new D(e, t), o = i.canvas; o; )
      n.x -= o.offsetLeft, n.y -= o.offsetTop, o = o.offsetParent;
    return r.scrollX && (n.x += r.scrollX), r.scrollY && (n.y += r.scrollY), n;
  }
  onClick(e) {
    var {
      x: t,
      y: r
    } = this.mapXY(e.clientX, e.clientY);
    this.events.push({
      type: "onclick",
      x: t,
      y: r,
      run(i) {
        i.onClick && i.onClick();
      }
    });
  }
  onMouseMove(e) {
    var {
      x: t,
      y: r
    } = this.mapXY(e.clientX, e.clientY);
    this.events.push({
      type: "onmousemove",
      x: t,
      y: r,
      run(i) {
        i.onMouseMove && i.onMouseMove();
      }
    });
  }
}
var gl = typeof window < "u" ? window : null, dl = typeof fetch < "u" ? fetch.bind(void 0) : null;
class Dr {
  constructor(e) {
    var {
      fetch: t = dl,
      window: r = gl
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.ctx = e, this.FRAMERATE = 30, this.MAX_VIRTUAL_PIXELS = 3e4, this.CLIENT_WIDTH = 800, this.CLIENT_HEIGHT = 600, this.viewPort = new mb(), this.mouse = new bb(this), this.animations = [], this.waits = [], this.frameDuration = 0, this.isReadyLock = !1, this.isFirstRender = !0, this.intervalId = null, this.window = r, this.fetch = t;
  }
  wait(e) {
    this.waits.push(e);
  }
  ready() {
    return this.readyPromise ? this.readyPromise : Promise.resolve();
  }
  isReady() {
    if (this.isReadyLock)
      return !0;
    var e = this.waits.every((t) => t());
    return e && (this.waits = [], this.resolveReady && this.resolveReady()), this.isReadyLock = e, e;
  }
  setDefaults(e) {
    e.strokeStyle = "rgba(0,0,0,0)", e.lineCap = "butt", e.lineJoin = "miter", e.miterLimit = 4;
  }
  setViewBox(e) {
    var {
      document: t,
      ctx: r,
      aspectRatio: i,
      width: n,
      desiredWidth: o,
      height: s,
      desiredHeight: u,
      minX: l = 0,
      minY: c = 0,
      refX: v,
      refY: f,
      clip: h = !1,
      clipX: d = 0,
      clipY: g = 0
    } = e, p = vt(i).replace(/^defer\s/, ""), [y, x] = p.split(" "), b = y || "xMidYMid", $ = x || "meet", S = n / o, E = s / u, T = Math.min(S, E), C = Math.max(S, E), N = o, _ = u;
    $ === "meet" && (N *= T, _ *= T), $ === "slice" && (N *= C, _ *= C);
    var j = new O(t, "refX", v), A = new O(t, "refY", f), W = j.hasValue() && A.hasValue();
    if (W && r.translate(-T * j.getPixels("x"), -T * A.getPixels("y")), h) {
      var X = T * d, G = T * g;
      r.beginPath(), r.moveTo(X, G), r.lineTo(n, G), r.lineTo(n, s), r.lineTo(X, s), r.closePath(), r.clip();
    }
    if (!W) {
      var q = $ === "meet" && T === E, H = $ === "slice" && C === E, K = $ === "meet" && T === S, R = $ === "slice" && C === S;
      b.startsWith("xMid") && (q || H) && r.translate(n / 2 - N / 2, 0), b.endsWith("YMid") && (K || R) && r.translate(0, s / 2 - _ / 2), b.startsWith("xMax") && (q || H) && r.translate(n - N, 0), b.endsWith("YMax") && (K || R) && r.translate(0, s - _);
    }
    switch (!0) {
      case b === "none":
        r.scale(S, E);
        break;
      case $ === "meet":
        r.scale(T, T);
        break;
      case $ === "slice":
        r.scale(C, C);
        break;
    }
    r.translate(-l, -c);
  }
  start(e) {
    var {
      enableRedraw: t = !1,
      ignoreMouse: r = !1,
      ignoreAnimation: i = !1,
      ignoreDimensions: n = !1,
      ignoreClear: o = !1,
      forceRedraw: s,
      scaleWidth: u,
      scaleHeight: l,
      offsetX: c,
      offsetY: v
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      FRAMERATE: f,
      mouse: h
    } = this, d = 1e3 / f;
    if (this.frameDuration = d, this.readyPromise = new Promise((b) => {
      this.resolveReady = b;
    }), this.isReady() && this.render(e, n, o, u, l, c, v), !!t) {
      var g = Date.now(), p = g, y = 0, x = () => {
        g = Date.now(), y = g - p, y >= d && (p = g - y % d, this.shouldUpdate(i, s) && (this.render(e, n, o, u, l, c, v), h.runEvents())), this.intervalId = Ua(x);
      };
      r || h.start(), this.intervalId = Ua(x);
    }
  }
  stop() {
    this.intervalId && (Ua.cancel(this.intervalId), this.intervalId = null), this.mouse.stop();
  }
  shouldUpdate(e, t) {
    if (!e) {
      var {
        frameDuration: r
      } = this, i = this.animations.reduce((n, o) => o.update(r) || n, !1);
      if (i)
        return !0;
    }
    return !!(typeof t == "function" && t() || !this.isReadyLock && this.isReady() || this.mouse.hasEvents());
  }
  render(e, t, r, i, n, o, s) {
    var {
      CLIENT_WIDTH: u,
      CLIENT_HEIGHT: l,
      viewPort: c,
      ctx: v,
      isFirstRender: f
    } = this, h = v.canvas;
    c.clear(), h.width && h.height ? c.setCurrent(h.width, h.height) : c.setCurrent(u, l);
    var d = e.getStyle("width"), g = e.getStyle("height");
    !t && (f || typeof i != "number" && typeof n != "number") && (d.hasValue() && (h.width = d.getPixels("x"), h.style && (h.style.width = "".concat(h.width, "px"))), g.hasValue() && (h.height = g.getPixels("y"), h.style && (h.style.height = "".concat(h.height, "px"))));
    var p = h.clientWidth || h.width, y = h.clientHeight || h.height;
    if (t && d.hasValue() && g.hasValue() && (p = d.getPixels("x"), y = g.getPixels("y")), c.setCurrent(p, y), typeof o == "number" && e.getAttribute("x", !0).setValue(o), typeof s == "number" && e.getAttribute("y", !0).setValue(s), typeof i == "number" || typeof n == "number") {
      var x = ie(e.getAttribute("viewBox").getString()), b = 0, $ = 0;
      if (typeof i == "number") {
        var S = e.getStyle("width");
        S.hasValue() ? b = S.getPixels("x") / i : isNaN(x[2]) || (b = x[2] / i);
      }
      if (typeof n == "number") {
        var E = e.getStyle("height");
        E.hasValue() ? $ = E.getPixels("y") / n : isNaN(x[3]) || ($ = x[3] / n);
      }
      b || (b = $), $ || ($ = b), e.getAttribute("width", !0).setValue(i), e.getAttribute("height", !0).setValue(n);
      var T = e.getStyle("transform", !0, !0);
      T.setValue("".concat(T.getString(), " scale(").concat(1 / b, ", ").concat(1 / $, ")"));
    }
    r || v.clearRect(0, 0, p, y), e.render(v), f && (this.isFirstRender = !1);
  }
}
Dr.defaultWindow = gl;
Dr.defaultFetch = dl;
var {
  defaultFetch: xb
} = Dr, $b = typeof DOMParser < "u" ? DOMParser : null;
class za {
  constructor() {
    var {
      fetch: e = xb,
      DOMParser: t = $b
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.fetch = e, this.DOMParser = t;
  }
  parse(e) {
    var t = this;
    return Te(function* () {
      return e.startsWith("<") ? t.parseFromString(e) : t.load(e);
    })();
  }
  parseFromString(e) {
    var t = new this.DOMParser();
    try {
      return this.checkDocument(t.parseFromString(e, "image/svg+xml"));
    } catch {
      return this.checkDocument(t.parseFromString(e, "text/xml"));
    }
  }
  checkDocument(e) {
    var t = e.getElementsByTagName("parsererror")[0];
    if (t)
      throw new Error(t.textContent);
    return e;
  }
  load(e) {
    var t = this;
    return Te(function* () {
      var r = yield t.fetch(e), i = yield r.text();
      return t.parseFromString(i);
    })();
  }
}
class Tb {
  constructor(e, t) {
    this.type = "translate", this.point = null, this.point = D.parse(t);
  }
  apply(e) {
    var {
      x: t,
      y: r
    } = this.point;
    e.translate(t || 0, r || 0);
  }
  unapply(e) {
    var {
      x: t,
      y: r
    } = this.point;
    e.translate(-1 * t || 0, -1 * r || 0);
  }
  applyToPoint(e) {
    var {
      x: t,
      y: r
    } = this.point;
    e.applyTransform([1, 0, 0, 1, t || 0, r || 0]);
  }
}
class Ob {
  constructor(e, t, r) {
    this.type = "rotate", this.angle = null, this.originX = null, this.originY = null, this.cx = 0, this.cy = 0;
    var i = ie(t);
    this.angle = new O(e, "angle", i[0]), this.originX = r[0], this.originY = r[1], this.cx = i[1] || 0, this.cy = i[2] || 0;
  }
  apply(e) {
    var {
      cx: t,
      cy: r,
      originX: i,
      originY: n,
      angle: o
    } = this, s = t + i.getPixels("x"), u = r + n.getPixels("y");
    e.translate(s, u), e.rotate(o.getRadians()), e.translate(-s, -u);
  }
  unapply(e) {
    var {
      cx: t,
      cy: r,
      originX: i,
      originY: n,
      angle: o
    } = this, s = t + i.getPixels("x"), u = r + n.getPixels("y");
    e.translate(s, u), e.rotate(-1 * o.getRadians()), e.translate(-s, -u);
  }
  applyToPoint(e) {
    var {
      cx: t,
      cy: r,
      angle: i
    } = this, n = i.getRadians();
    e.applyTransform([
      1,
      0,
      0,
      1,
      t || 0,
      r || 0
      // this.p.y
    ]), e.applyTransform([Math.cos(n), Math.sin(n), -Math.sin(n), Math.cos(n), 0, 0]), e.applyTransform([
      1,
      0,
      0,
      1,
      -t || 0,
      -r || 0
      // -this.p.y
    ]);
  }
}
class Eb {
  constructor(e, t, r) {
    this.type = "scale", this.scale = null, this.originX = null, this.originY = null;
    var i = D.parseScale(t);
    (i.x === 0 || i.y === 0) && (i.x = nt, i.y = nt), this.scale = i, this.originX = r[0], this.originY = r[1];
  }
  apply(e) {
    var {
      scale: {
        x: t,
        y: r
      },
      originX: i,
      originY: n
    } = this, o = i.getPixels("x"), s = n.getPixels("y");
    e.translate(o, s), e.scale(t, r || t), e.translate(-o, -s);
  }
  unapply(e) {
    var {
      scale: {
        x: t,
        y: r
      },
      originX: i,
      originY: n
    } = this, o = i.getPixels("x"), s = n.getPixels("y");
    e.translate(o, s), e.scale(1 / t, 1 / r || t), e.translate(-o, -s);
  }
  applyToPoint(e) {
    var {
      x: t,
      y: r
    } = this.scale;
    e.applyTransform([t || 0, 0, 0, r || 0, 0, 0]);
  }
}
class pl {
  constructor(e, t, r) {
    this.type = "matrix", this.matrix = [], this.originX = null, this.originY = null, this.matrix = ie(t), this.originX = r[0], this.originY = r[1];
  }
  apply(e) {
    var {
      originX: t,
      originY: r,
      matrix: i
    } = this, n = t.getPixels("x"), o = r.getPixels("y");
    e.translate(n, o), e.transform(i[0], i[1], i[2], i[3], i[4], i[5]), e.translate(-n, -o);
  }
  unapply(e) {
    var {
      originX: t,
      originY: r,
      matrix: i
    } = this, n = i[0], o = i[2], s = i[4], u = i[1], l = i[3], c = i[5], v = 0, f = 0, h = 1, d = 1 / (n * (l * h - c * f) - o * (u * h - c * v) + s * (u * f - l * v)), g = t.getPixels("x"), p = r.getPixels("y");
    e.translate(g, p), e.transform(d * (l * h - c * f), d * (c * v - u * h), d * (s * f - o * h), d * (n * h - s * v), d * (o * c - s * l), d * (s * u - n * c)), e.translate(-g, -p);
  }
  applyToPoint(e) {
    e.applyTransform(this.matrix);
  }
}
class yl extends pl {
  constructor(e, t, r) {
    super(e, t, r), this.type = "skew", this.angle = null, this.angle = new O(e, "angle", t);
  }
}
class Sb extends yl {
  constructor(e, t, r) {
    super(e, t, r), this.type = "skewX", this.matrix = [1, 0, Math.tan(this.angle.getRadians()), 1, 0, 0];
  }
}
class wb extends yl {
  constructor(e, t, r) {
    super(e, t, r), this.type = "skewY", this.matrix = [1, Math.tan(this.angle.getRadians()), 0, 1, 0, 0];
  }
}
function Cb(a) {
  return vt(a).trim().replace(/\)([a-zA-Z])/g, ") $1").replace(/\)(\s?,\s?)/g, ") ").split(/\s(?=[a-z])/);
}
function Pb(a) {
  var [e, t] = a.split("(");
  return [e.trim(), t.trim().replace(")", "")];
}
class Be {
  constructor(e, t, r) {
    this.document = e, this.transforms = [];
    var i = Cb(t);
    i.forEach((n) => {
      if (n !== "none") {
        var [o, s] = Pb(n), u = Be.transformTypes[o];
        typeof u < "u" && this.transforms.push(new u(this.document, s, r));
      }
    });
  }
  static fromElement(e, t) {
    var r = t.getStyle("transform", !1, !0), [i, n = i] = t.getStyle("transform-origin", !1, !0).split(), o = [i, n];
    return r.hasValue() ? new Be(e, r.getString(), o) : null;
  }
  apply(e) {
    for (var {
      transforms: t
    } = this, r = t.length, i = 0; i < r; i++)
      t[i].apply(e);
  }
  unapply(e) {
    for (var {
      transforms: t
    } = this, r = t.length, i = r - 1; i >= 0; i--)
      t[i].unapply(e);
  }
  // TODO: applyToPoint unused ... remove?
  applyToPoint(e) {
    for (var {
      transforms: t
    } = this, r = t.length, i = 0; i < r; i++)
      t[i].applyToPoint(e);
  }
}
Be.transformTypes = {
  translate: Tb,
  rotate: Ob,
  scale: Eb,
  matrix: pl,
  skewX: Sb,
  skewY: wb
};
class I {
  constructor(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (this.document = e, this.node = t, this.captureTextNodes = r, this.attributes = {}, this.styles = {}, this.stylesSpecificity = {}, this.animationFrozen = !1, this.animationFrozenValue = "", this.parent = null, this.children = [], !(!t || t.nodeType !== 1)) {
      if (Array.from(t.attributes).forEach((s) => {
        var u = ub(s.nodeName);
        this.attributes[u] = new O(e, u, s.value);
      }), this.addStylesFromStyleDefinition(), this.getAttribute("style").hasValue()) {
        var i = this.getAttribute("style").getString().split(";").map((s) => s.trim());
        i.forEach((s) => {
          if (s) {
            var [u, l] = s.split(":").map((c) => c.trim());
            this.styles[u] = new O(e, u, l);
          }
        });
      }
      var {
        definitions: n
      } = e, o = this.getAttribute("id");
      o.hasValue() && (n[o.getString()] || (n[o.getString()] = this)), Array.from(t.childNodes).forEach((s) => {
        if (s.nodeType === 1)
          this.addChild(s);
        else if (r && (s.nodeType === 3 || s.nodeType === 4)) {
          var u = e.createTextNode(s);
          u.getText().length > 0 && this.addChild(u);
        }
      });
    }
  }
  getAttribute(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = this.attributes[e];
    if (!r && t) {
      var i = new O(this.document, e, "");
      return this.attributes[e] = i, i;
    }
    return r || O.empty(this.document);
  }
  getHrefAttribute() {
    for (var e in this.attributes)
      if (e === "href" || e.endsWith(":href"))
        return this.attributes[e];
    return O.empty(this.document);
  }
  getStyle(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, i = this.styles[e];
    if (i)
      return i;
    var n = this.getAttribute(e);
    if (n != null && n.hasValue())
      return this.styles[e] = n, n;
    if (!r) {
      var {
        parent: o
      } = this;
      if (o) {
        var s = o.getStyle(e);
        if (s != null && s.hasValue())
          return s;
      }
    }
    if (t) {
      var u = new O(this.document, e, "");
      return this.styles[e] = u, u;
    }
    return i || O.empty(this.document);
  }
  render(e) {
    if (!(this.getStyle("display").getString() === "none" || this.getStyle("visibility").getString() === "hidden")) {
      if (e.save(), this.getStyle("mask").hasValue()) {
        var t = this.getStyle("mask").getDefinition();
        t && (this.applyEffects(e), t.apply(e, this));
      } else if (this.getStyle("filter").getValue("none") !== "none") {
        var r = this.getStyle("filter").getDefinition();
        r && (this.applyEffects(e), r.apply(e, this));
      } else
        this.setContext(e), this.renderChildren(e), this.clearContext(e);
      e.restore();
    }
  }
  setContext(e) {
  }
  applyEffects(e) {
    var t = Be.fromElement(this.document, this);
    t && t.apply(e);
    var r = this.getStyle("clip-path", !1, !0);
    if (r.hasValue()) {
      var i = r.getDefinition();
      i && i.apply(e);
    }
  }
  clearContext(e) {
  }
  renderChildren(e) {
    this.children.forEach((t) => {
      t.render(e);
    });
  }
  addChild(e) {
    var t = e instanceof I ? e : this.document.createElement(e);
    t.parent = this, I.ignoreChildTypes.includes(t.type) || this.children.push(t);
  }
  matchesSelector(e) {
    var t, {
      node: r
    } = this;
    if (typeof r.matches == "function")
      return r.matches(e);
    var i = (t = r.getAttribute) === null || t === void 0 ? void 0 : t.call(r, "class");
    return !i || i === "" ? !1 : i.split(" ").some((n) => ".".concat(n) === e);
  }
  addStylesFromStyleDefinition() {
    var {
      styles: e,
      stylesSpecificity: t
    } = this.document;
    for (var r in e)
      if (!r.startsWith("@") && this.matchesSelector(r)) {
        var i = e[r], n = t[r];
        if (i)
          for (var o in i) {
            var s = this.stylesSpecificity[o];
            typeof s > "u" && (s = "000"), n >= s && (this.styles[o] = i[o], this.stylesSpecificity[o] = n);
          }
      }
  }
  removeStyles(e, t) {
    var r = t.reduce((i, n) => {
      var o = e.getStyle(n);
      if (!o.hasValue())
        return i;
      var s = o.getString();
      return o.setValue(""), [...i, [n, s]];
    }, []);
    return r;
  }
  restoreStyles(e, t) {
    t.forEach((r) => {
      var [i, n] = r;
      e.getStyle(i, !0).setValue(n);
    });
  }
  isFirstChild() {
    var e;
    return ((e = this.parent) === null || e === void 0 ? void 0 : e.children.indexOf(this)) === 0;
  }
}
I.ignoreChildTypes = ["title"];
class Ab extends I {
  constructor(e, t, r) {
    super(e, t, r);
  }
}
function Rb(a) {
  var e = a.trim();
  return /^('|")/.test(e) ? e : '"'.concat(e, '"');
}
function Ib(a) {
  return typeof process > "u" ? a : a.trim().split(",").map(Rb).join(",");
}
function Nb(a) {
  if (!a)
    return "";
  var e = a.trim().toLowerCase();
  switch (e) {
    case "normal":
    case "italic":
    case "oblique":
    case "inherit":
    case "initial":
    case "unset":
      return e;
    default:
      return /^oblique\s+(-|)\d+deg$/.test(e) ? e : "";
  }
}
function Mb(a) {
  if (!a)
    return "";
  var e = a.trim().toLowerCase();
  switch (e) {
    case "normal":
    case "bold":
    case "lighter":
    case "bolder":
    case "inherit":
    case "initial":
    case "unset":
      return e;
    default:
      return /^[\d.]+$/.test(e) ? e : "";
  }
}
class J {
  constructor(e, t, r, i, n, o) {
    var s = o ? typeof o == "string" ? J.parse(o) : o : {};
    this.fontFamily = n || s.fontFamily, this.fontSize = i || s.fontSize, this.fontStyle = e || s.fontStyle, this.fontWeight = r || s.fontWeight, this.fontVariant = t || s.fontVariant;
  }
  static parse() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0, r = "", i = "", n = "", o = "", s = "", u = vt(e).trim().split(" "), l = {
      fontSize: !1,
      fontStyle: !1,
      fontWeight: !1,
      fontVariant: !1
    };
    return u.forEach((c) => {
      switch (!0) {
        case (!l.fontStyle && J.styles.includes(c)):
          c !== "inherit" && (r = c), l.fontStyle = !0;
          break;
        case (!l.fontVariant && J.variants.includes(c)):
          c !== "inherit" && (i = c), l.fontStyle = !0, l.fontVariant = !0;
          break;
        case (!l.fontWeight && J.weights.includes(c)):
          c !== "inherit" && (n = c), l.fontStyle = !0, l.fontVariant = !0, l.fontWeight = !0;
          break;
        case !l.fontSize:
          c !== "inherit" && ([o] = c.split("/")), l.fontStyle = !0, l.fontVariant = !0, l.fontWeight = !0, l.fontSize = !0;
          break;
        default:
          c !== "inherit" && (s += c);
      }
    }), new J(r, i, n, o, s, t);
  }
  toString() {
    return [
      Nb(this.fontStyle),
      this.fontVariant,
      Mb(this.fontWeight),
      this.fontSize,
      // Wrap fontFamily only on nodejs and only for canvas.ctx
      Ib(this.fontFamily)
    ].join(" ").trim();
  }
}
J.styles = "normal|italic|oblique|inherit";
J.variants = "normal|small-caps|inherit";
J.weights = "normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit";
class he {
  constructor() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Number.NaN, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.NaN, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Number.NaN, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Number.NaN;
    this.x1 = e, this.y1 = t, this.x2 = r, this.y2 = i, this.addPoint(e, t), this.addPoint(r, i);
  }
  get x() {
    return this.x1;
  }
  get y() {
    return this.y1;
  }
  get width() {
    return this.x2 - this.x1;
  }
  get height() {
    return this.y2 - this.y1;
  }
  addPoint(e, t) {
    typeof e < "u" && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = e, this.x2 = e), e < this.x1 && (this.x1 = e), e > this.x2 && (this.x2 = e)), typeof t < "u" && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = t, this.y2 = t), t < this.y1 && (this.y1 = t), t > this.y2 && (this.y2 = t));
  }
  addX(e) {
    this.addPoint(e, null);
  }
  addY(e) {
    this.addPoint(null, e);
  }
  addBoundingBox(e) {
    if (e) {
      var {
        x1: t,
        y1: r,
        x2: i,
        y2: n
      } = e;
      this.addPoint(t, r), this.addPoint(i, n);
    }
  }
  sumCubic(e, t, r, i, n) {
    return Math.pow(1 - e, 3) * t + 3 * Math.pow(1 - e, 2) * e * r + 3 * (1 - e) * Math.pow(e, 2) * i + Math.pow(e, 3) * n;
  }
  bezierCurveAdd(e, t, r, i, n) {
    var o = 6 * t - 12 * r + 6 * i, s = -3 * t + 9 * r - 9 * i + 3 * n, u = 3 * r - 3 * t;
    if (s === 0) {
      if (o === 0)
        return;
      var l = -u / o;
      0 < l && l < 1 && (e ? this.addX(this.sumCubic(l, t, r, i, n)) : this.addY(this.sumCubic(l, t, r, i, n)));
      return;
    }
    var c = Math.pow(o, 2) - 4 * u * s;
    if (!(c < 0)) {
      var v = (-o + Math.sqrt(c)) / (2 * s);
      0 < v && v < 1 && (e ? this.addX(this.sumCubic(v, t, r, i, n)) : this.addY(this.sumCubic(v, t, r, i, n)));
      var f = (-o - Math.sqrt(c)) / (2 * s);
      0 < f && f < 1 && (e ? this.addX(this.sumCubic(f, t, r, i, n)) : this.addY(this.sumCubic(f, t, r, i, n)));
    }
  }
  // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
  addBezierCurve(e, t, r, i, n, o, s, u) {
    this.addPoint(e, t), this.addPoint(s, u), this.bezierCurveAdd(!0, e, r, n, s), this.bezierCurveAdd(!1, t, i, o, u);
  }
  addQuadraticCurve(e, t, r, i, n, o) {
    var s = e + 0.6666666666666666 * (r - e), u = t + 2 / 3 * (i - t), l = s + 1 / 3 * (n - e), c = u + 1 / 3 * (o - t);
    this.addBezierCurve(e, t, s, l, u, c, n, o);
  }
  isPointInBox(e, t) {
    var {
      x1: r,
      y1: i,
      x2: n,
      y2: o
    } = this;
    return r <= e && e <= n && i <= t && t <= o;
  }
}
class w extends m {
  constructor(e) {
    super(e.replace(/([+\-.])\s+/gm, "$1").replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, "")), this.control = null, this.start = null, this.current = null, this.command = null, this.commands = this.commands, this.i = -1, this.previousCommand = null, this.points = [], this.angles = [];
  }
  reset() {
    this.i = -1, this.command = null, this.previousCommand = null, this.start = new D(0, 0), this.control = new D(0, 0), this.current = new D(0, 0), this.points = [], this.angles = [];
  }
  isEnd() {
    var {
      i: e,
      commands: t
    } = this;
    return e >= t.length - 1;
  }
  next() {
    var e = this.commands[++this.i];
    return this.previousCommand = this.command, this.command = e, e;
  }
  getPoint() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "x", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "y", r = new D(this.command[e], this.command[t]);
    return this.makeAbsolute(r);
  }
  getAsControlPoint(e, t) {
    var r = this.getPoint(e, t);
    return this.control = r, r;
  }
  getAsCurrentPoint(e, t) {
    var r = this.getPoint(e, t);
    return this.current = r, r;
  }
  getReflectedControlPoint() {
    var e = this.previousCommand.type;
    if (e !== m.CURVE_TO && e !== m.SMOOTH_CURVE_TO && e !== m.QUAD_TO && e !== m.SMOOTH_QUAD_TO)
      return this.current;
    var {
      current: {
        x: t,
        y: r
      },
      control: {
        x: i,
        y: n
      }
    } = this, o = new D(2 * t - i, 2 * r - n);
    return o;
  }
  makeAbsolute(e) {
    if (this.command.relative) {
      var {
        x: t,
        y: r
      } = this.current;
      e.x += t, e.y += r;
    }
    return e;
  }
  addMarker(e, t, r) {
    var {
      points: i,
      angles: n
    } = this;
    r && n.length > 0 && !n[n.length - 1] && (n[n.length - 1] = i[i.length - 1].angleTo(r)), this.addMarkerAngle(e, t ? t.angleTo(e) : null);
  }
  addMarkerAngle(e, t) {
    this.points.push(e), this.angles.push(t);
  }
  getMarkerPoints() {
    return this.points;
  }
  getMarkerAngles() {
    for (var {
      angles: e
    } = this, t = e.length, r = 0; r < t; r++)
      if (!e[r]) {
        for (var i = r + 1; i < t; i++)
          if (e[i]) {
            e[r] = e[i];
            break;
          }
      }
    return e;
  }
}
class ze extends I {
  constructor() {
    super(...arguments), this.modifiedEmSizeStack = !1;
  }
  calculateOpacity() {
    for (var e = 1, t = this; t; ) {
      var r = t.getStyle("opacity", !1, !0);
      r.hasValue(!0) && (e *= r.getNumber()), t = t.parent;
    }
    return e;
  }
  setContext(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (!t) {
      var r = this.getStyle("fill"), i = this.getStyle("fill-opacity"), n = this.getStyle("stroke"), o = this.getStyle("stroke-opacity");
      if (r.isUrlDefinition()) {
        var s = r.getFillStyleDefinition(this, i);
        s && (e.fillStyle = s);
      } else if (r.hasValue()) {
        r.getString() === "currentColor" && r.setValue(this.getStyle("color").getColor());
        var u = r.getColor();
        u !== "inherit" && (e.fillStyle = u === "none" ? "rgba(0,0,0,0)" : u);
      }
      if (i.hasValue()) {
        var l = new O(this.document, "fill", e.fillStyle).addOpacity(i).getColor();
        e.fillStyle = l;
      }
      if (n.isUrlDefinition()) {
        var c = n.getFillStyleDefinition(this, o);
        c && (e.strokeStyle = c);
      } else if (n.hasValue()) {
        n.getString() === "currentColor" && n.setValue(this.getStyle("color").getColor());
        var v = n.getString();
        v !== "inherit" && (e.strokeStyle = v === "none" ? "rgba(0,0,0,0)" : v);
      }
      if (o.hasValue()) {
        var f = new O(this.document, "stroke", e.strokeStyle).addOpacity(o).getString();
        e.strokeStyle = f;
      }
      var h = this.getStyle("stroke-width");
      if (h.hasValue()) {
        var d = h.getPixels();
        e.lineWidth = d || nt;
      }
      var g = this.getStyle("stroke-linecap"), p = this.getStyle("stroke-linejoin"), y = this.getStyle("stroke-miterlimit"), x = this.getStyle("stroke-dasharray"), b = this.getStyle("stroke-dashoffset");
      if (g.hasValue() && (e.lineCap = g.getString()), p.hasValue() && (e.lineJoin = p.getString()), y.hasValue() && (e.miterLimit = y.getNumber()), x.hasValue() && x.getString() !== "none") {
        var $ = ie(x.getString());
        typeof e.setLineDash < "u" ? e.setLineDash($) : typeof e.webkitLineDash < "u" ? e.webkitLineDash = $ : typeof e.mozDash < "u" && !($.length === 1 && $[0] === 0) && (e.mozDash = $);
        var S = b.getPixels();
        typeof e.lineDashOffset < "u" ? e.lineDashOffset = S : typeof e.webkitLineDashOffset < "u" ? e.webkitLineDashOffset = S : typeof e.mozDashOffset < "u" && (e.mozDashOffset = S);
      }
    }
    if (this.modifiedEmSizeStack = !1, typeof e.font < "u") {
      var E = this.getStyle("font"), T = this.getStyle("font-style"), C = this.getStyle("font-variant"), N = this.getStyle("font-weight"), _ = this.getStyle("font-size"), j = this.getStyle("font-family"), A = new J(T.getString(), C.getString(), N.getString(), _.hasValue() ? "".concat(_.getPixels(!0), "px") : "", j.getString(), J.parse(E.getString(), e.font));
      T.setValue(A.fontStyle), C.setValue(A.fontVariant), N.setValue(A.fontWeight), _.setValue(A.fontSize), j.setValue(A.fontFamily), e.font = A.toString(), _.isPixels() && (this.document.emSize = _.getPixels(), this.modifiedEmSizeStack = !0);
    }
    t || (this.applyEffects(e), e.globalAlpha = this.calculateOpacity());
  }
  clearContext(e) {
    super.clearContext(e), this.modifiedEmSizeStack && this.document.popEmSize();
  }
}
class P extends ze {
  constructor(e, t, r) {
    super(e, t, r), this.type = "path", this.pathParser = null, this.pathParser = new w(this.getAttribute("d").getString());
  }
  path(e) {
    var {
      pathParser: t
    } = this, r = new he();
    for (t.reset(), e && e.beginPath(); !t.isEnd(); )
      switch (t.next().type) {
        case w.MOVE_TO:
          this.pathM(e, r);
          break;
        case w.LINE_TO:
          this.pathL(e, r);
          break;
        case w.HORIZ_LINE_TO:
          this.pathH(e, r);
          break;
        case w.VERT_LINE_TO:
          this.pathV(e, r);
          break;
        case w.CURVE_TO:
          this.pathC(e, r);
          break;
        case w.SMOOTH_CURVE_TO:
          this.pathS(e, r);
          break;
        case w.QUAD_TO:
          this.pathQ(e, r);
          break;
        case w.SMOOTH_QUAD_TO:
          this.pathT(e, r);
          break;
        case w.ARC:
          this.pathA(e, r);
          break;
        case w.CLOSE_PATH:
          this.pathZ(e, r);
          break;
      }
    return r;
  }
  getBoundingBox(e) {
    return this.path();
  }
  getMarkers() {
    var {
      pathParser: e
    } = this, t = e.getMarkerPoints(), r = e.getMarkerAngles(), i = t.map((n, o) => [n, r[o]]);
    return i;
  }
  renderChildren(e) {
    this.path(e), this.document.screen.mouse.checkPath(this, e);
    var t = this.getStyle("fill-rule");
    e.fillStyle !== "" && (t.getString("inherit") !== "inherit" ? e.fill(t.getString()) : e.fill()), e.strokeStyle !== "" && (this.getAttribute("vector-effect").getString() === "non-scaling-stroke" ? (e.save(), e.setTransform(1, 0, 0, 1, 0, 0), e.stroke(), e.restore()) : e.stroke());
    var r = this.getMarkers();
    if (r) {
      var i = r.length - 1, n = this.getStyle("marker-start"), o = this.getStyle("marker-mid"), s = this.getStyle("marker-end");
      if (n.isUrlDefinition()) {
        var u = n.getDefinition(), [l, c] = r[0];
        u.render(e, l, c);
      }
      if (o.isUrlDefinition())
        for (var v = o.getDefinition(), f = 1; f < i; f++) {
          var [h, d] = r[f];
          v.render(e, h, d);
        }
      if (s.isUrlDefinition()) {
        var g = s.getDefinition(), [p, y] = r[i];
        g.render(e, p, y);
      }
    }
  }
  static pathM(e) {
    var t = e.getAsCurrentPoint();
    return e.start = e.current, {
      point: t
    };
  }
  pathM(e, t) {
    var {
      pathParser: r
    } = this, {
      point: i
    } = P.pathM(r), {
      x: n,
      y: o
    } = i;
    r.addMarker(i), t.addPoint(n, o), e && e.moveTo(n, o);
  }
  static pathL(e) {
    var {
      current: t
    } = e, r = e.getAsCurrentPoint();
    return {
      current: t,
      point: r
    };
  }
  pathL(e, t) {
    var {
      pathParser: r
    } = this, {
      current: i,
      point: n
    } = P.pathL(r), {
      x: o,
      y: s
    } = n;
    r.addMarker(n, i), t.addPoint(o, s), e && e.lineTo(o, s);
  }
  static pathH(e) {
    var {
      current: t,
      command: r
    } = e, i = new D((r.relative ? t.x : 0) + r.x, t.y);
    return e.current = i, {
      current: t,
      point: i
    };
  }
  pathH(e, t) {
    var {
      pathParser: r
    } = this, {
      current: i,
      point: n
    } = P.pathH(r), {
      x: o,
      y: s
    } = n;
    r.addMarker(n, i), t.addPoint(o, s), e && e.lineTo(o, s);
  }
  static pathV(e) {
    var {
      current: t,
      command: r
    } = e, i = new D(t.x, (r.relative ? t.y : 0) + r.y);
    return e.current = i, {
      current: t,
      point: i
    };
  }
  pathV(e, t) {
    var {
      pathParser: r
    } = this, {
      current: i,
      point: n
    } = P.pathV(r), {
      x: o,
      y: s
    } = n;
    r.addMarker(n, i), t.addPoint(o, s), e && e.lineTo(o, s);
  }
  static pathC(e) {
    var {
      current: t
    } = e, r = e.getPoint("x1", "y1"), i = e.getAsControlPoint("x2", "y2"), n = e.getAsCurrentPoint();
    return {
      current: t,
      point: r,
      controlPoint: i,
      currentPoint: n
    };
  }
  pathC(e, t) {
    var {
      pathParser: r
    } = this, {
      current: i,
      point: n,
      controlPoint: o,
      currentPoint: s
    } = P.pathC(r);
    r.addMarker(s, o, n), t.addBezierCurve(i.x, i.y, n.x, n.y, o.x, o.y, s.x, s.y), e && e.bezierCurveTo(n.x, n.y, o.x, o.y, s.x, s.y);
  }
  static pathS(e) {
    var {
      current: t
    } = e, r = e.getReflectedControlPoint(), i = e.getAsControlPoint("x2", "y2"), n = e.getAsCurrentPoint();
    return {
      current: t,
      point: r,
      controlPoint: i,
      currentPoint: n
    };
  }
  pathS(e, t) {
    var {
      pathParser: r
    } = this, {
      current: i,
      point: n,
      controlPoint: o,
      currentPoint: s
    } = P.pathS(r);
    r.addMarker(s, o, n), t.addBezierCurve(i.x, i.y, n.x, n.y, o.x, o.y, s.x, s.y), e && e.bezierCurveTo(n.x, n.y, o.x, o.y, s.x, s.y);
  }
  static pathQ(e) {
    var {
      current: t
    } = e, r = e.getAsControlPoint("x1", "y1"), i = e.getAsCurrentPoint();
    return {
      current: t,
      controlPoint: r,
      currentPoint: i
    };
  }
  pathQ(e, t) {
    var {
      pathParser: r
    } = this, {
      current: i,
      controlPoint: n,
      currentPoint: o
    } = P.pathQ(r);
    r.addMarker(o, n, n), t.addQuadraticCurve(i.x, i.y, n.x, n.y, o.x, o.y), e && e.quadraticCurveTo(n.x, n.y, o.x, o.y);
  }
  static pathT(e) {
    var {
      current: t
    } = e, r = e.getReflectedControlPoint();
    e.control = r;
    var i = e.getAsCurrentPoint();
    return {
      current: t,
      controlPoint: r,
      currentPoint: i
    };
  }
  pathT(e, t) {
    var {
      pathParser: r
    } = this, {
      current: i,
      controlPoint: n,
      currentPoint: o
    } = P.pathT(r);
    r.addMarker(o, n, n), t.addQuadraticCurve(i.x, i.y, n.x, n.y, o.x, o.y), e && e.quadraticCurveTo(n.x, n.y, o.x, o.y);
  }
  static pathA(e) {
    var {
      current: t,
      command: r
    } = e, {
      rX: i,
      rY: n,
      xRot: o,
      lArcFlag: s,
      sweepFlag: u
    } = r, l = o * (Math.PI / 180), c = e.getAsCurrentPoint(), v = new D(Math.cos(l) * (t.x - c.x) / 2 + Math.sin(l) * (t.y - c.y) / 2, -Math.sin(l) * (t.x - c.x) / 2 + Math.cos(l) * (t.y - c.y) / 2), f = Math.pow(v.x, 2) / Math.pow(i, 2) + Math.pow(v.y, 2) / Math.pow(n, 2);
    f > 1 && (i *= Math.sqrt(f), n *= Math.sqrt(f));
    var h = (s === u ? -1 : 1) * Math.sqrt((Math.pow(i, 2) * Math.pow(n, 2) - Math.pow(i, 2) * Math.pow(v.y, 2) - Math.pow(n, 2) * Math.pow(v.x, 2)) / (Math.pow(i, 2) * Math.pow(v.y, 2) + Math.pow(n, 2) * Math.pow(v.x, 2)));
    isNaN(h) && (h = 0);
    var d = new D(h * i * v.y / n, h * -n * v.x / i), g = new D((t.x + c.x) / 2 + Math.cos(l) * d.x - Math.sin(l) * d.y, (t.y + c.y) / 2 + Math.sin(l) * d.x + Math.cos(l) * d.y), p = $o([1, 0], [(v.x - d.x) / i, (v.y - d.y) / n]), y = [(v.x - d.x) / i, (v.y - d.y) / n], x = [(-v.x - d.x) / i, (-v.y - d.y) / n], b = $o(y, x);
    return xi(y, x) <= -1 && (b = Math.PI), xi(y, x) >= 1 && (b = 0), {
      currentPoint: c,
      rX: i,
      rY: n,
      sweepFlag: u,
      xAxisRotation: l,
      centp: g,
      a1: p,
      ad: b
    };
  }
  pathA(e, t) {
    var {
      pathParser: r
    } = this, {
      currentPoint: i,
      rX: n,
      rY: o,
      sweepFlag: s,
      xAxisRotation: u,
      centp: l,
      a1: c,
      ad: v
    } = P.pathA(r), f = 1 - s ? 1 : -1, h = c + f * (v / 2), d = new D(l.x + n * Math.cos(h), l.y + o * Math.sin(h));
    if (r.addMarkerAngle(d, h - f * Math.PI / 2), r.addMarkerAngle(i, h - f * Math.PI), t.addPoint(i.x, i.y), e && !isNaN(c) && !isNaN(v)) {
      var g = n > o ? n : o, p = n > o ? 1 : n / o, y = n > o ? o / n : 1;
      e.translate(l.x, l.y), e.rotate(u), e.scale(p, y), e.arc(0, 0, g, c, c + v, !!(1 - s)), e.scale(1 / p, 1 / y), e.rotate(-u), e.translate(-l.x, -l.y);
    }
  }
  static pathZ(e) {
    e.current = e.start;
  }
  pathZ(e, t) {
    P.pathZ(this.pathParser), e && t.x1 !== t.x2 && t.y1 !== t.y2 && e.closePath();
  }
}
class ml extends P {
  constructor(e, t, r) {
    super(e, t, r), this.type = "glyph", this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber(), this.unicode = this.getAttribute("unicode").getString(), this.arabicForm = this.getAttribute("arabic-form").getString();
  }
}
class Ae extends ze {
  constructor(e, t, r) {
    super(e, t, new.target === Ae ? !0 : r), this.type = "text", this.x = 0, this.y = 0, this.measureCache = -1;
  }
  setContext(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    super.setContext(e, t);
    var r = this.getStyle("dominant-baseline").getTextBaseline() || this.getStyle("alignment-baseline").getTextBaseline();
    r && (e.textBaseline = r);
  }
  initializeCoordinates() {
    this.x = 0, this.y = 0, this.leafTexts = [], this.textChunkStart = 0, this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY;
  }
  getBoundingBox(e) {
    if (this.type !== "text")
      return this.getTElementBoundingBox(e);
    this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(e);
    var t = null;
    return this.children.forEach((r, i) => {
      var n = this.getChildBoundingBox(e, this, this, i);
      t ? t.addBoundingBox(n) : t = n;
    }), t;
  }
  getFontSize() {
    var {
      document: e,
      parent: t
    } = this, r = J.parse(e.ctx.font).fontSize, i = t.getStyle("font-size").getNumber(r);
    return i;
  }
  getTElementBoundingBox(e) {
    var t = this.getFontSize();
    return new he(this.x, this.y - t, this.x + this.measureText(e), this.y);
  }
  getGlyph(e, t, r) {
    var i = t[r], n = null;
    if (e.isArabic) {
      var o = t.length, s = t[r - 1], u = t[r + 1], l = "isolated";
      if ((r === 0 || s === " ") && r < o - 1 && u !== " " && (l = "terminal"), r > 0 && s !== " " && r < o - 1 && u !== " " && (l = "medial"), r > 0 && s !== " " && (r === o - 1 || u === " ") && (l = "initial"), typeof e.glyphs[i] < "u") {
        var c = e.glyphs[i];
        n = c instanceof ml ? c : c[l];
      }
    } else
      n = e.glyphs[i];
    return n || (n = e.missingGlyph), n;
  }
  getText() {
    return "";
  }
  getTextFromNode(e) {
    var t = e || this.node, r = Array.from(t.parentNode.childNodes), i = r.indexOf(t), n = r.length - 1, o = vt(
      // textNode.value
      // || textNode.text
      t.textContent || ""
    );
    return i === 0 && (o = nb(o)), i === n && (o = sb(o)), o;
  }
  renderChildren(e) {
    if (this.type !== "text") {
      this.renderTElementChildren(e);
      return;
    }
    this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(e), this.children.forEach((r, i) => {
      this.renderChild(e, this, this, i);
    });
    var {
      mouse: t
    } = this.document.screen;
    t.isWorking() && t.checkBoundingBox(this, this.getBoundingBox(e));
  }
  renderTElementChildren(e) {
    var {
      document: t,
      parent: r
    } = this, i = this.getText(), n = r.getStyle("font-family").getDefinition();
    if (n) {
      for (var {
        unitsPerEm: o
      } = n.fontFace, s = J.parse(t.ctx.font), u = r.getStyle("font-size").getNumber(s.fontSize), l = r.getStyle("font-style").getString(s.fontStyle), c = u / o, v = n.isRTL ? i.split("").reverse().join("") : i, f = ie(r.getAttribute("dx").getString()), h = v.length, d = 0; d < h; d++) {
        var g = this.getGlyph(n, v, d);
        e.translate(this.x, this.y), e.scale(c, -c);
        var p = e.lineWidth;
        e.lineWidth = e.lineWidth * o / u, l === "italic" && e.transform(1, 0, 0.4, 1, 0, 0), g.render(e), l === "italic" && e.transform(1, 0, -0.4, 1, 0, 0), e.lineWidth = p, e.scale(1 / c, -1 / c), e.translate(-this.x, -this.y), this.x += u * (g.horizAdvX || n.horizAdvX) / o, typeof f[d] < "u" && !isNaN(f[d]) && (this.x += f[d]);
      }
      return;
    }
    var {
      x: y,
      y: x
    } = this;
    e.fillStyle && e.fillText(i, y, x), e.strokeStyle && e.strokeText(i, y, x);
  }
  applyAnchoring() {
    if (!(this.textChunkStart >= this.leafTexts.length)) {
      var e = this.leafTexts[this.textChunkStart], t = e.getStyle("text-anchor").getString("start"), r = !1, i = 0;
      t === "start" && !r || t === "end" && r ? i = e.x - this.minX : t === "end" && !r || t === "start" && r ? i = e.x - this.maxX : i = e.x - (this.minX + this.maxX) / 2;
      for (var n = this.textChunkStart; n < this.leafTexts.length; n++)
        this.leafTexts[n].x += i;
      this.minX = Number.POSITIVE_INFINITY, this.maxX = Number.NEGATIVE_INFINITY, this.textChunkStart = this.leafTexts.length;
    }
  }
  adjustChildCoordinatesRecursive(e) {
    this.children.forEach((t, r) => {
      this.adjustChildCoordinatesRecursiveCore(e, this, this, r);
    }), this.applyAnchoring();
  }
  adjustChildCoordinatesRecursiveCore(e, t, r, i) {
    var n = r.children[i];
    n.children.length > 0 ? n.children.forEach((o, s) => {
      t.adjustChildCoordinatesRecursiveCore(e, t, n, s);
    }) : this.adjustChildCoordinates(e, t, r, i);
  }
  adjustChildCoordinates(e, t, r, i) {
    var n = r.children[i];
    if (typeof n.measureText != "function")
      return n;
    e.save(), n.setContext(e, !0);
    var o = n.getAttribute("x"), s = n.getAttribute("y"), u = n.getAttribute("dx"), l = n.getAttribute("dy"), c = n.getStyle("font-family").getDefinition(), v = !!c && c.isRTL;
    i === 0 && (o.hasValue() || o.setValue(n.getInheritedAttribute("x")), s.hasValue() || s.setValue(n.getInheritedAttribute("y")), u.hasValue() || u.setValue(n.getInheritedAttribute("dx")), l.hasValue() || l.setValue(n.getInheritedAttribute("dy")));
    var f = n.measureText(e);
    return v && (t.x -= f), o.hasValue() ? (t.applyAnchoring(), n.x = o.getPixels("x"), u.hasValue() && (n.x += u.getPixels("x"))) : (u.hasValue() && (t.x += u.getPixels("x")), n.x = t.x), t.x = n.x, v || (t.x += f), s.hasValue() ? (n.y = s.getPixels("y"), l.hasValue() && (n.y += l.getPixels("y"))) : (l.hasValue() && (t.y += l.getPixels("y")), n.y = t.y), t.y = n.y, t.leafTexts.push(n), t.minX = Math.min(t.minX, n.x, n.x + f), t.maxX = Math.max(t.maxX, n.x, n.x + f), n.clearContext(e), e.restore(), n;
  }
  getChildBoundingBox(e, t, r, i) {
    var n = r.children[i];
    if (typeof n.getBoundingBox != "function")
      return null;
    var o = n.getBoundingBox(e);
    return o ? (n.children.forEach((s, u) => {
      var l = t.getChildBoundingBox(e, t, n, u);
      o.addBoundingBox(l);
    }), o) : null;
  }
  renderChild(e, t, r, i) {
    var n = r.children[i];
    n.render(e), n.children.forEach((o, s) => {
      t.renderChild(e, t, n, s);
    });
  }
  measureText(e) {
    var {
      measureCache: t
    } = this;
    if (~t)
      return t;
    var r = this.getText(), i = this.measureTargetText(e, r);
    return this.measureCache = i, i;
  }
  measureTargetText(e, t) {
    if (!t.length)
      return 0;
    var {
      parent: r
    } = this, i = r.getStyle("font-family").getDefinition();
    if (i) {
      for (var n = this.getFontSize(), o = i.isRTL ? t.split("").reverse().join("") : t, s = ie(r.getAttribute("dx").getString()), u = o.length, l = 0, c = 0; c < u; c++) {
        var v = this.getGlyph(i, o, c);
        l += (v.horizAdvX || i.horizAdvX) * n / i.fontFace.unitsPerEm, typeof s[c] < "u" && !isNaN(s[c]) && (l += s[c]);
      }
      return l;
    }
    if (!e.measureText)
      return t.length * 10;
    e.save(), this.setContext(e, !0);
    var {
      width: f
    } = e.measureText(t);
    return this.clearContext(e), e.restore(), f;
  }
  /**
   * Inherits positional attributes from {@link TextElement} parent(s). Attributes
   * are only inherited from a parent to its first child.
   * @param name - The attribute name.
   * @returns The attribute value or null.
   */
  getInheritedAttribute(e) {
    for (var t = this; t instanceof Ae && t.isFirstChild(); ) {
      var r = t.parent.getAttribute(e);
      if (r.hasValue(!0))
        return r.getValue("0");
      t = t.parent;
    }
    return null;
  }
}
class Vr extends Ae {
  constructor(e, t, r) {
    super(e, t, new.target === Vr ? !0 : r), this.type = "tspan", this.text = this.children.length > 0 ? "" : this.getTextFromNode();
  }
  getText() {
    return this.text;
  }
}
class _b extends Vr {
  constructor() {
    super(...arguments), this.type = "textNode";
  }
}
class _t extends ze {
  constructor() {
    super(...arguments), this.type = "svg", this.root = !1;
  }
  setContext(e) {
    var t, {
      document: r
    } = this, {
      screen: i,
      window: n
    } = r, o = e.canvas;
    if (i.setDefaults(e), o.style && typeof e.font < "u" && n && typeof n.getComputedStyle < "u") {
      e.font = n.getComputedStyle(o).getPropertyValue("font");
      var s = new O(r, "fontSize", J.parse(e.font).fontSize);
      s.hasValue() && (r.rootEmSize = s.getPixels("y"), r.emSize = r.rootEmSize);
    }
    this.getAttribute("x").hasValue() || this.getAttribute("x", !0).setValue(0), this.getAttribute("y").hasValue() || this.getAttribute("y", !0).setValue(0);
    var {
      width: u,
      height: l
    } = i.viewPort;
    this.getStyle("width").hasValue() || this.getStyle("width", !0).setValue("100%"), this.getStyle("height").hasValue() || this.getStyle("height", !0).setValue("100%"), this.getStyle("color").hasValue() || this.getStyle("color", !0).setValue("black");
    var c = this.getAttribute("refX"), v = this.getAttribute("refY"), f = this.getAttribute("viewBox"), h = f.hasValue() ? ie(f.getString()) : null, d = !this.root && this.getStyle("overflow").getValue("hidden") !== "visible", g = 0, p = 0, y = 0, x = 0;
    h && (g = h[0], p = h[1]), this.root || (u = this.getStyle("width").getPixels("x"), l = this.getStyle("height").getPixels("y"), this.type === "marker" && (y = g, x = p, g = 0, p = 0)), i.viewPort.setCurrent(u, l), this.node && (!this.parent || ((t = this.node.parentNode) === null || t === void 0 ? void 0 : t.nodeName) === "foreignObject") && this.getStyle("transform", !1, !0).hasValue() && !this.getStyle("transform-origin", !1, !0).hasValue() && this.getStyle("transform-origin", !0, !0).setValue("50% 50%"), super.setContext(e), e.translate(this.getAttribute("x").getPixels("x"), this.getAttribute("y").getPixels("y")), h && (u = h[2], l = h[3]), r.setViewBox({
      ctx: e,
      aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
      width: i.viewPort.width,
      desiredWidth: u,
      height: i.viewPort.height,
      desiredHeight: l,
      minX: g,
      minY: p,
      refX: c.getValue(),
      refY: v.getValue(),
      clip: d,
      clipX: y,
      clipY: x
    }), h && (i.viewPort.removeCurrent(), i.viewPort.setCurrent(u, l));
  }
  clearContext(e) {
    super.clearContext(e), this.document.screen.viewPort.removeCurrent();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */
  resize(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, i = this.getAttribute("width", !0), n = this.getAttribute("height", !0), o = this.getAttribute("viewBox"), s = this.getAttribute("style"), u = i.getNumber(0), l = n.getNumber(0);
    if (r)
      if (typeof r == "string")
        this.getAttribute("preserveAspectRatio", !0).setValue(r);
      else {
        var c = this.getAttribute("preserveAspectRatio");
        c.hasValue() && c.setValue(c.getString().replace(/^\s*(\S.*\S)\s*$/, "$1"));
      }
    if (i.setValue(e), n.setValue(t), o.hasValue() || o.setValue("0 0 ".concat(u || e, " ").concat(l || t)), s.hasValue()) {
      var v = this.getStyle("width"), f = this.getStyle("height");
      v.hasValue() && v.setValue("".concat(e, "px")), f.hasValue() && f.setValue("".concat(t, "px"));
    }
  }
}
class bl extends P {
  constructor() {
    super(...arguments), this.type = "rect";
  }
  path(e) {
    var t = this.getAttribute("x").getPixels("x"), r = this.getAttribute("y").getPixels("y"), i = this.getStyle("width", !1, !0).getPixels("x"), n = this.getStyle("height", !1, !0).getPixels("y"), o = this.getAttribute("rx"), s = this.getAttribute("ry"), u = o.getPixels("x"), l = s.getPixels("y");
    if (o.hasValue() && !s.hasValue() && (l = u), s.hasValue() && !o.hasValue() && (u = l), u = Math.min(u, i / 2), l = Math.min(l, n / 2), e) {
      var c = 4 * ((Math.sqrt(2) - 1) / 3);
      e.beginPath(), n > 0 && i > 0 && (e.moveTo(t + u, r), e.lineTo(t + i - u, r), e.bezierCurveTo(t + i - u + c * u, r, t + i, r + l - c * l, t + i, r + l), e.lineTo(t + i, r + n - l), e.bezierCurveTo(t + i, r + n - l + c * l, t + i - u + c * u, r + n, t + i - u, r + n), e.lineTo(t + u, r + n), e.bezierCurveTo(t + u - c * u, r + n, t, r + n - l + c * l, t, r + n - l), e.lineTo(t, r + l), e.bezierCurveTo(t, r + l - c * l, t + u - c * u, r, t + u, r), e.closePath());
    }
    return new he(t, r, t + i, r + n);
  }
  getMarkers() {
    return null;
  }
}
class Db extends P {
  constructor() {
    super(...arguments), this.type = "circle";
  }
  path(e) {
    var t = this.getAttribute("cx").getPixels("x"), r = this.getAttribute("cy").getPixels("y"), i = this.getAttribute("r").getPixels();
    return e && i > 0 && (e.beginPath(), e.arc(t, r, i, 0, Math.PI * 2, !1), e.closePath()), new he(t - i, r - i, t + i, r + i);
  }
  getMarkers() {
    return null;
  }
}
class Vb extends P {
  constructor() {
    super(...arguments), this.type = "ellipse";
  }
  path(e) {
    var t = 4 * ((Math.sqrt(2) - 1) / 3), r = this.getAttribute("rx").getPixels("x"), i = this.getAttribute("ry").getPixels("y"), n = this.getAttribute("cx").getPixels("x"), o = this.getAttribute("cy").getPixels("y");
    return e && r > 0 && i > 0 && (e.beginPath(), e.moveTo(n + r, o), e.bezierCurveTo(n + r, o + t * i, n + t * r, o + i, n, o + i), e.bezierCurveTo(n - t * r, o + i, n - r, o + t * i, n - r, o), e.bezierCurveTo(n - r, o - t * i, n - t * r, o - i, n, o - i), e.bezierCurveTo(n + t * r, o - i, n + r, o - t * i, n + r, o), e.closePath()), new he(n - r, o - i, n + r, o + i);
  }
  getMarkers() {
    return null;
  }
}
class kb extends P {
  constructor() {
    super(...arguments), this.type = "line";
  }
  getPoints() {
    return [new D(this.getAttribute("x1").getPixels("x"), this.getAttribute("y1").getPixels("y")), new D(this.getAttribute("x2").getPixels("x"), this.getAttribute("y2").getPixels("y"))];
  }
  path(e) {
    var [{
      x: t,
      y: r
    }, {
      x: i,
      y: n
    }] = this.getPoints();
    return e && (e.beginPath(), e.moveTo(t, r), e.lineTo(i, n)), new he(t, r, i, n);
  }
  getMarkers() {
    var [e, t] = this.getPoints(), r = e.angleTo(t);
    return [[e, r], [t, r]];
  }
}
class xl extends P {
  constructor(e, t, r) {
    super(e, t, r), this.type = "polyline", this.points = [], this.points = D.parsePath(this.getAttribute("points").getString());
  }
  path(e) {
    var {
      points: t
    } = this, [{
      x: r,
      y: i
    }] = t, n = new he(r, i);
    return e && (e.beginPath(), e.moveTo(r, i)), t.forEach((o) => {
      var {
        x: s,
        y: u
      } = o;
      n.addPoint(s, u), e && e.lineTo(s, u);
    }), n;
  }
  getMarkers() {
    var {
      points: e
    } = this, t = e.length - 1, r = [];
    return e.forEach((i, n) => {
      n !== t && r.push([i, i.angleTo(e[n + 1])]);
    }), r.length > 0 && r.push([e[e.length - 1], r[r.length - 1][1]]), r;
  }
}
class Lb extends xl {
  constructor() {
    super(...arguments), this.type = "polygon";
  }
  path(e) {
    var t = super.path(e), [{
      x: r,
      y: i
    }] = this.points;
    return e && (e.lineTo(r, i), e.closePath()), t;
  }
}
class Bb extends I {
  constructor() {
    super(...arguments), this.type = "pattern";
  }
  createPattern(e, t, r) {
    var i = this.getStyle("width").getPixels("x", !0), n = this.getStyle("height").getPixels("y", !0), o = new _t(this.document, null);
    o.attributes.viewBox = new O(this.document, "viewBox", this.getAttribute("viewBox").getValue()), o.attributes.width = new O(this.document, "width", "".concat(i, "px")), o.attributes.height = new O(this.document, "height", "".concat(n, "px")), o.attributes.transform = new O(this.document, "transform", this.getAttribute("patternTransform").getValue()), o.children = this.children;
    var s = this.document.createCanvas(i, n), u = s.getContext("2d"), l = this.getAttribute("x"), c = this.getAttribute("y");
    l.hasValue() && c.hasValue() && u.translate(l.getPixels("x", !0), c.getPixels("y", !0)), r.hasValue() ? this.styles["fill-opacity"] = r : Reflect.deleteProperty(this.styles, "fill-opacity");
    for (var v = -1; v <= 1; v++)
      for (var f = -1; f <= 1; f++)
        u.save(), o.attributes.x = new O(this.document, "x", v * s.width), o.attributes.y = new O(this.document, "y", f * s.height), o.render(u), u.restore();
    var h = e.createPattern(s, "repeat");
    return h;
  }
}
class jb extends I {
  constructor() {
    super(...arguments), this.type = "marker";
  }
  render(e, t, r) {
    if (t) {
      var {
        x: i,
        y: n
      } = t, o = this.getAttribute("orient").getString("auto"), s = this.getAttribute("markerUnits").getString("strokeWidth");
      e.translate(i, n), o === "auto" && e.rotate(r), s === "strokeWidth" && e.scale(e.lineWidth, e.lineWidth), e.save();
      var u = new _t(this.document, null);
      u.type = this.type, u.attributes.viewBox = new O(this.document, "viewBox", this.getAttribute("viewBox").getValue()), u.attributes.refX = new O(this.document, "refX", this.getAttribute("refX").getValue()), u.attributes.refY = new O(this.document, "refY", this.getAttribute("refY").getValue()), u.attributes.width = new O(this.document, "width", this.getAttribute("markerWidth").getValue()), u.attributes.height = new O(this.document, "height", this.getAttribute("markerHeight").getValue()), u.attributes.overflow = new O(this.document, "overflow", this.getAttribute("overflow").getValue()), u.attributes.fill = new O(this.document, "fill", this.getAttribute("fill").getColor("black")), u.attributes.stroke = new O(this.document, "stroke", this.getAttribute("stroke").getValue("none")), u.children = this.children, u.render(e), e.restore(), s === "strokeWidth" && e.scale(1 / e.lineWidth, 1 / e.lineWidth), o === "auto" && e.rotate(-r), e.translate(-i, -n);
    }
  }
}
class Ub extends I {
  constructor() {
    super(...arguments), this.type = "defs";
  }
  render() {
  }
}
class sn extends ze {
  constructor() {
    super(...arguments), this.type = "g";
  }
  getBoundingBox(e) {
    var t = new he();
    return this.children.forEach((r) => {
      t.addBoundingBox(r.getBoundingBox(e));
    }), t;
  }
}
class $l extends I {
  constructor(e, t, r) {
    super(e, t, r), this.attributesToInherit = ["gradientUnits"], this.stops = [];
    var {
      stops: i,
      children: n
    } = this;
    n.forEach((o) => {
      o.type === "stop" && i.push(o);
    });
  }
  getGradientUnits() {
    return this.getAttribute("gradientUnits").getString("objectBoundingBox");
  }
  createGradient(e, t, r) {
    var i = this;
    this.getHrefAttribute().hasValue() && (i = this.getHrefAttribute().getDefinition(), this.inheritStopContainer(i));
    var {
      stops: n
    } = i, o = this.getGradient(e, t);
    if (!o)
      return this.addParentOpacity(r, n[n.length - 1].color);
    if (n.forEach((p) => {
      o.addColorStop(p.offset, this.addParentOpacity(r, p.color));
    }), this.getAttribute("gradientTransform").hasValue()) {
      var {
        document: s
      } = this, {
        MAX_VIRTUAL_PIXELS: u,
        viewPort: l
      } = s.screen, [c] = l.viewPorts, v = new bl(s, null);
      v.attributes.x = new O(s, "x", -u / 3), v.attributes.y = new O(s, "y", -u / 3), v.attributes.width = new O(s, "width", u), v.attributes.height = new O(s, "height", u);
      var f = new sn(s, null);
      f.attributes.transform = new O(s, "transform", this.getAttribute("gradientTransform").getValue()), f.children = [v];
      var h = new _t(s, null);
      h.attributes.x = new O(s, "x", 0), h.attributes.y = new O(s, "y", 0), h.attributes.width = new O(s, "width", c.width), h.attributes.height = new O(s, "height", c.height), h.children = [f];
      var d = s.createCanvas(c.width, c.height), g = d.getContext("2d");
      return g.fillStyle = o, h.render(g), g.createPattern(d, "no-repeat");
    }
    return o;
  }
  inheritStopContainer(e) {
    this.attributesToInherit.forEach((t) => {
      !this.getAttribute(t).hasValue() && e.getAttribute(t).hasValue() && this.getAttribute(t, !0).setValue(e.getAttribute(t).getValue());
    });
  }
  addParentOpacity(e, t) {
    if (e.hasValue()) {
      var r = new O(this.document, "color", t);
      return r.addOpacity(e).getColor();
    }
    return t;
  }
}
class Fb extends $l {
  constructor(e, t, r) {
    super(e, t, r), this.type = "linearGradient", this.attributesToInherit.push("x1", "y1", "x2", "y2");
  }
  getGradient(e, t) {
    var r = this.getGradientUnits() === "objectBoundingBox", i = r ? t.getBoundingBox(e) : null;
    if (r && !i)
      return null;
    !this.getAttribute("x1").hasValue() && !this.getAttribute("y1").hasValue() && !this.getAttribute("x2").hasValue() && !this.getAttribute("y2").hasValue() && (this.getAttribute("x1", !0).setValue(0), this.getAttribute("y1", !0).setValue(0), this.getAttribute("x2", !0).setValue(1), this.getAttribute("y2", !0).setValue(0));
    var n = r ? i.x + i.width * this.getAttribute("x1").getNumber() : this.getAttribute("x1").getPixels("x"), o = r ? i.y + i.height * this.getAttribute("y1").getNumber() : this.getAttribute("y1").getPixels("y"), s = r ? i.x + i.width * this.getAttribute("x2").getNumber() : this.getAttribute("x2").getPixels("x"), u = r ? i.y + i.height * this.getAttribute("y2").getNumber() : this.getAttribute("y2").getPixels("y");
    return n === s && o === u ? null : e.createLinearGradient(n, o, s, u);
  }
}
class Gb extends $l {
  constructor(e, t, r) {
    super(e, t, r), this.type = "radialGradient", this.attributesToInherit.push("cx", "cy", "r", "fx", "fy", "fr");
  }
  getGradient(e, t) {
    var r = this.getGradientUnits() === "objectBoundingBox", i = t.getBoundingBox(e);
    if (r && !i)
      return null;
    this.getAttribute("cx").hasValue() || this.getAttribute("cx", !0).setValue("50%"), this.getAttribute("cy").hasValue() || this.getAttribute("cy", !0).setValue("50%"), this.getAttribute("r").hasValue() || this.getAttribute("r", !0).setValue("50%");
    var n = r ? i.x + i.width * this.getAttribute("cx").getNumber() : this.getAttribute("cx").getPixels("x"), o = r ? i.y + i.height * this.getAttribute("cy").getNumber() : this.getAttribute("cy").getPixels("y"), s = n, u = o;
    this.getAttribute("fx").hasValue() && (s = r ? i.x + i.width * this.getAttribute("fx").getNumber() : this.getAttribute("fx").getPixels("x")), this.getAttribute("fy").hasValue() && (u = r ? i.y + i.height * this.getAttribute("fy").getNumber() : this.getAttribute("fy").getPixels("y"));
    var l = r ? (i.width + i.height) / 2 * this.getAttribute("r").getNumber() : this.getAttribute("r").getPixels(), c = this.getAttribute("fr").getPixels();
    return e.createRadialGradient(s, u, c, n, o, l);
  }
}
class zb extends I {
  constructor(e, t, r) {
    super(e, t, r), this.type = "stop";
    var i = Math.max(0, Math.min(1, this.getAttribute("offset").getNumber())), n = this.getStyle("stop-opacity"), o = this.getStyle("stop-color", !0);
    o.getString() === "" && o.setValue("#000"), n.hasValue() && (o = o.addOpacity(n)), this.offset = i, this.color = o.getColor();
  }
}
class on extends I {
  constructor(e, t, r) {
    super(e, t, r), this.type = "animate", this.duration = 0, this.initialValue = null, this.initialUnits = "", this.removed = !1, this.frozen = !1, e.screen.animations.push(this), this.begin = this.getAttribute("begin").getMilliseconds(), this.maxDuration = this.begin + this.getAttribute("dur").getMilliseconds(), this.from = this.getAttribute("from"), this.to = this.getAttribute("to"), this.values = new O(e, "values", null);
    var i = this.getAttribute("values");
    i.hasValue() && this.values.setValue(i.getString().split(";"));
  }
  getProperty() {
    var e = this.getAttribute("attributeType").getString(), t = this.getAttribute("attributeName").getString();
    return e === "CSS" ? this.parent.getStyle(t, !0) : this.parent.getAttribute(t, !0);
  }
  calcValue() {
    var {
      initialUnits: e
    } = this, {
      progress: t,
      from: r,
      to: i
    } = this.getProgress(), n = r.getNumber() + (i.getNumber() - r.getNumber()) * t;
    return e === "%" && (n *= 100), "".concat(n).concat(e);
  }
  update(e) {
    var {
      parent: t
    } = this, r = this.getProperty();
    if (this.initialValue || (this.initialValue = r.getString(), this.initialUnits = r.getUnits()), this.duration > this.maxDuration) {
      var i = this.getAttribute("fill").getString("remove");
      if (this.getAttribute("repeatCount").getString() === "indefinite" || this.getAttribute("repeatDur").getString() === "indefinite")
        this.duration = 0;
      else if (i === "freeze" && !this.frozen)
        this.frozen = !0, t.animationFrozen = !0, t.animationFrozenValue = r.getString();
      else if (i === "remove" && !this.removed)
        return this.removed = !0, r.setValue(t.animationFrozen ? t.animationFrozenValue : this.initialValue), !0;
      return !1;
    }
    this.duration += e;
    var n = !1;
    if (this.begin < this.duration) {
      var o = this.calcValue(), s = this.getAttribute("type");
      if (s.hasValue()) {
        var u = s.getString();
        o = "".concat(u, "(").concat(o, ")");
      }
      r.setValue(o), n = !0;
    }
    return n;
  }
  getProgress() {
    var {
      document: e,
      values: t
    } = this, r = {
      progress: (this.duration - this.begin) / (this.maxDuration - this.begin)
    };
    if (t.hasValue()) {
      var i = r.progress * (t.getValue().length - 1), n = Math.floor(i), o = Math.ceil(i);
      r.from = new O(e, "from", parseFloat(t.getValue()[n])), r.to = new O(e, "to", parseFloat(t.getValue()[o])), r.progress = (i - n) / (o - n);
    } else
      r.from = this.from, r.to = this.to;
    return r;
  }
}
class Hb extends on {
  constructor() {
    super(...arguments), this.type = "animateColor";
  }
  calcValue() {
    var {
      progress: e,
      from: t,
      to: r
    } = this.getProgress(), i = new yi(t.getColor()), n = new yi(r.getColor());
    if (i.ok && n.ok) {
      var o = i.r + (n.r - i.r) * e, s = i.g + (n.g - i.g) * e, u = i.b + (n.b - i.b) * e;
      return "rgb(".concat(Math.floor(o), ", ").concat(Math.floor(s), ", ").concat(Math.floor(u), ")");
    }
    return this.getAttribute("from").getColor();
  }
}
class Yb extends on {
  constructor() {
    super(...arguments), this.type = "animateTransform";
  }
  calcValue() {
    var {
      progress: e,
      from: t,
      to: r
    } = this.getProgress(), i = ie(t.getString()), n = ie(r.getString()), o = i.map((s, u) => {
      var l = n[u];
      return s + (l - s) * e;
    }).join(" ");
    return o;
  }
}
class Wb extends I {
  constructor(e, t, r) {
    super(e, t, r), this.type = "font", this.glyphs = {}, this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber();
    var {
      definitions: i
    } = e, {
      children: n
    } = this;
    for (var o of n)
      switch (o.type) {
        case "font-face": {
          this.fontFace = o;
          var s = o.getStyle("font-family");
          s.hasValue() && (i[s.getString()] = this);
          break;
        }
        case "missing-glyph":
          this.missingGlyph = o;
          break;
        case "glyph": {
          var u = o;
          u.arabicForm ? (this.isRTL = !0, this.isArabic = !0, typeof this.glyphs[u.unicode] > "u" && (this.glyphs[u.unicode] = {}), this.glyphs[u.unicode][u.arabicForm] = u) : this.glyphs[u.unicode] = u;
          break;
        }
      }
  }
  render() {
  }
}
class Xb extends I {
  constructor(e, t, r) {
    super(e, t, r), this.type = "font-face", this.ascent = this.getAttribute("ascent").getNumber(), this.descent = this.getAttribute("descent").getNumber(), this.unitsPerEm = this.getAttribute("units-per-em").getNumber();
  }
}
class qb extends P {
  constructor() {
    super(...arguments), this.type = "missing-glyph", this.horizAdvX = 0;
  }
}
class Kb extends Ae {
  constructor() {
    super(...arguments), this.type = "tref";
  }
  getText() {
    var e = this.getHrefAttribute().getDefinition();
    if (e) {
      var t = e.children[0];
      if (t)
        return t.getText();
    }
    return "";
  }
}
class Qb extends Ae {
  constructor(e, t, r) {
    super(e, t, r), this.type = "a";
    var {
      childNodes: i
    } = t, n = i[0], o = i.length > 0 && Array.from(i).every((s) => s.nodeType === 3);
    this.hasText = o, this.text = o ? this.getTextFromNode(n) : "";
  }
  getText() {
    return this.text;
  }
  renderChildren(e) {
    if (this.hasText) {
      super.renderChildren(e);
      var {
        document: t,
        x: r,
        y: i
      } = this, {
        mouse: n
      } = t.screen, o = new O(t, "fontSize", J.parse(t.ctx.font).fontSize);
      n.isWorking() && n.checkBoundingBox(this, new he(r, i - o.getPixels("y"), r + this.measureText(e), i));
    } else if (this.children.length > 0) {
      var s = new sn(this.document, null);
      s.children = this.children, s.parent = this, s.render(e);
    }
  }
  onClick() {
    var {
      window: e
    } = this.document;
    e && e.open(this.getHrefAttribute().getString());
  }
  onMouseMove() {
    var e = this.document.ctx;
    e.canvas.style.cursor = "pointer";
  }
}
function Ao(a, e) {
  var t = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(a);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(a, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function nr(a) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ao(Object(t), !0).forEach(function(r) {
      an(a, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(t)) : Ao(Object(t)).forEach(function(r) {
      Object.defineProperty(a, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return a;
}
class Zb extends Ae {
  constructor(e, t, r) {
    super(e, t, r), this.type = "textPath", this.textWidth = 0, this.textHeight = 0, this.pathLength = -1, this.glyphInfo = null, this.letterSpacingCache = [], this.measuresCache = /* @__PURE__ */ new Map([["", 0]]);
    var i = this.getHrefAttribute().getDefinition();
    this.text = this.getTextFromNode(), this.dataArray = this.parsePathData(i);
  }
  getText() {
    return this.text;
  }
  path(e) {
    var {
      dataArray: t
    } = this;
    e && e.beginPath(), t.forEach((r) => {
      var {
        type: i,
        points: n
      } = r;
      switch (i) {
        case w.LINE_TO:
          e && e.lineTo(n[0], n[1]);
          break;
        case w.MOVE_TO:
          e && e.moveTo(n[0], n[1]);
          break;
        case w.CURVE_TO:
          e && e.bezierCurveTo(n[0], n[1], n[2], n[3], n[4], n[5]);
          break;
        case w.QUAD_TO:
          e && e.quadraticCurveTo(n[0], n[1], n[2], n[3]);
          break;
        case w.ARC: {
          var [o, s, u, l, c, v, f, h] = n, d = u > l ? u : l, g = u > l ? 1 : u / l, p = u > l ? l / u : 1;
          e && (e.translate(o, s), e.rotate(f), e.scale(g, p), e.arc(0, 0, d, c, c + v, !!(1 - h)), e.scale(1 / g, 1 / p), e.rotate(-f), e.translate(-o, -s));
          break;
        }
        case w.CLOSE_PATH:
          e && e.closePath();
          break;
      }
    });
  }
  renderChildren(e) {
    this.setTextData(e), e.save();
    var t = this.parent.getStyle("text-decoration").getString(), r = this.getFontSize(), {
      glyphInfo: i
    } = this, n = e.fillStyle;
    t === "underline" && e.beginPath(), i.forEach((o, s) => {
      var {
        p0: u,
        p1: l,
        rotation: c,
        text: v
      } = o;
      e.save(), e.translate(u.x, u.y), e.rotate(c), e.fillStyle && e.fillText(v, 0, 0), e.strokeStyle && e.strokeText(v, 0, 0), e.restore(), t === "underline" && (s === 0 && e.moveTo(u.x, u.y + r / 8), e.lineTo(l.x, l.y + r / 5));
    }), t === "underline" && (e.lineWidth = r / 20, e.strokeStyle = n, e.stroke(), e.closePath()), e.restore();
  }
  getLetterSpacingAt() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return this.letterSpacingCache[e] || 0;
  }
  findSegmentToFitChar(e, t, r, i, n, o, s, u, l) {
    var c = o, v = this.measureText(e, u);
    u === " " && t === "justify" && r < i && (v += (i - r) / n), l > -1 && (c += this.getLetterSpacingAt(l));
    var f = this.textHeight / 20, h = this.getEquidistantPointOnPath(c, f, 0), d = this.getEquidistantPointOnPath(c + v, f, 0), g = {
      p0: h,
      p1: d
    }, p = h && d ? Math.atan2(d.y - h.y, d.x - h.x) : 0;
    if (s) {
      var y = Math.cos(Math.PI / 2 + p) * s, x = Math.cos(-p) * s;
      g.p0 = nr(nr({}, h), {}, {
        x: h.x + y,
        y: h.y + x
      }), g.p1 = nr(nr({}, d), {}, {
        x: d.x + y,
        y: d.y + x
      });
    }
    return c += v, {
      offset: c,
      segment: g,
      rotation: p
    };
  }
  measureText(e, t) {
    var {
      measuresCache: r
    } = this, i = t || this.getText();
    if (r.has(i))
      return r.get(i);
    var n = this.measureTargetText(e, i);
    return r.set(i, n), n;
  }
  // This method supposes what all custom fonts already loaded.
  // If some font will be loaded after this method call, <textPath> will not be rendered correctly.
  // You need to call this method manually to update glyphs cache.
  setTextData(e) {
    if (!this.glyphInfo) {
      var t = this.getText(), r = t.split(""), i = t.split(" ").length - 1, n = this.parent.getAttribute("dx").split().map(($) => $.getPixels("x")), o = this.parent.getAttribute("dy").getPixels("y"), s = this.parent.getStyle("text-anchor").getString("start"), u = this.getStyle("letter-spacing"), l = this.parent.getStyle("letter-spacing"), c = 0;
      !u.hasValue() || u.getValue() === "inherit" ? c = l.getPixels() : u.hasValue() && u.getValue() !== "initial" && u.getValue() !== "unset" && (c = u.getPixels());
      var v = [], f = t.length;
      this.letterSpacingCache = v;
      for (var h = 0; h < f; h++)
        v.push(typeof n[h] < "u" ? n[h] : c);
      var d = v.reduce(($, S, E) => E === 0 ? 0 : $ + S || 0, 0), g = this.measureText(e), p = Math.max(g + d, 0);
      this.textWidth = g, this.textHeight = this.getFontSize(), this.glyphInfo = [];
      var y = this.getPathLength(), x = this.getStyle("startOffset").getNumber(0) * y, b = 0;
      (s === "middle" || s === "center") && (b = -p / 2), (s === "end" || s === "right") && (b = -p), b += x, r.forEach(($, S) => {
        var {
          offset: E,
          segment: T,
          rotation: C
        } = this.findSegmentToFitChar(e, s, p, y, i, b, o, $, S);
        b = E, !(!T.p0 || !T.p1) && this.glyphInfo.push({
          // transposeX: midpoint.x,
          // transposeY: midpoint.y,
          text: r[S],
          p0: T.p0,
          p1: T.p1,
          rotation: C
        });
      });
    }
  }
  parsePathData(e) {
    if (this.pathLength = -1, !e)
      return [];
    var t = [], {
      pathParser: r
    } = e;
    for (r.reset(); !r.isEnd(); ) {
      var {
        current: i
      } = r, n = i ? i.x : 0, o = i ? i.y : 0, s = r.next(), u = s.type, l = [];
      switch (s.type) {
        case w.MOVE_TO:
          this.pathM(r, l);
          break;
        case w.LINE_TO:
          u = this.pathL(r, l);
          break;
        case w.HORIZ_LINE_TO:
          u = this.pathH(r, l);
          break;
        case w.VERT_LINE_TO:
          u = this.pathV(r, l);
          break;
        case w.CURVE_TO:
          this.pathC(r, l);
          break;
        case w.SMOOTH_CURVE_TO:
          u = this.pathS(r, l);
          break;
        case w.QUAD_TO:
          this.pathQ(r, l);
          break;
        case w.SMOOTH_QUAD_TO:
          u = this.pathT(r, l);
          break;
        case w.ARC:
          l = this.pathA(r);
          break;
        case w.CLOSE_PATH:
          P.pathZ(r);
          break;
      }
      s.type !== w.CLOSE_PATH ? t.push({
        type: u,
        points: l,
        start: {
          x: n,
          y: o
        },
        pathLength: this.calcLength(n, o, u, l)
      }) : t.push({
        type: w.CLOSE_PATH,
        points: [],
        pathLength: 0
      });
    }
    return t;
  }
  pathM(e, t) {
    var {
      x: r,
      y: i
    } = P.pathM(e).point;
    t.push(r, i);
  }
  pathL(e, t) {
    var {
      x: r,
      y: i
    } = P.pathL(e).point;
    return t.push(r, i), w.LINE_TO;
  }
  pathH(e, t) {
    var {
      x: r,
      y: i
    } = P.pathH(e).point;
    return t.push(r, i), w.LINE_TO;
  }
  pathV(e, t) {
    var {
      x: r,
      y: i
    } = P.pathV(e).point;
    return t.push(r, i), w.LINE_TO;
  }
  pathC(e, t) {
    var {
      point: r,
      controlPoint: i,
      currentPoint: n
    } = P.pathC(e);
    t.push(r.x, r.y, i.x, i.y, n.x, n.y);
  }
  pathS(e, t) {
    var {
      point: r,
      controlPoint: i,
      currentPoint: n
    } = P.pathS(e);
    return t.push(r.x, r.y, i.x, i.y, n.x, n.y), w.CURVE_TO;
  }
  pathQ(e, t) {
    var {
      controlPoint: r,
      currentPoint: i
    } = P.pathQ(e);
    t.push(r.x, r.y, i.x, i.y);
  }
  pathT(e, t) {
    var {
      controlPoint: r,
      currentPoint: i
    } = P.pathT(e);
    return t.push(r.x, r.y, i.x, i.y), w.QUAD_TO;
  }
  pathA(e) {
    var {
      rX: t,
      rY: r,
      sweepFlag: i,
      xAxisRotation: n,
      centp: o,
      a1: s,
      ad: u
    } = P.pathA(e);
    return i === 0 && u > 0 && (u -= 2 * Math.PI), i === 1 && u < 0 && (u += 2 * Math.PI), [o.x, o.y, t, r, s, u, n, i];
  }
  calcLength(e, t, r, i) {
    var n = 0, o = null, s = null, u = 0;
    switch (r) {
      case w.LINE_TO:
        return this.getLineLength(e, t, i[0], i[1]);
      case w.CURVE_TO:
        for (n = 0, o = this.getPointOnCubicBezier(0, e, t, i[0], i[1], i[2], i[3], i[4], i[5]), u = 0.01; u <= 1; u += 0.01)
          s = this.getPointOnCubicBezier(u, e, t, i[0], i[1], i[2], i[3], i[4], i[5]), n += this.getLineLength(o.x, o.y, s.x, s.y), o = s;
        return n;
      case w.QUAD_TO:
        for (n = 0, o = this.getPointOnQuadraticBezier(0, e, t, i[0], i[1], i[2], i[3]), u = 0.01; u <= 1; u += 0.01)
          s = this.getPointOnQuadraticBezier(u, e, t, i[0], i[1], i[2], i[3]), n += this.getLineLength(o.x, o.y, s.x, s.y), o = s;
        return n;
      case w.ARC: {
        n = 0;
        var l = i[4], c = i[5], v = i[4] + c, f = Math.PI / 180;
        if (Math.abs(l - v) < f && (f = Math.abs(l - v)), o = this.getPointOnEllipticalArc(i[0], i[1], i[2], i[3], l, 0), c < 0)
          for (u = l - f; u > v; u -= f)
            s = this.getPointOnEllipticalArc(i[0], i[1], i[2], i[3], u, 0), n += this.getLineLength(o.x, o.y, s.x, s.y), o = s;
        else
          for (u = l + f; u < v; u += f)
            s = this.getPointOnEllipticalArc(i[0], i[1], i[2], i[3], u, 0), n += this.getLineLength(o.x, o.y, s.x, s.y), o = s;
        return s = this.getPointOnEllipticalArc(i[0], i[1], i[2], i[3], v, 0), n += this.getLineLength(o.x, o.y, s.x, s.y), n;
      }
    }
    return 0;
  }
  getPointOnLine(e, t, r, i, n) {
    var o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : t, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : r, u = (n - r) / (i - t + nt), l = Math.sqrt(e * e / (1 + u * u));
    i < t && (l *= -1);
    var c = u * l, v = null;
    if (i === t)
      v = {
        x: o,
        y: s + c
      };
    else if ((s - r) / (o - t + nt) === u)
      v = {
        x: o + l,
        y: s + c
      };
    else {
      var f = 0, h = 0, d = this.getLineLength(t, r, i, n);
      if (d < nt)
        return null;
      var g = (o - t) * (i - t) + (s - r) * (n - r);
      g /= d * d, f = t + g * (i - t), h = r + g * (n - r);
      var p = this.getLineLength(o, s, f, h), y = Math.sqrt(e * e - p * p);
      l = Math.sqrt(y * y / (1 + u * u)), i < t && (l *= -1), c = u * l, v = {
        x: f + l,
        y: h + c
      };
    }
    return v;
  }
  getPointOnPath(e) {
    var t = this.getPathLength(), r = 0, i = null;
    if (e < -5e-5 || e - 5e-5 > t)
      return null;
    var {
      dataArray: n
    } = this;
    for (var o of n) {
      if (o && (o.pathLength < 5e-5 || r + o.pathLength + 5e-5 < e)) {
        r += o.pathLength;
        continue;
      }
      var s = e - r, u = 0;
      switch (o.type) {
        case w.LINE_TO:
          i = this.getPointOnLine(s, o.start.x, o.start.y, o.points[0], o.points[1], o.start.x, o.start.y);
          break;
        case w.ARC: {
          var l = o.points[4], c = o.points[5], v = o.points[4] + c;
          if (u = l + s / o.pathLength * c, c < 0 && u < v || c >= 0 && u > v)
            break;
          i = this.getPointOnEllipticalArc(o.points[0], o.points[1], o.points[2], o.points[3], u, o.points[6]);
          break;
        }
        case w.CURVE_TO:
          u = s / o.pathLength, u > 1 && (u = 1), i = this.getPointOnCubicBezier(u, o.start.x, o.start.y, o.points[0], o.points[1], o.points[2], o.points[3], o.points[4], o.points[5]);
          break;
        case w.QUAD_TO:
          u = s / o.pathLength, u > 1 && (u = 1), i = this.getPointOnQuadraticBezier(u, o.start.x, o.start.y, o.points[0], o.points[1], o.points[2], o.points[3]);
          break;
      }
      if (i)
        return i;
      break;
    }
    return null;
  }
  getLineLength(e, t, r, i) {
    return Math.sqrt((r - e) * (r - e) + (i - t) * (i - t));
  }
  getPathLength() {
    return this.pathLength === -1 && (this.pathLength = this.dataArray.reduce((e, t) => t.pathLength > 0 ? e + t.pathLength : e, 0)), this.pathLength;
  }
  getPointOnCubicBezier(e, t, r, i, n, o, s, u, l) {
    var c = u * To(e) + o * Oo(e) + i * Eo(e) + t * So(e), v = l * To(e) + s * Oo(e) + n * Eo(e) + r * So(e);
    return {
      x: c,
      y: v
    };
  }
  getPointOnQuadraticBezier(e, t, r, i, n, o, s) {
    var u = o * wo(e) + i * Co(e) + t * Po(e), l = s * wo(e) + n * Co(e) + r * Po(e);
    return {
      x: u,
      y: l
    };
  }
  getPointOnEllipticalArc(e, t, r, i, n, o) {
    var s = Math.cos(o), u = Math.sin(o), l = {
      x: r * Math.cos(n),
      y: i * Math.sin(n)
    };
    return {
      x: e + (l.x * s - l.y * u),
      y: t + (l.x * u + l.y * s)
    };
  }
  // TODO need some optimisations. possibly build cache only for curved segments?
  buildEquidistantCache(e, t) {
    var r = this.getPathLength(), i = t || 0.25, n = e || r / 100;
    if (!this.equidistantCache || this.equidistantCache.step !== n || this.equidistantCache.precision !== i) {
      this.equidistantCache = {
        step: n,
        precision: i,
        points: []
      };
      for (var o = 0, s = 0; s <= r; s += i) {
        var u = this.getPointOnPath(s), l = this.getPointOnPath(s + i);
        !u || !l || (o += this.getLineLength(u.x, u.y, l.x, l.y), o >= n && (this.equidistantCache.points.push({
          x: u.x,
          y: u.y,
          distance: s
        }), o -= n));
      }
    }
  }
  getEquidistantPointOnPath(e, t, r) {
    if (this.buildEquidistantCache(t, r), e < 0 || e - this.getPathLength() > 5e-5)
      return null;
    var i = Math.round(e / this.getPathLength() * (this.equidistantCache.points.length - 1));
    return this.equidistantCache.points[i] || null;
  }
}
var Jb = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*)$/i;
class e2 extends ze {
  constructor(e, t, r) {
    super(e, t, r), this.type = "image", this.loaded = !1;
    var i = this.getHrefAttribute().getString();
    if (i) {
      var n = i.endsWith(".svg") || /^\s*data:image\/svg\+xml/i.test(i);
      e.images.push(this), n ? this.loadSvg(i) : this.loadImage(i), this.isSvg = n;
    }
  }
  loadImage(e) {
    var t = this;
    return Te(function* () {
      try {
        var r = yield t.document.createImage(e);
        t.image = r;
      } catch (i) {
        console.error('Error while loading image "'.concat(e, '":'), i);
      }
      t.loaded = !0;
    })();
  }
  loadSvg(e) {
    var t = this;
    return Te(function* () {
      var r = Jb.exec(e);
      if (r) {
        var i = r[5];
        r[4] === "base64" ? t.image = atob(i) : t.image = decodeURIComponent(i);
      } else
        try {
          var n = yield t.document.fetch(e), o = yield n.text();
          t.image = o;
        } catch (s) {
          console.error('Error while loading image "'.concat(e, '":'), s);
        }
      t.loaded = !0;
    })();
  }
  renderChildren(e) {
    var {
      document: t,
      image: r,
      loaded: i
    } = this, n = this.getAttribute("x").getPixels("x"), o = this.getAttribute("y").getPixels("y"), s = this.getStyle("width").getPixels("x"), u = this.getStyle("height").getPixels("y");
    if (!(!i || !r || !s || !u)) {
      if (e.save(), e.translate(n, o), this.isSvg) {
        var l = t.canvg.forkString(e, this.image, {
          ignoreMouse: !0,
          ignoreAnimation: !0,
          ignoreDimensions: !0,
          ignoreClear: !0,
          offsetX: 0,
          offsetY: 0,
          scaleWidth: s,
          scaleHeight: u
        });
        l.document.documentElement.parent = this, l.render();
      } else {
        var c = this.image;
        t.setViewBox({
          ctx: e,
          aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
          width: s,
          desiredWidth: c.width,
          height: u,
          desiredHeight: c.height
        }), this.loaded && (typeof c.complete > "u" || c.complete) && e.drawImage(c, 0, 0);
      }
      e.restore();
    }
  }
  getBoundingBox() {
    var e = this.getAttribute("x").getPixels("x"), t = this.getAttribute("y").getPixels("y"), r = this.getStyle("width").getPixels("x"), i = this.getStyle("height").getPixels("y");
    return new he(e, t, e + r, t + i);
  }
}
class t2 extends ze {
  constructor() {
    super(...arguments), this.type = "symbol";
  }
  render(e) {
  }
}
class r2 {
  constructor(e) {
    this.document = e, this.loaded = !1, e.fonts.push(this);
  }
  load(e, t) {
    var r = this;
    return Te(function* () {
      try {
        var {
          document: i
        } = r, n = yield i.canvg.parser.load(t), o = n.getElementsByTagName("font");
        Array.from(o).forEach((s) => {
          var u = i.createElement(s);
          i.definitions[e] = u;
        });
      } catch (s) {
        console.error('Error while loading font "'.concat(t, '":'), s);
      }
      r.loaded = !0;
    })();
  }
}
class Tl extends I {
  constructor(e, t, r) {
    super(e, t, r), this.type = "style";
    var i = vt(
      Array.from(t.childNodes).map((o) => o.textContent).join("").replace(/(\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, "").replace(/@import.*;/g, "")
      // remove imports
    ), n = i.split("}");
    n.forEach((o) => {
      var s = o.trim();
      if (s) {
        var u = s.split("{"), l = u[0].split(","), c = u[1].split(";");
        l.forEach((v) => {
          var f = v.trim();
          if (f) {
            var h = e.styles[f] || {};
            if (c.forEach((p) => {
              var y = p.indexOf(":"), x = p.substr(0, y).trim(), b = p.substr(y + 1, p.length - y).trim();
              x && b && (h[x] = new O(e, x, b));
            }), e.styles[f] = h, e.stylesSpecificity[f] = yb(f), f === "@font-face") {
              var d = h["font-family"].getString().replace(/"|'/g, ""), g = h.src.getString().split(",");
              g.forEach((p) => {
                if (p.indexOf('format("svg")') > 0) {
                  var y = fl(p);
                  y && new r2(e).load(d, y);
                }
              });
            }
          }
        });
      }
    });
  }
}
Tl.parseExternalUrl = fl;
class a2 extends ze {
  constructor() {
    super(...arguments), this.type = "use";
  }
  setContext(e) {
    super.setContext(e);
    var t = this.getAttribute("x"), r = this.getAttribute("y");
    t.hasValue() && e.translate(t.getPixels("x"), 0), r.hasValue() && e.translate(0, r.getPixels("y"));
  }
  path(e) {
    var {
      element: t
    } = this;
    t && t.path(e);
  }
  renderChildren(e) {
    var {
      document: t,
      element: r
    } = this;
    if (r) {
      var i = r;
      if (r.type === "symbol" && (i = new _t(t, null), i.attributes.viewBox = new O(t, "viewBox", r.getAttribute("viewBox").getString()), i.attributes.preserveAspectRatio = new O(t, "preserveAspectRatio", r.getAttribute("preserveAspectRatio").getString()), i.attributes.overflow = new O(t, "overflow", r.getAttribute("overflow").getString()), i.children = r.children, r.styles.opacity = new O(t, "opacity", this.calculateOpacity())), i.type === "svg") {
        var n = this.getStyle("width", !1, !0), o = this.getStyle("height", !1, !0);
        n.hasValue() && (i.attributes.width = new O(t, "width", n.getString())), o.hasValue() && (i.attributes.height = new O(t, "height", o.getString()));
      }
      var s = i.parent;
      i.parent = this, i.render(e), i.parent = s;
    }
  }
  getBoundingBox(e) {
    var {
      element: t
    } = this;
    return t ? t.getBoundingBox(e) : null;
  }
  elementTransform() {
    var {
      document: e,
      element: t
    } = this;
    return Be.fromElement(e, t);
  }
  get element() {
    return this.cachedElement || (this.cachedElement = this.getHrefAttribute().getDefinition()), this.cachedElement;
  }
}
function sr(a, e, t, r, i, n) {
  return a[t * r * 4 + e * 4 + n];
}
function or(a, e, t, r, i, n, o) {
  a[t * r * 4 + e * 4 + n] = o;
}
function U(a, e, t) {
  var r = a[e];
  return r * t;
}
function be(a, e, t, r) {
  return e + Math.cos(a) * t + Math.sin(a) * r;
}
class Ol extends I {
  constructor(e, t, r) {
    super(e, t, r), this.type = "feColorMatrix";
    var i = ie(this.getAttribute("values").getString());
    switch (this.getAttribute("type").getString("matrix")) {
      case "saturate": {
        var n = i[0];
        i = [0.213 + 0.787 * n, 0.715 - 0.715 * n, 0.072 - 0.072 * n, 0, 0, 0.213 - 0.213 * n, 0.715 + 0.285 * n, 0.072 - 0.072 * n, 0, 0, 0.213 - 0.213 * n, 0.715 - 0.715 * n, 0.072 + 0.928 * n, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
        break;
      }
      case "hueRotate": {
        var o = i[0] * Math.PI / 180;
        i = [be(o, 0.213, 0.787, -0.213), be(o, 0.715, -0.715, -0.715), be(o, 0.072, -0.072, 0.928), 0, 0, be(o, 0.213, -0.213, 0.143), be(o, 0.715, 0.285, 0.14), be(o, 0.072, -0.072, -0.283), 0, 0, be(o, 0.213, -0.213, -0.787), be(o, 0.715, -0.715, 0.715), be(o, 0.072, 0.928, 0.072), 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
        break;
      }
      case "luminanceToAlpha":
        i = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2125, 0.7154, 0.0721, 0, 0, 0, 0, 0, 0, 1];
        break;
    }
    this.matrix = i, this.includeOpacity = this.getAttribute("includeOpacity").hasValue();
  }
  apply(e, t, r, i, n) {
    for (var {
      includeOpacity: o,
      matrix: s
    } = this, u = e.getImageData(0, 0, i, n), l = 0; l < n; l++)
      for (var c = 0; c < i; c++) {
        var v = sr(u.data, c, l, i, n, 0), f = sr(u.data, c, l, i, n, 1), h = sr(u.data, c, l, i, n, 2), d = sr(u.data, c, l, i, n, 3), g = U(s, 0, v) + U(s, 1, f) + U(s, 2, h) + U(s, 3, d) + U(s, 4, 1), p = U(s, 5, v) + U(s, 6, f) + U(s, 7, h) + U(s, 8, d) + U(s, 9, 1), y = U(s, 10, v) + U(s, 11, f) + U(s, 12, h) + U(s, 13, d) + U(s, 14, 1), x = U(s, 15, v) + U(s, 16, f) + U(s, 17, h) + U(s, 18, d) + U(s, 19, 1);
        o && (g = 0, p = 0, y = 0, x *= d / 255), or(u.data, c, l, i, n, 0, g), or(u.data, c, l, i, n, 1, p), or(u.data, c, l, i, n, 2, y), or(u.data, c, l, i, n, 3, x);
      }
    e.clearRect(0, 0, i, n), e.putImageData(u, 0, 0);
  }
}
class kr extends I {
  constructor() {
    super(...arguments), this.type = "mask";
  }
  apply(e, t) {
    var {
      document: r
    } = this, i = this.getAttribute("x").getPixels("x"), n = this.getAttribute("y").getPixels("y"), o = this.getStyle("width").getPixels("x"), s = this.getStyle("height").getPixels("y");
    if (!o && !s) {
      var u = new he();
      this.children.forEach((d) => {
        u.addBoundingBox(d.getBoundingBox(e));
      }), i = Math.floor(u.x1), n = Math.floor(u.y1), o = Math.floor(u.width), s = Math.floor(u.height);
    }
    var l = this.removeStyles(t, kr.ignoreStyles), c = r.createCanvas(i + o, n + s), v = c.getContext("2d");
    r.screen.setDefaults(v), this.renderChildren(v), new Ol(r, {
      nodeType: 1,
      childNodes: [],
      attributes: [{
        nodeName: "type",
        value: "luminanceToAlpha"
      }, {
        nodeName: "includeOpacity",
        value: "true"
      }]
    }).apply(v, 0, 0, i + o, n + s);
    var f = r.createCanvas(i + o, n + s), h = f.getContext("2d");
    r.screen.setDefaults(h), t.render(h), h.globalCompositeOperation = "destination-in", h.fillStyle = v.createPattern(c, "no-repeat"), h.fillRect(0, 0, i + o, n + s), e.fillStyle = h.createPattern(f, "no-repeat"), e.fillRect(0, 0, i + o, n + s), this.restoreStyles(t, l);
  }
  render(e) {
  }
}
kr.ignoreStyles = ["mask", "transform", "clip-path"];
var Ro = () => {
};
class i2 extends I {
  constructor() {
    super(...arguments), this.type = "clipPath";
  }
  apply(e) {
    var {
      document: t
    } = this, r = Reflect.getPrototypeOf(e), {
      beginPath: i,
      closePath: n
    } = e;
    r && (r.beginPath = Ro, r.closePath = Ro), Reflect.apply(i, e, []), this.children.forEach((o) => {
      if (!(typeof o.path > "u")) {
        var s = typeof o.elementTransform < "u" ? o.elementTransform() : null;
        s || (s = Be.fromElement(t, o)), s && s.apply(e), o.path(e), r && (r.closePath = n), s && s.unapply(e);
      }
    }), Reflect.apply(n, e, []), e.clip(), r && (r.beginPath = i, r.closePath = n);
  }
  render(e) {
  }
}
class Lr extends I {
  constructor() {
    super(...arguments), this.type = "filter";
  }
  apply(e, t) {
    var {
      document: r,
      children: i
    } = this, n = t.getBoundingBox(e);
    if (n) {
      var o = 0, s = 0;
      i.forEach((y) => {
        var x = y.extraFilterDistance || 0;
        o = Math.max(o, x), s = Math.max(s, x);
      });
      var u = Math.floor(n.width), l = Math.floor(n.height), c = u + 2 * o, v = l + 2 * s;
      if (!(c < 1 || v < 1)) {
        var f = Math.floor(n.x), h = Math.floor(n.y), d = this.removeStyles(t, Lr.ignoreStyles), g = r.createCanvas(c, v), p = g.getContext("2d");
        r.screen.setDefaults(p), p.translate(-f + o, -h + s), t.render(p), i.forEach((y) => {
          typeof y.apply == "function" && y.apply(p, 0, 0, c, v);
        }), e.drawImage(g, 0, 0, c, v, f - o, h - s, c, v), this.restoreStyles(t, d);
      }
    }
  }
  render(e) {
  }
}
Lr.ignoreStyles = ["filter", "transform", "clip-path"];
class n2 extends I {
  constructor(e, t, r) {
    super(e, t, r), this.type = "feDropShadow", this.addStylesFromStyleDefinition();
  }
  apply(e, t, r, i, n) {
  }
}
class s2 extends I {
  constructor() {
    super(...arguments), this.type = "feMorphology";
  }
  apply(e, t, r, i, n) {
  }
}
class o2 extends I {
  constructor() {
    super(...arguments), this.type = "feComposite";
  }
  apply(e, t, r, i, n) {
  }
}
class u2 extends I {
  constructor(e, t, r) {
    super(e, t, r), this.type = "feGaussianBlur", this.blurRadius = Math.floor(this.getAttribute("stdDeviation").getNumber()), this.extraFilterDistance = this.blurRadius;
  }
  apply(e, t, r, i, n) {
    var {
      document: o,
      blurRadius: s
    } = this, u = o.window ? o.window.document.body : null, l = e.canvas;
    l.id = o.getUniqueId(), u && (l.style.display = "none", u.appendChild(l)), tb(l, t, r, i, n, s), u && u.removeChild(l);
  }
}
class l2 extends I {
  constructor() {
    super(...arguments), this.type = "title";
  }
}
class c2 extends I {
  constructor() {
    super(...arguments), this.type = "desc";
  }
}
var h2 = {
  svg: _t,
  rect: bl,
  circle: Db,
  ellipse: Vb,
  line: kb,
  polyline: xl,
  polygon: Lb,
  path: P,
  pattern: Bb,
  marker: jb,
  defs: Ub,
  linearGradient: Fb,
  radialGradient: Gb,
  stop: zb,
  animate: on,
  animateColor: Hb,
  animateTransform: Yb,
  font: Wb,
  "font-face": Xb,
  "missing-glyph": qb,
  glyph: ml,
  text: Ae,
  tspan: Vr,
  tref: Kb,
  a: Qb,
  textPath: Zb,
  image: e2,
  g: sn,
  symbol: t2,
  style: Tl,
  use: a2,
  mask: kr,
  clipPath: i2,
  filter: Lr,
  feDropShadow: n2,
  feMorphology: s2,
  feComposite: o2,
  feColorMatrix: Ol,
  feGaussianBlur: u2,
  title: l2,
  desc: c2
};
function Io(a, e) {
  var t = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(a);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(a, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function v2(a) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Io(Object(t), !0).forEach(function(r) {
      an(a, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(t)) : Io(Object(t)).forEach(function(r) {
      Object.defineProperty(a, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return a;
}
function f2(a, e) {
  var t = document.createElement("canvas");
  return t.width = a, t.height = e, t;
}
function g2(a) {
  return $i.apply(this, arguments);
}
function $i() {
  return $i = Te(function* (a) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, t = document.createElement("img");
    return e && (t.crossOrigin = "Anonymous"), new Promise((r, i) => {
      t.onload = () => {
        r(t);
      }, t.onerror = (n, o, s, u, l) => {
        i(l);
      }, t.src = a;
    });
  }), $i.apply(this, arguments);
}
class Ce {
  constructor(e) {
    var {
      rootEmSize: t = 12,
      emSize: r = 12,
      createCanvas: i = Ce.createCanvas,
      createImage: n = Ce.createImage,
      anonymousCrossOrigin: o
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.canvg = e, this.definitions = {}, this.styles = {}, this.stylesSpecificity = {}, this.images = [], this.fonts = [], this.emSizeStack = [], this.uniqueId = 0, this.screen = e.screen, this.rootEmSize = t, this.emSize = r, this.createCanvas = i, this.createImage = this.bindCreateImage(n, o), this.screen.wait(this.isImagesLoaded.bind(this)), this.screen.wait(this.isFontsLoaded.bind(this));
  }
  bindCreateImage(e, t) {
    return typeof t == "boolean" ? (r, i) => e(r, typeof i == "boolean" ? i : t) : e;
  }
  get window() {
    return this.screen.window;
  }
  get fetch() {
    return this.screen.fetch;
  }
  get ctx() {
    return this.screen.ctx;
  }
  get emSize() {
    var {
      emSizeStack: e
    } = this;
    return e[e.length - 1];
  }
  set emSize(e) {
    var {
      emSizeStack: t
    } = this;
    t.push(e);
  }
  popEmSize() {
    var {
      emSizeStack: e
    } = this;
    e.pop();
  }
  getUniqueId() {
    return "canvg".concat(++this.uniqueId);
  }
  isImagesLoaded() {
    return this.images.every((e) => e.loaded);
  }
  isFontsLoaded() {
    return this.fonts.every((e) => e.loaded);
  }
  createDocumentElement(e) {
    var t = this.createElement(e.documentElement);
    return t.root = !0, t.addStylesFromStyleDefinition(), this.documentElement = t, t;
  }
  createElement(e) {
    var t = e.nodeName.replace(/^[^:]+:/, ""), r = Ce.elementTypes[t];
    return typeof r < "u" ? new r(this, e) : new Ab(this, e);
  }
  createTextNode(e) {
    return new _b(this, e);
  }
  setViewBox(e) {
    this.screen.setViewBox(v2({
      document: this
    }, e));
  }
}
Ce.createCanvas = f2;
Ce.createImage = g2;
Ce.elementTypes = h2;
function No(a, e) {
  var t = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(a);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(a, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function ke(a) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? No(Object(t), !0).forEach(function(r) {
      an(a, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(t)) : No(Object(t)).forEach(function(r) {
      Object.defineProperty(a, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return a;
}
class bt {
  /**
   * Main constructor.
   * @param ctx - Rendering context.
   * @param svg - SVG Document.
   * @param options - Rendering options.
   */
  constructor(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.parser = new za(r), this.screen = new Dr(e, r), this.options = r;
    var i = new Ce(this, r), n = i.createDocumentElement(t);
    this.document = i, this.documentElement = n;
  }
  /**
   * Create Canvg instance from SVG source string or URL.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  static from(e, t) {
    var r = arguments;
    return Te(function* () {
      var i = r.length > 2 && r[2] !== void 0 ? r[2] : {}, n = new za(i), o = yield n.parse(t);
      return new bt(e, o, i);
    })();
  }
  /**
   * Create Canvg instance from SVG source string.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  static fromString(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = new za(r), n = i.parseFromString(t);
    return new bt(e, n, r);
  }
  /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  fork(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return bt.from(e, t, ke(ke({}, this.options), r));
  }
  /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  forkString(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return bt.fromString(e, t, ke(ke({}, this.options), r));
  }
  /**
   * Document is ready promise.
   * @returns Ready promise.
   */
  ready() {
    return this.screen.ready();
  }
  /**
   * Document is ready value.
   * @returns Is ready or not.
   */
  isReady() {
    return this.screen.isReady();
  }
  /**
   * Render only first frame, ignoring animations and mouse.
   * @param options - Rendering options.
   */
  render() {
    var e = arguments, t = this;
    return Te(function* () {
      var r = e.length > 0 && e[0] !== void 0 ? e[0] : {};
      t.start(ke({
        enableRedraw: !0,
        ignoreAnimation: !0,
        ignoreMouse: !0
      }, r)), yield t.ready(), t.stop();
    })();
  }
  /**
   * Start rendering.
   * @param options - Render options.
   */
  start() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, {
      documentElement: t,
      screen: r,
      options: i
    } = this;
    r.start(t, ke(ke({
      enableRedraw: !0
    }, i), e));
  }
  /**
   * Stop rendering.
   */
  stop() {
    this.screen.stop();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */
  resize(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    this.documentElement.resize(e, t, r);
  }
}
export {
  Qb as AElement,
  Hb as AnimateColorElement,
  on as AnimateElement,
  Yb as AnimateTransformElement,
  he as BoundingBox,
  To as CB1,
  Oo as CB2,
  Eo as CB3,
  So as CB4,
  bt as Canvg,
  Db as CircleElement,
  i2 as ClipPathElement,
  Ub as DefsElement,
  c2 as DescElement,
  Ce as Document,
  I as Element,
  Vb as EllipseElement,
  Ol as FeColorMatrixElement,
  o2 as FeCompositeElement,
  n2 as FeDropShadowElement,
  u2 as FeGaussianBlurElement,
  s2 as FeMorphologyElement,
  Lr as FilterElement,
  J as Font,
  Wb as FontElement,
  Xb as FontFaceElement,
  sn as GElement,
  ml as GlyphElement,
  $l as GradientElement,
  e2 as ImageElement,
  kb as LineElement,
  Fb as LinearGradientElement,
  jb as MarkerElement,
  kr as MaskElement,
  pl as Matrix,
  qb as MissingGlyphElement,
  bb as Mouse,
  nt as PSEUDO_ZERO,
  za as Parser,
  P as PathElement,
  w as PathParser,
  Bb as PatternElement,
  D as Point,
  Lb as PolygonElement,
  xl as PolylineElement,
  O as Property,
  wo as QB1,
  Co as QB2,
  Po as QB3,
  Gb as RadialGradientElement,
  bl as RectElement,
  ze as RenderedElement,
  Ob as Rotate,
  _t as SVGElement,
  r2 as SVGFontLoader,
  Eb as Scale,
  Dr as Screen,
  yl as Skew,
  Sb as SkewX,
  wb as SkewY,
  zb as StopElement,
  Tl as StyleElement,
  t2 as SymbolElement,
  Kb as TRefElement,
  Vr as TSpanElement,
  Ae as TextElement,
  Zb as TextPathElement,
  l2 as TitleElement,
  Be as Transform,
  Tb as Translate,
  Ab as UnknownElement,
  a2 as UseElement,
  mb as ViewPort,
  vt as compressSpaces,
  bt as default,
  yb as getSelectorSpecificity,
  ub as normalizeAttributeName,
  lb as normalizeColor,
  fl as parseExternalUrl,
  R2 as presets,
  ie as toNumbers,
  nb as trimLeft,
  sb as trimRight,
  xo as vectorMagnitude,
  $o as vectorsAngle,
  xi as vectorsRatio
};
//# sourceMappingURL=index.es-BcIsAgCR.mjs.map
